var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { DocumentService } from './../../services/document.service';
import { ChangeDetectorRef, ElementRef } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Http } from '@angular/http';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { MaskPipe } from 'ngx-mask';
import { Modal } from 'ngx-modal';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../environments/environment';
import { ApiUrlConstants } from '../../../common/constants/api.constants';
import { AccessLevel } from '../../../common/enums/access-level.enum';
import { Permission } from '../../../common/enums/permission.enum';
import { CurrencyTransformPipe } from '../../../common/pipes/currency-format.pipe';
import { GroupByPipe } from '../../../common/pipes/group-by.pipe';
import { TitleCasePipe } from '../../../common/pipes/title-case.pipe';
import { TranslateKey } from '../../../common/pipes/translate-key.pipe';
import { CacheKey } from '../../../shared/constants/cachekey.constants';
import { ContactType } from '../../../shared/enums/contact-type.enum';
import { CacheService } from '../../../shared/services/cache.service';
import { CommonService } from '../../../shared/services/common.service';
import { MemberDisplayPriceConfigService } from '../../../shared/services/member-display-price-config.service';
import { MessageService } from '../../../shared/services/message.service';
import { CustomValidators } from '../../../shared/Utils/custom-validator';
import { Utils } from '../../../shared/Utils/utils';
import { Constants, DelivaryOptionType, MemberType, ProductSource } from '../../common/constants';
import { DeliveryPreference, MemberLevel, OrderSources, OrderType, PurchaseFlow, RowStatus } from '../../common/enumerations';
import { DateConstants } from '../../constants/date.constants';
import { MemberTypeId } from '../../constants/member-type-id.enum';
import { PaymentConstants } from '../../constants/payment.constants';
import { PhoneCodesConstants } from '../../constants/phone-codes.constant';
import { PortalDisplayPage } from '../../constants/portal-display-page.enum';
import { EcheckPhoneNumberValidation } from '../../directive/echeck-phone-validation';
import { AccountType } from '../../enums/echeck-accounttypes.enum';
import { EcheckPortalTypes } from '../../enums/echeck-portal-types.enum';
import { ImageType } from '../../enums/image-type.enum';
import { MemberOrderType } from '../../enums/member-order-type.enum';
import { MemberStatus } from '../../enums/member-status.enum';
import { MemberTitleExtEnums } from '../../enums/member-title.enum';
import { MemberTypeEnum } from '../../enums/member-type.enum';
import { MessageTypeEnum } from '../../enums/message-type.enums';
import { NotificationType } from '../../enums/notification-types.enum';
import { AddressType, OrderSourceType, OrderStatus, PaymentMethodTypes, PaymentType, PosPaymentMethodsEnum, PriceType, ProductWeightMetric, PurchaseFlows, PurchaseFlowType, ShippingOrderType, ShippingType, Source } from '../../enums/order-source-type';
import { MemberActivityLogType } from '../../../shared/common/enumerations';
import { OrderSourceTypes, OrderSourceValue } from '../../enums/order-source.enum';
import { PaymentCardTypes } from '../../enums/payment-card-types.enum';
import { PaymentStatus } from '../../enums/payment-status.enum';
import { PosPaymentGroupEnum } from '../../enums/pos-payment-group.enum';
import { ProductMetatDataValue } from '../../enums/product-metadata.enum';
import { SelectEnum } from '../../enums/selection.enum';
import { ShippingMemberTitle } from '../../enums/shipping-member-title.enum';
import { ShippingMemberType } from '../../enums/shipping-member-type.enum';
import { ValueType } from '../../enums/value-type.enum';
import { TaxType } from '../../interface/tax-type.interface';
import { OrderInfoTab } from '../../models/order-info-tab-model';
import { PaymentComponentSettings } from '../../models/payments/payment.model';
import { AppConfigService } from '../../services/app-config.service';
import { CheckoutConfigService } from '../../services/checkout-config.service';
import { CustomerService } from '../../services/customer.service';
import { EcheckService } from '../../services/echeck.service';
import { OrderService } from '../../services/order.service';
import { PayvisionService } from '../../services/payvision.service';
import { DisplaySectionId, Portal } from '../../enums/document-library-member-id.enum';
import { ResponseStatus } from '../../constants/response-status-constants';
import { PriceTier } from '../../constants/pricetier.constants';
import { ImpersonateUserConstants } from '../../constants/impersonate-user.constants';
import { AccountRestrictionStatus } from '../../../common/enums/account-restricted.enum';
import { CommonConstant } from '../../../shared/constants/common.constants';
import { ConfigurationService } from '../../services/configuration.service';
import { BonusConstants } from '../../constants/bonus-status.constants';
import { PaymentProcessorAlias } from '../../enums/payment-processor-alias.enum';
import { MULTI_SELECT_CONFIG_INTEGRATED_TERMINAL } from '../../../shared/selectize/selectize.config';
import { transactional } from '../../enums/sponsor-transactional-source-type.enum';
var PosOrderPromotionComponent = /** @class */ (function () {
    function PosOrderPromotionComponent(_orderService, _echeckService, _sanitizer, _formbuilder, _http, _commonService, _translatePipe, _translateKey, _currencyPipe, _cacheService, _customerService, messageService, _payvisionService, _titleCase, _maskPipe, _checkoutConfigService, _configurationService, _memberDisplayPriceConfigService, chRef, _appConfigService, _translateService, _documentService, _groupByPipe, document) {
        var _this = this;
        this._orderService = _orderService;
        this._echeckService = _echeckService;
        this._sanitizer = _sanitizer;
        this._formbuilder = _formbuilder;
        this._http = _http;
        this._commonService = _commonService;
        this._translatePipe = _translatePipe;
        this._translateKey = _translateKey;
        this._currencyPipe = _currencyPipe;
        this._cacheService = _cacheService;
        this._customerService = _customerService;
        this.messageService = messageService;
        this._payvisionService = _payvisionService;
        this._titleCase = _titleCase;
        this._maskPipe = _maskPipe;
        this._checkoutConfigService = _checkoutConfigService;
        this._configurationService = _configurationService;
        this._memberDisplayPriceConfigService = _memberDisplayPriceConfigService;
        this.chRef = chRef;
        this._appConfigService = _appConfigService;
        this._translateService = _translateService;
        this._documentService = _documentService;
        this._groupByPipe = _groupByPipe;
        this.document = document;
        this.momentConstructor = moment.default || moment;
        this.terminalPaymentStatusCheckPollingCount = environment.terminalPaymentStatusCheckPollingCount;
        this.memberTypeEnum = MemberTypeEnum;
        this.orderType = OrderType;
        this.items = [];
        this.countries = [];
        this.states = [];
        this.memberSearchSubmitted = false;
        this.posLocations = [];
        this.shipMethodValidation = '';
        this.subTotal = 0.0;
        this.retailSubTotal = 0.0;
        this.totalCommissionableVolume = 0;
        this.selectedIsoCountryCode = '';
        this.selectedCountryCodeTwo = '';
        this.paymentBillingAddress = {};
        this.isSubmitted = false;
        this.products = [];
        this.posRetailMemberEligibleCountries = [];
        this.orderSubmitted = false;
        this.taxableAmount = 0;
        this.shipMethod = {};
        this.languageCode = 'en-US';
        this.languageShortCode = 'en';
        this.payByLinkLanguageCulture = 'en-US';
        this.payByLinkLanguageCode = 'en';
        this.pollCount = 0;
        this.maxPollCount = 15;
        this.importFeeValue = 0;
        this.importFeeEnabled = false;
        this.selectEnum = SelectEnum;
        this.posPaymentGroupEnum = PosPaymentGroupEnum;
        this.isOverrideMinimumLimit = false;
        this.taxCalculationStatus = true;
        this.isMemberFboUpgraded = false;
        this.upgradeFboLimitExceeded = false;
        this.isFBOValidationPending = false;
        this.isMemberEligibleToPlaceOrder = false;
        this.handlingCharges = 0;
        this.overrideMinimumLimitIsEnabled = false;
        this.paymentComponentSettings = new PaymentComponentSettings();
        this.orderSession = {};
        this.FBOPOSOrderPermissions = [
            Permission.POS_ORDER_CREATE,
            Permission.POS_ORDER_MANAGE
        ];
        this.shoppingCartCount = 0;
        this.isMemberHasAccessToOrder = true;
        this.restrictedDays = 0;
        this.cartLimitExceed = false;
        this.cartLimitNotReach = false;
        this.paymentTypeEnum = PaymentType;
        this.bankDetailsList = [];
        this.isQuantityUpdate = false;
        this.previousQuantity = 1;
        this.splitPayments = [];
        this.posPaymentMethods = [];
        this.posPaymentGroups = [];
        this.isEnterPaymentDetailsEnabled = false;
        this.isPaymentBlockEnabled = false;
        this.placeOrderClicked = false;
        this.posPaymetMethodsEnum = PosPaymentMethodsEnum;
        this.taxType = TaxType;
        this.integratedPaymentMethods = [];
        this.paymentMethodTypes = PaymentMethodTypes;
        this.isPayByLinkValid = true;
        this.acceptPaymentDocuments = null;
        this.enableBackDateOrder = false;
        this.operatingCountry = [];
        this.overrideMinimumOrderLimitPermissions = [
            Permission.OVERRIDE_MINIMUM_LIMIT
        ];
        this.hasMinimumOverrideLimit = false;
        this.isWhosaleCheckNotCalculated = false;
        this.accountViewPermission = false;
        this.accountRestrictionPermission = [Permission.ACCOUNT_RESTRICTED_VIEW, Permission.ACCOUNT_RESTRICTED_MANAGE];
        this.depsoitFeeProductsInfo = [];
        this.productAssociationInfo = [];
        this.dropShipDeliveryOptionDisabled = false;
        this.shippingDeliveryOptionAvailable = false;
        this.pickupDeliveryOptionAvailable = false;
        this.disableQty = false;
        this.isNexioPayment = false;
        this.showNexioPayment = false;
        this.enableNexioPaymentForPickUpCenter = environment.enableNexioPaymentForPickUpCenter;
        this.isSingleDistributionCenter = false;
        this.terminalOptions = [];
        this.preselectTerminal = [];
        this.isTerminalSelected = false;
        this.displayTryAgain = false;
        this.terminalTransactionCancelButton = true;
        this.isStoreDiscounPercentagetConfigured = false;
        this.isNewCardClicked = false;
        this.ignoreAddNewCards = false;
        // endregion
        // region #Start Products Section
        /**
        * @param  {any} data
        * @returns SafeHtml
        */
        this.autocompleListFormatter = function (data) {
            var html = "<span>" + data.itemNumber + " - " + _this._titleCase.transform(data.displayName ? data.displayName : data.name) + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        /**
         * Auto Complete Product Search
         */
        this.observableSource = function (keyword, fullSearch) {
            var fpc5PercentEnabled = false;
            if (_this.memberInfo && _this.storeInfo) {
                if (keyword && keyword.length > 1) {
                    if (keyword.indexOf('#') == 0) {
                        keyword = keyword.replace(/#/, '');
                    }
                    if (_this.appConfig && _this.appConfig.fpc5PercentEnabled) {
                        fpc5PercentEnabled = true;
                    }
                    var wholesaleQualified = _this.memberInfo && _this.memberInfo.wholeSaleQualified ? true : false;
                    if (wholesaleQualified == null) {
                        wholesaleQualified = false;
                    }
                    var optin = _this.memberInfo && _this.memberInfo.optin ? _this.memberInfo.optin : false;
                    var memberTitleId = _this.memberInfo ? _this._orderService.getMemberTitleId(_this.memberInfo) : MemberLevel.RETAIL;
                    _this.purchaseFlowType = _this._commonService.getPurchaseFlowType(_this.memberTypeId, wholesaleQualified, fpc5PercentEnabled, false, memberTitleId);
                    // HARD_DOWNGRADE CHECK FOR FPC USERS
                    if (_this.memberInfo) {
                        memberTitleId = _this._orderService.getDowngradeTitleID(_this.memberInfo.memberTypeId, _this.memberInfo.memberTitleId);
                    }
                    var _itemNumberURL = environment.productsUrl + '/stores/' + _this.storeInfo.id + '/customerservice/products' +
                        '?languageCode=' + _this.storeDefaultLanguage + '&memberTitleId=' + memberTitleId +
                        '&countryCode=' + _this.selectedIsoCountryCode + '&pageSize=10&pageNumber=1&wholesaleQualified='
                        + wholesaleQualified + '&productWildSearch=' + keyword.trim() + '&source=' + ProductSource.ADMINISTRATION +
                        '&optin=' + optin + '&taxInclusive=' + _this.storeInfo.taxInclusive;
                    if (fullSearch) {
                        _itemNumberURL += '&searchType=FULL';
                    }
                    return _this._http.get(decodeURIComponent(encodeURIComponent(_itemNumberURL))).map(function (res) {
                        var results = res.json();
                        if (results && results.length > 0) {
                            return results;
                        }
                        else {
                            return [];
                        }
                    });
                }
                else {
                    return Observable.of([]);
                }
            }
            else {
                var notification = void 0;
                if (!_this.memberInfo) {
                    notification = _this._translatePipe.get('order.Member Details are Mandatory');
                }
                else if (!_this.storeInfo && _this.showPOSOrderValidation) {
                    notification = _this._translatePipe.get('order.Member not eligible for POS orders');
                }
                else if (!_this.storeInfo) {
                    notification = _this._translatePipe.get('order.Please select POS Location');
                }
                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            }
        };
        this.setPaymentMethod = function (value) {
            _this.posOrderFormGroup.controls['paymentSelector'].setValue(value.toString());
            _this.onPaymentMethodChnage();
        };
        /**
         * Checks Whether Order Can be BackDated or Not
         * @param timeZoneOffset
         */
        this.isBackDateOrderAvailable = function (timeZoneOffset, operatingCountry) {
            _this.enableBackDateOrder = false;
            var processingMonth;
            var processingYear;
            var date = new Date();
            if (date.getMonth() === 0) {
                processingMonth = 12;
                processingYear = date.getFullYear() - 1;
            }
            else {
                processingMonth = date.getMonth();
                processingYear = date.getFullYear();
            }
            if (operatingCountry && processingMonth && processingYear) {
                _this._customerService.getBonusRunStatusDetails(operatingCountry, processingMonth, processingYear).subscribe(function (response) {
                    if (response && response.success && response.bonusStatus && response.validations.length === 0) {
                        if ((response.bonusStatus.toLowerCase() === BonusConstants.Open.toLowerCase())
                            || (response.bonusStatus.toLowerCase() === BonusConstants.Restricted.toLowerCase())) {
                            _this._orderService.isBackDateOrderAllowed(timeZoneOffset, _this.countryCode).subscribe(function (response) {
                                if (response && response.success) {
                                    _this.enableBackDateOrder = true;
                                }
                                else {
                                    _this.enableBackDateOrder = false;
                                }
                            }, function (error) {
                                _this.enableBackDateOrder = false;
                            });
                        }
                    }
                }, function (error) {
                    _this.enableBackDateOrder = false;
                });
            }
        };
    }
    PosOrderPromotionComponent.prototype.ngOnInit = function () {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.retrieveOrderInfoSession();
        this.businessEntityId = this.orderSession && this.orderSession.businessEntityId ? this.orderSession.businessEntityId : null;
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this.getDistributorInfoFromStorage();
        this.buildForm();
        this.getOperatingCountries();
        if (this.orderSession && this.orderSession.paymentComponentSettings && this.orderSession.paymentComponentSettings.webOrderId) {
            var country = this.orderSession.paymentComponentSettings.isoCountryCode;
            var webOrderId = this.orderSession.paymentComponentSettings.webOrderId;
            this.clearAllTheForms(true);
            this.openOrderViewTab(webOrderId, country);
        }
        this.getAllPermissions();
        //this.getPosMemberEligible();
        this.getCountries();
        this.getStates();
        this.orderSession != null && this.orderSession.isOverrideMinimumLimit === true ? this.isOverrideMinimumLimit = true : this.isOverrideMinimumLimit = false;
        if (this.orderSession) {
            this.minMaxPriceValidation = this.orderSession.minMaxPriceValidation;
        }
        this.isOrderSessionInfo = this.orderSession ? true : false;
        this.selectedPaymentMethod = PaymentMethodTypes.Credit_Card.toString();
        // this.orderFromLookup || this.isOrderSessionInfo
        //     ? (document.getElementById('country') ? document.getElementById('country').focus() : null)
        //     : (document.getElementById('memberInfo') ? document.getElementById('memberInfo').focus() : null);
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        if (this.userInfo && !this.orderSession) {
            this.getPosLocations();
        }
        this.accountTypes = [AccountType.Checking, AccountType.Savings];
        this.accountViewPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.accountRestrictionPermission[0] + ']'), AccessLevel.Customer_Service);
    };
    PosOrderPromotionComponent.prototype.retrieveOrderInfoSession = function () {
        try {
            this.orderSession = (sessionStorage.getItem(CacheKey.OrderInfo) && (sessionStorage.getItem(CacheKey.posOrderPaymentStatus)) ? (sessionStorage.getItem(CacheKey.posOrderPaymentStatus).toUpperCase() === PaymentStatus.SUCCESS ||
                sessionStorage.getItem(CacheKey.posOrderPaymentStatus).toUpperCase() === PaymentStatus.FAILED || sessionStorage.getItem(CacheKey.posOrderPaymentStatus).toUpperCase() === PaymentStatus.CANCEL || sessionStorage.getItem(CacheKey.posOrderPaymentStatus).toUpperCase() === PaymentStatus.CANCELLED) : false) ? JSON.parse(sessionStorage.getItem(CacheKey.OrderInfo)) : null;
        }
        catch (error) {
            console.error(error);
            sessionStorage.removeItem(CacheKey.OrderInfo);
            sessionStorage.removeItem(CacheKey.posOrderPaymentStatus);
        }
    };
    // getting Pos Locations from UserInfo
    PosOrderPromotionComponent.prototype.getPosLocations = function () {
        var _this = this;
        this.isWhosaleCheckNotCalculated = false;
        var posLocationID = [];
        if (this.userInfo && this.userInfo.hasSystemRole) {
            this._customerService.getAllPosLocations().subscribe(function (response) {
                _this.posLocations = response;
                _this.assignDefaultLocation();
            });
        }
        else {
            if (this.userInfo && this.userInfo.allowedPosLocations.length) {
                this.userInfo.allowedPosLocations.forEach(function (item) {
                    posLocationID.push(item.posLocations);
                });
            }
            this._customerService.getPosLocations(posLocationID).subscribe(function (response) {
                _this.posLocations = response;
                _this.assignDefaultLocation();
            });
        }
    };
    PosOrderPromotionComponent.prototype.getDistributorInfoFromStorage = function () {
        this.CreatePOSOrderInfo = this._cacheService.get('CreatePOSOrderInfo');
        this._cacheService.remove('CreatePOSOrderInfo');
        if (this.CreatePOSOrderInfo) {
            if (this.CreatePOSOrderInfo.distributorId) {
                this.orderFromLookup = true;
            }
            else {
                this.orderFromLookup = false;
            }
            this.fboid = this.CreatePOSOrderInfo.distributorId;
        }
    };
    PosOrderPromotionComponent.prototype.assignDefaultLocation = function () {
        var selectedPOSLocation = sessionStorage.getItem(CacheKey.SelectedPOSLocation);
        if (this.posLocations && this.posLocations.length && this.posLocations.length > 1) {
            if ((this.orderSession && this.orderSession.posLocation) || selectedPOSLocation) {
                this.posOrderFormGroup.controls['posLocation'].setValue(selectedPOSLocation || this.orderSession.posLocation);
                this.changePosLocation(selectedPOSLocation || this.orderSession.posLocation);
            }
            else {
                this.posOrderFormGroup.controls['posLocation'].setValue(0);
            }
        }
        else if (this.posLocations && this.posLocations.length) {
            this.posOrderFormGroup.controls['posLocation'].setValue(this.posLocations[0].id);
            this.posOrderFormGroup.controls['posLocation'].updateValueAndValidity();
            this.isSingleDistributionCenter = true;
            this.changePosLocation(this.posLocations[0].id);
        }
    };
    //    getPosMemberEligible(){
    //     this._commonService.getPosMembrOrderElible().subscribe((response: any[]) => {
    //         if (response) {
    //            this.posRetailMemberEligibleCountries=response;
    //         }
    //     });
    //    }
    PosOrderPromotionComponent.prototype.getFormControls = function () {
        var items = this.posOrderFormGroup.get('items');
        return items.controls;
    };
    /**
     * @description This method used to get all permissions
     * getAllPermissions()
     * @memberof OrderPromotionComponent
    */
    PosOrderPromotionComponent.prototype.getAllPermissions = function () {
        this.hasPOSOrderPermissions = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBOPOSOrderPermissions + ']'), AccessLevel.Customer_Service);
        this.hasMinimumOverrideLimit = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.overrideMinimumOrderLimitPermissions + ']'), AccessLevel.Customer_Service);
    };
    /**
     * build Form
     */
    PosOrderPromotionComponent.prototype.buildForm = function () {
        this.posOrderFormGroup = this._formbuilder.group({
            orderType: this.orderType.POS,
            memberInfo: ['', [Validators.required, Utils.noEmptyString, Utils.searchByMemberValidation]],
            items: this._formbuilder.array(this.items),
            shipMethodId: ['', [Validators.required]],
            itemSearch: [''],
            itemLevelSearch: [''],
            paymentInstrumentId: [''],
            paymentSelector: [],
            saveForFutureUse: [false],
            language: [],
            backDateOrder: [false],
            posLocation: ['', [Validators.required]]
        });
        if (this.orderSession && this.orderSession.splitPayments
            && this.orderSession.splitPayments.length > 0) {
            this.splitPayments = this.orderSession.splitPayments;
            this.posOrderFormGroup.controls['paymentSelector'].setValue('4');
        }
    };
    PosOrderPromotionComponent.prototype.buildPaymentForm = function () {
        var _this = this;
        this.buildSplitPaymentForm();
        this.buildExternalPaymentForm();
        this.buildPayByLinkForm();
        this.createPaymentMethodTypeForm();
        if (this.posPaymentGroups.find(function (paymentGroup) { return paymentGroup.id === _this.posPaymentGroupEnum.External_Payment; })) {
            this.posOrderFormGroup.controls['paymentSelector'].setValue(this.posPaymentGroupEnum.External_Payment);
            this.posOrderFormGroup.controls['paymentSelector'].updateValueAndValidity();
            this.onPaymentMethodGroupChange(this.posPaymentGroupEnum.External_Payment);
        }
        else if (this.posPaymentGroups.find(function (paymentGroup) { return paymentGroup.id === _this.posPaymentGroupEnum.Integrated_Payments; })) {
            this.posOrderFormGroup.controls['paymentSelector'].setValue(this.posPaymentGroupEnum.Integrated_Payments);
            this.posOrderFormGroup.controls['paymentSelector'].updateValueAndValidity();
            this.balanceOrderTotal = 0;
            this.onPaymentMethodGroupChange(this.posPaymentGroupEnum.Integrated_Payments);
        }
        else if (this.posPaymentGroups.find(function (paymentGroup) { return paymentGroup.id === _this.posPaymentGroupEnum.Split_Payment; })) {
            this.posOrderFormGroup.controls['paymentSelector'].setValue(this.posPaymentGroupEnum.Split_Payment);
            this.posOrderFormGroup.controls['paymentSelector'].updateValueAndValidity();
            this.onPaymentMethodGroupChange(this.posPaymentGroupEnum.Split_Payment);
        }
        // let payments:any = this.paymentForm.get('payments') as FormArray;
        // if (this.orderSession
        //     && this.orderSession.splitPayments && this.orderSession.splitPayments.length > 0) {
        //     this.balanceOrderTotal= this.orderSession.orderTotal;
        //     this.paymentComponentSettings= this.orderSession.paymentComponentSettings;
        //     this.orderSession.splitPayments.forEach(x => {
        //         if (x) {
        //             payments.controls[x.index].controls['paymentType'].setValue(x.paymentType);
        //             payments.controls[x.index].controls['amount'].setValue(x.amount);
        //             payments.controls[x.index].controls['paymentType'].updateValueAndValidity();
        //             payments.controls[x.index].controls['amount'].updateValueAndValidity();
        //             this.balanceOrderTotal = this.balanceOrderTotal - Number(payments.controls[x.index].controls['amount'].value);
        //         }
        //     });
        // }
    };
    PosOrderPromotionComponent.prototype.buildExternalPaymentForm = function () {
        var _this = this;
        this.externalPaymentForm = this._formbuilder.group({ payments: this._formbuilder.array([]) });
        var payments = this.externalPaymentForm.get('payments');
        if (this.posPaymentMethods) {
            this.posPaymentMethods.forEach(function (paymentMethod) {
                if (paymentMethod.paymentMethodsModel.paymentGroupID === _this.posPaymentGroupEnum.External_Payment) {
                    var paymentFormGroup = _this._formbuilder.group({
                        paymentMethodId: [''],
                        paymentStatus: [''],
                        amount: [''],
                        paymentNote: [''],
                        paymentCheckNumber: [''],
                    });
                    payments.push(paymentFormGroup);
                }
            });
        }
        if (this.posPaymentGroups && this.posPaymentGroups.find(function (paymentGroup) { return paymentGroup.id === _this.posPaymentGroupEnum.External_Payment; })) {
            if (payments.length > 0) {
                payments.controls[0].controls['paymentMethodId'].setValue(this.getPaymentMethodId(this.posPaymentGroupEnum.External_Payment, 0));
                payments.controls[0].controls['amount'].setValidators([Validators.required]);
                payments.controls[0].updateValueAndValidity();
            }
        }
    };
    PosOrderPromotionComponent.prototype.getMemberBonusInfo = function () {
        var _this = this;
        if (this.memberInfo && this.memberInfo.memberId) {
            this._customerService.getMemberBankDetails(this.memberInfo.memberId).subscribe(function (response) {
                if (response) {
                    _this.memberBonusInfo = response;
                }
            });
        }
    };
    /**
     * @description Creating the delivery options form
     * @memberof PaymentComponent
     */
    PosOrderPromotionComponent.prototype.createPaymentMethodTypeForm = function () {
        this.paymentMethodTypeForm = this._formbuilder.group({
            preselectTerminal: '',
            paymentMethodType: ['']
        });
    };
    PosOrderPromotionComponent.prototype.clearPaymentMethodTypeFormForm = function () {
        this.paymentMethodTypeForm.reset({
            preselectTerminal: '',
            paymentMethodType: ''
        });
    };
    PosOrderPromotionComponent.prototype.buildSplitPaymentForm = function () {
        this.splitPaymentForm = this._formbuilder.group({ payments: this._formbuilder.array([]) });
        var payments = this.splitPaymentForm.get('payments');
        payments.push(this.getPaymentFormGroup());
    };
    PosOrderPromotionComponent.prototype.getPaymentFormGroup = function () {
        var paymentFormGroup = this._formbuilder.group({
            paymentMethodId: [''],
            paymentStatus: [''],
            amount: [''],
            paymentNote: [''],
            paymentCheckNumber: [''],
        });
        return paymentFormGroup;
    };
    PosOrderPromotionComponent.prototype.addNewSplitPaymentGroup = function () {
        var payments = this.splitPaymentForm.get('payments');
        if (payments.length < 5) {
            payments.push(this.getPaymentFormGroup());
        }
    };
    PosOrderPromotionComponent.prototype.removeSplitPaymentGroup = function () {
        var payments = this.splitPaymentForm.get('payments');
        if (payments.length !== 1 && payments.controls[payments.length - 1].controls['amount'].value == '') {
            payments.removeAt(payments.length - 1);
        }
    };
    PosOrderPromotionComponent.prototype.getPaymentMethodName = function (groupId, index) {
        var payments = this.posPaymentMethods.filter(function (paymentMethod) { return paymentMethod.paymentMethodsModel.paymentGroupID === groupId; });
        if (payments && payments.length > 0) {
            return payments[index].paymentMethodsModel.paymentMethodName;
        }
        else {
            return "";
        }
    };
    PosOrderPromotionComponent.prototype.getPaymentMethodId = function (groupId, index) {
        var payments = this.posPaymentMethods.filter(function (paymentMethod) { return paymentMethod.paymentMethodsModel.paymentGroupID === groupId; });
        if (payments && payments.length > 0) {
            return payments[index].paymentMethodsModel.paymentMethodId;
        }
        else {
            return '';
        }
    };
    PosOrderPromotionComponent.prototype.paymentTypeChange = function (value, index) {
        var payments = this.paymentForm.get('payments');
        var paymentModel = {
            paymentType: payments.controls[index].controls['paymentType'].value,
            amount: payments.controls[index].controls['amount'].value,
            index: index
        };
        this.balanceOrderTotal = this.balanceOrderTotal - Number(payments.controls[index].controls['amount'].value);
        this.splitPayments.push(paymentModel);
        if (value === PaymentMethodTypes.Credit_Card) {
            this.selectSavedCard(null, true, Number(payments.controls[index].controls['amount'].value));
        }
    };
    PosOrderPromotionComponent.prototype.selectPaymentMethodType = function (paymentMethod) {
        var _this = this;
        this.isTerminalSelected = false;
        if (paymentMethod && paymentMethod.paymentMethodsModel && paymentMethod.paymentMethodsModel.paymentMethodId === PaymentType.INTEGRATED_TERMINAL) {
            this.isTerminalSelected = true;
            if (!this.paymentMethodTypeForm.controls['preselectTerminal'].value || !this.terminalDetails) {
                var terminalDetails = this._cacheService.get(CacheKey.SelectedTerminalDetails);
                this.paymentMethodTypeForm.controls['preselectTerminal'].setValue(terminalDetails ? terminalDetails : null);
                this.terminalSelection(terminalDetails);
            }
        }
        if (paymentMethod && paymentMethod.paymentMethodsModel && paymentMethod.paymentMethodsModel.paymentMethodId === this.paymentTypeEnum.Pay_By_Link) {
            var email = this.memberInfo ? this.memberInfo.email : '';
            if (email != null) {
                this.emailForm.controls['payByLinkEmail'].setValue(email);
            }
            else {
                this.emailForm.controls['payByLinkEmail'].setValue('');
            }
            this.emailForm.controls['payByLinkEmail'].updateValueAndValidity();
            if (this.emailForm.controls['payByLinkEmail'].value !== '') {
                this.isPayByLinkValid = true;
            }
            else {
                this.isPayByLinkValid = false;
            }
        }
        else if (this.enableNexioPaymentForPickUpCenter && paymentMethod.paymentMethodsModel.paymentMethodId === this.paymentTypeEnum.Nexio_Credit_Card) {
            this.isPayByLinkValid = true;
            if (this.paymentComponentSettings.savedCards && this.paymentComponentSettings.savedCards.length > 0) {
                var isDefaultCard_1 = false;
                var isCardAdded_1 = false;
                this.paymentComponentSettings.savedCards.forEach(function (card) {
                    if (card.expired === false && isDefaultCard_1 === false) {
                        isDefaultCard_1 = true;
                        isCardAdded_1 = true;
                        _this.posOrderFormGroup.controls['paymentInstrumentId'].setValue(card.id);
                        _this.selectSavedCard(card);
                    }
                });
                if (!isCardAdded_1) {
                    this.posOrderFormGroup.controls['paymentInstrumentId'].setValue('');
                    this.posOrderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
                    this.selectSavedCard(null, true);
                }
            }
            else {
                this.selectSavedCard(null, true);
            }
        }
        else {
            this.isPayByLinkValid = true;
        }
        if (paymentMethod && paymentMethod.paymentMethodsModel && paymentMethod.paymentMethodsModel.paymentMethodId === this.paymentTypeEnum.Direct_Debit) {
            this.checkPaymentDocumentsSelected();
        }
        else {
            this.agreementCheckError = false;
        }
    };
    /**
     * place POS order
     */
    PosOrderPromotionComponent.prototype.createPosOrder = function () {
        var items = this.posOrderFormGroup.get('items');
        var productids = [];
        items.value.forEach(function (element) {
            productids.push(element.productId);
        });
        this.posStockAvailabilityCheck(productids, +this.posOrderFormGroup.controls['posLocation'].value, true);
        if (this.isOverrideMinimumLimit === true) {
            this.saveMemberActivityLog(this.memberInfo.memberId, MemberActivityLogType.Override_Minimum_Limit);
        }
    };
    PosOrderPromotionComponent.prototype.createPosOrderUpdate = function () {
        var paymentData;
        if (+this.posOrderFormGroup.controls['paymentSelector'].value === this.posPaymentGroupEnum.External_Payment) {
            var externalPaymentData = this.getSelectedExternalPaymentData();
            paymentData = externalPaymentData;
            if (+externalPaymentData.amount !== this.calculateOrderTotal() && +this.posOrderFormGroup.controls['paymentSelector'].value === this.posPaymentGroupEnum.External_Payment) {
                var errorMessage = this._translatePipe.get('Entered amount is not matching with Order Total');
                this._commonService.createNotification('', errorMessage.value, NotificationType.ERROR);
            }
            else {
                this.proceedPlaceOrder(paymentData);
            }
        }
        if (+this.posOrderFormGroup.controls['paymentSelector'].value === this.posPaymentGroupEnum.Integrated_Payments) {
            if (this.paymentMethodTypeForm.controls['paymentMethodType'].value == this.paymentTypeEnum.Pay_By_Link) {
                var initiatePaymentRequest = this.prepareInitiatePaymentRequest();
                this.initiatePayment(initiatePaymentRequest);
            }
            else if (this.paymentMethodTypeForm.controls['paymentMethodType'].value == this.paymentTypeEnum.Saved_Cards ||
                (this.enableNexioPaymentForPickUpCenter && this.paymentMethodTypeForm.controls['paymentMethodType'].value == this.paymentTypeEnum.Nexio_Credit_Card)) {
                var creditCardPaymentData = this.getSelectedCreditCardData();
                paymentData = creditCardPaymentData;
                this.proceedPlaceOrder(paymentData);
            }
            else if (this.paymentMethodTypeForm.controls['paymentMethodType'].value == PaymentType.INTEGRATED_TERMINAL) {
                this.prepareIntegratedPaymentData();
            }
            if (this.paymentMethodTypeForm.controls['paymentMethodType'].value == this.paymentTypeEnum.Direct_Debit) {
                var creditCardPaymentData = this.getIntegratedPaymentData();
                paymentData = creditCardPaymentData;
                this.proceedPlaceOrder(paymentData);
            }
        }
    };
    PosOrderPromotionComponent.prototype.getIntegratedPaymentData = function () {
        var data = {};
        data = {
            paymentGroupId: this.posPaymentGroupEnum.Integrated_Payments,
            paymentMethodId: this.paymentMethodTypeForm.controls['paymentMethodType'].value,
            paymentMethodName: PosPaymentMethodsEnum[+this.paymentMethodTypeForm.controls['paymentMethodType'].value],
            paymentMethodType: PosPaymentMethodsEnum[+this.paymentMethodTypeForm.controls['paymentMethodType'].value],
            paymentStatus: '',
            paymentNote: '',
            paymentCheckNumber: '',
            amount: ''
        };
        return data;
    };
    PosOrderPromotionComponent.prototype.prepareInitiatePaymentRequest = function () {
        var orderDescription = this.products && this.products &&
            this.products.length > 0 ? this.products[0].name : 'order description';
        var initiatePaymentRequest = {
            email: this.emailForm.value.payByLinkEmail,
            paymentLinkEmail: this.emailForm.value.payByLinkEmail,
            firstName: this.memberInfo.firstName,
            lastName: this.memberInfo.lastName,
            languageCode: this.payByLinkLanguageCode,
            languageCulture: this._commonService.getLanguageCulture(this.storeInfo, this.countryCode, this.memberInfo),
            customerId: this.memberInfo.memberId,
            paymentMethodType: PaymentMethodTypes.Pay_By_Link,
            countryCode: this.selectedIsoCountryCode,
            amount: {
                currency: this.storeInfo.currencyCode,
                value: this.calculateOrderTotal()
            },
            distributorId: this.memberInfo.fboId,
            orderTypeId: this.orderType.POS,
            webOrderID: this.paymentComponentSettings.webOrderId,
            orderReferenceId: this.paymentComponentSettings.orderReferenceId,
            storeID: this.storeInfo.id,
            orderSource: OrderSources.POS,
            description: orderDescription,
            shippingAddress: this.getPayByLinkShippingAddress()
        };
        return initiatePaymentRequest;
    };
    PosOrderPromotionComponent.prototype.getPayByLinkShippingAddress = function () {
        var address = {
            addressLine1: this.storeInfo.warehouseAddress.addressLine1 ? this.storeInfo.warehouseAddress.addressLine1 : '',
            addressLine2: this.storeInfo.warehouseAddress.addressLine2 ? this.storeInfo.warehouseAddress.addressLine2 : '',
            city: this.storeInfo.warehouseAddress.city ? this.storeInfo.warehouseAddress.city : '',
            countryCode: this.storeInfo.warehouseAddress.countryCode || this.selectedIsoCountryCode,
            state: this.storeInfo.warehouseAddress.stateCode ? this.storeInfo.warehouseAddress.stateCode : '',
            zip: this.storeInfo.warehouseAddress.zipCode ? this.storeInfo.warehouseAddress.zipCode : ''
        };
        return address;
    };
    PosOrderPromotionComponent.prototype.initiatePayment = function (initiatePaymentRequest) {
        var _this = this;
        this._payvisionService.initiatePayment(initiatePaymentRequest)
            .subscribe(function (response) {
            if (response && response.authorizeResponse && response.authorizeResponse.paymentStatus === PaymentStatus.PEND) {
                _this.openOrderViewTab(response.authorizeResponse.orderID);
                _this.clearAllTheForms(true);
            }
        }, function (error) {
            _this.placeOrderClicked = false;
            var errorMessage = _this._translatePipe.get('common.Sorry, Something Went Wrong: Please try again later.');
            _this._commonService.createNotification('', errorMessage.value, NotificationType.ERROR);
        });
    };
    PosOrderPromotionComponent.prototype.proceedPlaceOrder = function (paymentData) {
        this.placeOrderClicked = true;
        if ((this.paymentMethodTypeForm.controls['paymentMethodType'].value == this.paymentTypeEnum.Saved_Cards || this.paymentMethodTypeForm.controls['paymentMethodType'].value == this.paymentTypeEnum.Nexio_Credit_Card) && this.selectedpayvisionCardInfo && !this.isNewCardClicked) {
            this.submitPayment(paymentData);
        }
        else if (!(this.paymentMethodTypeForm.controls['paymentMethodType'].value == this.paymentTypeEnum.Saved_Cards || this.paymentMethodTypeForm.controls['paymentMethodType'].value == this.paymentTypeEnum.Nexio_Credit_Card)) {
            this.submitPayment(paymentData);
        }
        else {
            this.placeOrderClicked = false;
            var errorMessage = this._translatePipe.get('common.Sorry, Something Went Wrong: Please try again later.');
            this._commonService.createNotification('', errorMessage.value, NotificationType.ERROR);
        }
    };
    PosOrderPromotionComponent.prototype.submitPayment = function (paymentData) {
        var _this = this;
        this._payvisionService.submitPayment(this.constructPaymentRequestModel(paymentData, null))
            .subscribe(function (response) {
            if (response && (response.paymentStatus === PaymentStatus.SUCCESS || response.paymentStatus === PaymentStatus.AUTH)) {
                _this.openOrderViewTab(response.orderID);
                _this.paymentComponentSettings.webOrderId = '';
                _this.clearAllTheForms(true);
            }
            else {
                _this.placeOrderClicked = false;
                var errorMessage = _this._translatePipe.get('common.Sorry, Something Went Wrong: Please try again later.');
                _this._commonService.createNotification('', errorMessage.value, NotificationType.ERROR);
            }
        }, function (error) {
            _this.placeOrderClicked = false;
            var errorMessage = _this._translatePipe.get('common.Sorry, Something Went Wrong: Please try again later.');
            _this._commonService.createNotification('', errorMessage.value, NotificationType.ERROR);
        });
    };
    PosOrderPromotionComponent.prototype.initiateTerminalPayment = function (initiatePaymentRequest) {
        var _this = this;
        this.terminalTransactionCancelButton = true;
        this._payvisionService.initiatePayment(initiatePaymentRequest)
            .subscribe(function (response) {
            if (_this.paymentComponentSettings.webOrderId && response) {
                if (response.terminalResponse && response.terminalResponse === Constants.OK && response.terminalPaymentStatusResponse && response.terminalPaymentStatusResponse.transactionID) {
                    _this.terminalTransactionID = response.terminalPaymentStatusResponse.transactionID;
                    _this.terminalTransactionCancelButton = false;
                    _this.getTerminalPaymentStatus(0);
                }
                else {
                    _this.paymentProcessingPopup.close();
                    _this.setErrorNotification(response);
                    _this.onEditCartClick();
                    _this.displayTryAgain = true;
                }
            }
        }, function (error) {
            _this.paymentProcessingPopup.close();
            _this.placeOrderClicked = false;
            var errorMessage = _this._translatePipe.get('common.Sorry, Something Went Wrong: Please try again later.');
            _this._commonService.createNotification('', errorMessage.value, NotificationType.ERROR);
            _this.onEditCartClick();
            _this.displayTryAgain = true;
        });
    };
    PosOrderPromotionComponent.prototype.getTerminalPaymentStatus = function (count) {
        var _this = this;
        if (!this.paymentComponentSettings.webOrderId) {
            this.paymentProcessingPopup.close();
        }
        else {
            var terminalPaymentStatus = {
                storeId: this.storeId,
                paymentMethodId: PaymentType.INTEGRATED_TERMINAL,
                orderSource: OrderSources.POS,
                saleID: this.paymentComponentSettings.webOrderId,
                poiid: this.terminalPOIId,
                paymentTransactionNo: this.terminalTransactionID ? this.terminalTransactionID : null,
                orderReferenceId: +this.paymentComponentSettings.orderReferenceId,
                storePOSTerminalId: this.terminalDetails.id
            };
            this._orderService.getTerminalPaymentStatus(terminalPaymentStatus)
                .subscribe(function (response) {
                if (_this.paymentComponentSettings.webOrderId && response) {
                    if (_this.validateTerminalStatusFailureResponse(response) && (response.terminalPaymentStatusResponse.paymentResponseErrorCondition === PaymentStatus.IN_PROGRESS || response.terminalPaymentStatusResponse.paymentResponseErrorCondition === PaymentStatus.MESSAGE_FORMAT) && _this.terminalPaymentStatusCheckPollingCount && _this.terminalPaymentStatusCheckPollingCount > 0) {
                        if (count <= _this.terminalPaymentStatusCheckPollingCount) {
                            setTimeout(function () {
                                count++;
                                _this.getTerminalPaymentStatus(count);
                            }, 5000);
                        }
                        else {
                            _this.paymentProcessingPopup.close();
                            _this.placeOrderClicked = false;
                            var errorMessage = _this._translatePipe.get('common.Sorry, Something Went Wrong: Please try again later.');
                            _this._commonService.createNotification('', errorMessage.value, NotificationType.ERROR);
                            _this.onEditCartClick();
                            _this.displayTryAgain = true;
                        }
                    }
                    else if (_this.validateTerminalStatusFailureResponse(response) && (response.terminalPaymentStatusResponse.paymentResponseErrorCondition.toUpperCase() === PaymentStatus.CANCEL || response.terminalPaymentStatusResponse.paymentResponseErrorCondition === PaymentStatus.ABORTED)) {
                        _this.paymentProcessingPopup.close();
                        _this.setErrorNotification(response.terminalPaymentStatusResponse);
                        _this.onEditCartClick();
                        _this.displayTryAgain = true;
                    }
                    else if (_this.validateTerminalStatusSuccessResponse(response)) {
                        _this.paymentProcessingPopup.close();
                        if (response.terminalPaymentStatusResponse.saleID) {
                            _this.openOrderViewTab(response.terminalPaymentStatusResponse.saleID);
                            _this.clearAllTheForms();
                        }
                    }
                    else {
                        _this.setErrorNotification(response.terminalPaymentStatusResponse);
                        _this.paymentProcessingPopup.close();
                        _this.onEditCartClick();
                        _this.displayTryAgain = true;
                    }
                }
            }, function (error) {
                _this.paymentProcessingPopup.close();
                _this.placeOrderClicked = false;
                var errorMessage = _this._translatePipe.get('common.Sorry, Something Went Wrong: Please try again later.');
                _this._commonService.createNotification('', errorMessage.value, NotificationType.ERROR);
                _this.onEditCartClick();
                _this.displayTryAgain = true;
            });
        }
    };
    PosOrderPromotionComponent.prototype.cancelTerminalPayment = function () {
        var _this = this;
        if (!this.paymentComponentSettings.webOrderId) {
            this.paymentProcessingPopup.close();
        }
        else {
            this.terminalTransactionCancelButton = true;
            var terminalPaymentStatusCheckPollingCount_1 = 0;
            if (this.terminalPaymentStatusCheckPollingCount && this.terminalPaymentStatusCheckPollingCount > 0) {
                terminalPaymentStatusCheckPollingCount_1 = this.terminalPaymentStatusCheckPollingCount > 2 ? this.terminalPaymentStatusCheckPollingCount - 2 : this.terminalPaymentStatusCheckPollingCount;
            }
            var cancelTerminalPayment = {
                storeId: this.storeId,
                paymentMethodId: PaymentType.INTEGRATED_TERMINAL,
                orderSource: OrderSources.POS,
                saleID: this.paymentComponentSettings.webOrderId,
                poiid: this.terminalPOIId,
            };
            this._orderService.cancelTerminalPayment(cancelTerminalPayment).subscribe(function (response) {
                if (_this.paymentComponentSettings.webOrderId && response) {
                    if (response.terminalResponse && response.terminalResponse === PaymentStatus.SUCCESS) {
                        _this.getTerminalPaymentStatus(terminalPaymentStatusCheckPollingCount_1);
                    }
                }
            }, function (error) {
                _this.getTerminalPaymentStatus(terminalPaymentStatusCheckPollingCount_1);
            });
        }
    };
    PosOrderPromotionComponent.prototype.validateTerminalStatusFailureResponse = function (response) {
        if (response.terminalPaymentStatusResponse && response.terminalPaymentStatusResponse.paymentStatus && response.terminalPaymentStatusResponse.paymentStatus === PaymentStatus.FAILURE && response.terminalPaymentStatusResponse.paymentResponseErrorCondition) {
            return true;
        }
        return false;
    };
    PosOrderPromotionComponent.prototype.validateTerminalStatusSuccessResponse = function (response) {
        if (response.terminalPaymentStatusResponse && response.terminalPaymentStatusResponse.paymentStatus && response.terminalPaymentStatusResponse.paymentStatus === PaymentStatus.SUCCESS) {
            return true;
        }
        return false;
    };
    PosOrderPromotionComponent.prototype.setErrorNotification = function (response) {
        if (response.validations && response.validations.message) {
            var errorMessage = response.validations.message;
            if (errorMessage.includes('+') || errorMessage.includes('message=')) {
                errorMessage = errorMessage.replace(/\+/g, ' ');
                errorMessage = errorMessage.replace(/message=/g, '');
            }
            this._commonService.createNotification('', errorMessage, NotificationType.ERROR);
        }
    };
    PosOrderPromotionComponent.prototype.enablePaymentBlock = function (status) {
        if (status) {
            this.isPaymentBlockEnabled = true;
            this.isEnterPaymentDetailsEnabled = false;
        }
        else {
            this.isPaymentBlockEnabled = false;
            this.isEnterPaymentDetailsEnabled = false;
        }
    };
    /**
    *
    * @param paymentMethod
    * @param paymentInformation
    * @param paymentComponentSettings
    */
    PosOrderPromotionComponent.prototype.constructPaymentRequestModel = function (paymentMethod, paymentInformation) {
        var orderDescription = this.products && this.products &&
            this.products.length > 0 ? this.products[0].name : 'order description';
        var paymentRequestModel = {
            token: (paymentMethod.paymentGroupId === 2 && this.selectedpayvisionCardInfo && this.selectedpayvisionCardInfo.token) ? this.selectedpayvisionCardInfo.token : paymentInformation ? paymentInformation.paymentToken : null,
            orderReferenceId: this.paymentComponentSettings.orderReferenceId,
            orderDescription: orderDescription,
            amount: this.calculateOrderTotal(),
            storeId: this.storeId,
            countryCode: paymentMethod.paymentGroupId === 2 ? this.selectedCountryCodeTwo : this.selectedIsoCountryCode,
            currencyCode: this.storeInfo.currencyCode,
            paymentMethodType: paymentMethod.paymentMethodName,
            paymentMethodId: paymentMethod.paymentMethodId,
            paymentGroupId: paymentMethod.paymentGroupId,
            orderSourceTypeId: OrderSourceValue.POS,
            notes: paymentMethod.paymentNote,
            checkNumber: paymentMethod.paymentCheckNumber,
            customerId: this.memberInfo && this.memberInfo.memberId ? this.memberInfo.memberId : null,
            orderTypeId: this.orderType.POS,
            // billingAddress: null, // this.getBillingAddress(),
            billingAddress: this.paymentBillingAddress,
            paymentAch: paymentInformation ? paymentInformation.paymentAch : null,
            paymentCheck: paymentInformation ? paymentInformation.paymentECheck : null,
            externalToken: paymentInformation ? paymentInformation.externalToken : null,
            paymentRequestModel: null,
            webOrderId: this.paymentComponentSettings.webOrderId,
            distrubutorId: paymentMethod.distrubutorId
        };
        return paymentRequestModel;
    };
    /**
     * @description To get Bank Details for Bank Transfer Payment method.
     * @author Akhil
     * @date 2020-05-11
     * @memberof OrderPromotionComponent
     */
    PosOrderPromotionComponent.prototype.getBankDetails = function () {
        var bankDetails = this._translateService.get(PaymentConstants.BankTransfer)['value'];
        if (bankDetails != PaymentConstants.BankTransfer) {
            for (var key in bankDetails) {
                if (key.indexOf(PaymentConstants.BankDetails) > -1) {
                    this.bankDetailsList.push(bankDetails[key]);
                }
            }
        }
    };
    /**
    *allows only numbers  with decimal value.
    */
    PosOrderPromotionComponent.prototype.allowOnlyDecimalValues = function (event, groupId, index) {
        if (event.keyCode !== 8 && event.keyCode !== 46) {
            var regex = new RegExp("^[0-9]+$");
            var value = event.key;
            if (!regex.test(value)) {
                event.preventDefault();
            }
        }
    };
    PosOrderPromotionComponent.prototype.getStatesCodeByByStateId = function (stateId) {
        var _this = this;
        var stateCode = '';
        var statedetails = this.states.find(function (item) { return item.id === stateId; });
        if (statedetails) {
            stateCode = statedetails.stateCode;
        }
        if (!stateCode) {
            var statesOfSelectedCountry = this.states.filter(function (x) { return x.countryCode === _this.paymentComponentSettings.isoCountryCode; });
            if (statesOfSelectedCountry[0] && statesOfSelectedCountry[0].stateCode) {
                stateCode = statesOfSelectedCountry[0].stateCode;
            }
        }
        return stateCode;
    };
    /**
     * set Distributor Info from FboId
     */
    PosOrderPromotionComponent.prototype.getDistributorInfo = function () {
        this.posOrderFormGroup.controls['memberInfo'].setValue(this.fboid);
        this.searchMember();
    };
    PosOrderPromotionComponent.prototype.onKeydown = function (event) {
        if (event.code === 'Space') {
            event.preventDefault();
        }
    };
    /**
     * create item number
     * @returns FormGroup
     */
    PosOrderPromotionComponent.prototype.createItemNumberGroup = function () {
        return this._formbuilder.group({
            itemNumber: [''],
            quantity: [''],
            productId: [''],
            productItem: [{}],
            productNumber: [''],
            productName: [''],
            productImage: [[]],
            disableIncrement: [false],
            isDepositFeeProduct: [false],
            depositFeeEnabled: [false]
        });
    };
    //#region #Start Countries/ Store and States Section
    /**
    * get Countries
    */
    PosOrderPromotionComponent.prototype.getCountries = function () {
        var _this = this;
        this._customerService.getCountriesLookup().subscribe(function (response) {
            if (response) {
                _this.countries = response;
                _this._cacheService.set(CacheKey.COUNTRIES, _this.countries);
                if (_this.orderFromLookup && _this.fboid) {
                    _this.getDistributorInfo();
                }
                else if (_this.isOrderSessionInfo) {
                    _this.posOrderFormGroup.controls['memberInfo'].setValue(_this.orderSession.memberInfo);
                    _this.searchMember();
                    _this.posOrderFormGroup.controls['orderType'].setValue(_this.orderSession.orderType);
                }
                _this.orderFromLookup = _this.isOrderSessionInfo ? _this.orderSession.orderFromLookup : _this.orderFromLookup;
            }
        });
    };
    /**
     * get States
     */
    PosOrderPromotionComponent.prototype.getStates = function () {
        var _this = this;
        this._customerService.getStates().subscribe(function (response) {
            if (response) {
                _this.states = response;
            }
        });
    };
    /**
     * Get Country Info by Code or Id
     * @param countryId
     * @param countryCode
     */
    PosOrderPromotionComponent.prototype.getCountryDetailsByCountryIdOrCode = function (countryId, countryCode) {
        var countryObj = {};
        if (countryId) {
            countryObj = this.countries.filter(function (x) { return x.countryId === countryId; })[0];
        }
        if (countryCode) {
            countryObj = this.countries.filter(function (x) { return x.isocodeThree === countryCode; })[0];
        }
        return countryObj;
    };
    /**
     * Get State Info by Code or Id
     * @param stateId
     * @param stateCode
     */
    PosOrderPromotionComponent.prototype.getStateDetailsByStateIdOrCode = function (stateId, stateCode) {
        var stateObj = {};
        if (stateId) {
            stateObj = this.states.filter(function (x) { return x.id === stateId; })[0];
        }
        if (stateCode) {
            stateObj = this.states.filter(function (x) { return x.stateCode === stateCode; })[0];
        }
        return stateObj;
    };
    PosOrderPromotionComponent.prototype.changePosLocation = function (posLocationID) {
        //    this.clearAllTheForms(false);
        this.clearOnPosLocationChange();
        if (this.posLocations && this.posLocations.length) {
            var posLocations = this.posLocations.find(function (x) { return x.id === +posLocationID; });
            this.currentPosLocation = posLocations;
            this.storeID = posLocations.storeId;
            this.businessEntityId = null;
            if (this.posLocations && this.posLocations.length && this.posLocations.length > 1) {
                sessionStorage.setItem(CacheKey.SelectedPOSLocation, posLocationID);
            }
            if (posLocations && this.memberInfo) {
                var isAuthorized = this.validatedAuthorizedCountries(posLocations.storeId);
                if (!isAuthorized) {
                    var notification = this._translatePipe.get('order.Sorry, this Customer is currently not eligible to purchase in this location. Add country in My Profile / My Global Business.');
                    this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    if (this.posLocations && this.posLocations.length && this.posLocations.length > 1) {
                        this.posOrderFormGroup.controls['posLocation'].setValue(0);
                    }
                }
                else {
                    this.posOrderFormGroup.controls['posLocation'].setValue(posLocationID);
                    this.posOrderFormGroup.controls['posLocation'].updateValueAndValidity();
                    this.storeInfo = null;
                    this.getStoreInfo(this.storeID);
                }
            }
        }
    };
    PosOrderPromotionComponent.prototype.validatedAuthorizedCountries = function (storeID) {
        var isAuthorizedStore = null;
        if (this.memberInfo && this.memberInfo.memberAllowedCountries && this.memberInfo.memberAllowedCountries.length) {
            isAuthorizedStore = this.memberInfo.memberAllowedCountries.find(function (allowedCountry) { return allowedCountry.storeId === storeID; });
        }
        return isAuthorizedStore;
    };
    /**
     * @description will get Handlig and fee charges based on poslocation
     * @date 2020-10-29
     * @memberof PosOrderPromotionComponent
     */
    PosOrderPromotionComponent.prototype.getHandlingFeeCharges = function () {
        var _this = this;
        this.taxCalculationStatus = true;
        this.importFeeValue = 0;
        this.handlingCharges = 0;
        // if shipMethodId formcontrol is not needed we need to remove this line
        this.posOrderFormGroup.controls['shipMethodId'].setValue(+this.posOrderFormGroup.controls['posLocation'].value);
        this.posOrderFormGroup.controls['shipMethodId'].updateValueAndValidity();
        if (this.memberInfo && this.storeInfo && this.products && this.products.length > 0 &&
            this.posOrderFormGroup.controls['posLocation'].value) {
            var shippingOptions = this.prepareShippingOptionsRequest();
            this._orderService.getPOSHandlingFeeCharges(shippingOptions, this.posOrderFormGroup.controls['posLocation'].value).subscribe(function (response) {
                if (response && response.shippingMethods && response.shippingMethods.length > 0) {
                    _this.shipMethod = response.shippingMethods[0];
                    _this.importFeeValue = _this._currencyPipe
                        .getFormatedCurrency(response.shippingMethods[0].importFeeValue, _this.storeInfo);
                    _this.handlingCharges = response.shippingMethods[0].shippingCharge;
                    _this.shippingMethodId = response.shippingMethods[0].shippingMethodId;
                    _this.calculateOrderTax();
                }
                else if (response && response.validations.length > 0) {
                    _this.shipMethodValidation = response.validations[0];
                }
                if (_this.isQuantityUpdate) {
                    _this.isQuantityUpdate = false;
                }
                _this.cartLimitNotReach = false;
            }, function (error) { });
        }
        console.log("getHandlingFeeCharges taxCalculationStatus", decodeURIComponent(encodeURIComponent(String(this.taxCalculationStatus))));
    };
    /**
     * @description will prepare shipping Options request
     * @date 2020-10-29
     * @returns {ShippingOptionsRequest}
     * @memberof PosOrderPromotionComponent
     */
    PosOrderPromotionComponent.prototype.prepareShippingOptionsRequest = function () {
        var shippingOptions = {
            productModels: this.getProductModels(),
            orderSourceId: OrderSourceType.Web,
            languageCode: this.languageCode,
            orderTypeId: ShippingOrderType.Personal,
            fromAddress: this.getWarehouseAddress(),
            toAddress: {},
            storeId: this.storeInfo.id,
            requestID: 2,
            memberTypeId: this.memberInfo && (this.memberInfo.memberTypeId === this.memberTypeEnum.DISTRIBUTOR ||
                this.memberInfo.memberTypeId === this.memberTypeEnum.FPC) ? ShippingMemberType.DISTRIBUTOR : ShippingMemberType.RETAIL,
            priceTypeId: PriceType.WHOLESALEPRICE,
            memberLevelId: this.memberInfo && (this.memberInfo.memberTitleId === MemberLevel.PREFERREDCUSTOMER)
                ? ShippingMemberTitle.NOVUS : ShippingMemberTitle.ASSISTANTMANAGER,
            orderSubTotal: this.calculateItemsSubTotal(this.storeInfo),
            orderCaseCredits: this.totalCommissionableVolume,
            purchaseFlowId: PurchaseFlowType.WholeSale,
            shippingTypeId: ShippingType.PICKUP,
            storeHomeCountryCode: this.selectedIsoCountryCode,
            vatInclusive: this.memberInfo && this.memberInfo.vatRegistered === true ? this.memberInfo.vatRegistered : false,
            initialOrder: false,
            orderType: this.orderType.POS,
            vatRegistered: this.memberInfo && this.memberInfo.vatRegistered === true ? this.memberInfo.vatRegistered : false
        };
        return shippingOptions;
    };
    /**
     * get products by Ids
     */
    PosOrderPromotionComponent.prototype.getProductsByIds = function (productsIds, storeInfo) {
        var _this = this;
        var fpc5PercentEnabled = false;
        var wholesaleQualified = this.memberInfo && this.memberInfo.wholeSaleQualified
            ? this.memberInfo.wholeSaleQualified : false;
        var optin = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
        var memberTitleId = this.memberInfo && this.memberInfo.memberLevelId
            ? this.memberInfo.memberLevelId : this.memberInfo.memberTitleId;
        if (this.appConfig && this.appConfig.fpc5PercentEnabled) {
            fpc5PercentEnabled = true;
        }
        var purchaseFlowType = this._commonService.getPurchaseFlowType(this.memberTypeId, wholesaleQualified, fpc5PercentEnabled, false, memberTitleId);
        // HARD_DOWNGRADE CHECK FOR FPC USERS
        memberTitleId = this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId);
        this._orderService.getProductsByIds(productsIds, this.storeDefaultLanguage, storeInfo.id, memberTitleId, purchaseFlowType, this.selectedIsoCountryCode, wholesaleQualified, optin, storeInfo.taxInclusive).subscribe(function (response) {
            if (response && response.length > 0) {
                _this.loadproducts(response);
            }
        });
    };
    /**
     *load procducts from session
     */
    PosOrderPromotionComponent.prototype.loadproducts = function (products) {
        var _this = this;
        products.forEach(function (product) {
            _this.addItemNumber();
            var items = _this.posOrderFormGroup.get('items');
            if (items && items.length > 0) {
                var index = (items.length - 1);
                if (product) {
                    var itemValue = product.itemNumber + ' - ' + product.name;
                    items.controls[index].controls['itemNumber'].setValue(itemValue);
                    var itemImage = (product.imageModelList && product.imageModelList.length > 0)
                        ? (product.imageModelList[0].details.find(function (imageDetail) { return imageDetail.type === ImageType.Thumbnail; })) : '';
                    var imageUrl = (itemImage && itemImage.url) ? (environment.cdnURL + '/' + itemImage.url)
                        : (environment.uiTemplateBaseUrl + '/images/no_image.png');
                    var isDepositFeeProduct = product.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_PRODUCT && x.metaKeyWords === '1'; });
                    var depositFeeEnabled = product.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1'; });
                    items.controls[index].controls['productImage'].setValue(imageUrl);
                    items.controls[index].controls['productNumber'].setValue(product.itemNumber);
                    items.controls[index].controls['productName'].setValue(product.displayName ? product.displayName : product.name);
                    items.controls[index].controls['productId'].setValue(product.id);
                    items.controls[index].controls['productItem'].setValue(product);
                    items.controls[index].controls['disableIncrement'].setValue(false);
                    items.controls[index].controls['quantity'].setValidators([Validators.required]);
                    items.controls[index].controls['quantity'].updateValueAndValidity();
                    items.controls[index].controls['isDepositFeeProduct'].setValue(!!isDepositFeeProduct);
                    items.controls[index].controls['depositFeeEnabled'].setValue(!!depositFeeEnabled);
                    if (_this.isOrderSessionInfo) {
                        var productInfo = _this.orderSession.products.find(function (item) { return product.id === item.productId; });
                        items.controls[index].controls['quantity'].setValue(productInfo && productInfo.quantity ? productInfo.quantity : 1);
                    }
                    else if (_this.posOrderFormGroup && !_this.isOrderSessionInfo) {
                        var productInfo = null;
                        if (_this.memberCart && _this.memberCart.items.length > 0) {
                            productInfo = _this.memberCart.items.find(function (item) { return product.id === item.productId; });
                        }
                        items.controls[index].controls['quantity'].setValue(productInfo && productInfo.quantity ? productInfo.quantity : 1);
                    }
                }
            }
        });
        this.updateTotalsAndShipMethod();
    };
    /**
     * Get Store Info
     * @param storeId
     */
    PosOrderPromotionComponent.prototype.getStoreInfo = function (storeId) {
        var _this = this;
        if (storeId) {
            this._orderService.getStoreById(storeId).subscribe(function (response) {
                if (response) {
                    var storeInfo = response;
                    _this.storeId = response.id;
                    _this.countryCode = response.homeIsocodeThree;
                    _this.selectedIsoCountryCode = response.homeIsocodeThree;
                    _this.storeLanguageCode = response.languages[0].cultureName;
                    var selectedCountry = _this.countries.find(function (x) { return x.isocodeThree.toLowerCase() === _this.selectedIsoCountryCode.toLowerCase(); });
                    if (selectedCountry) {
                        _this.memberInfo.vatRegistered = _this._commonService.getVatDetail(selectedCountry, _this.memberInfo);
                        if (environment.ignoreDisableAddNewCardCheckCountries && selectedCountry.isocodeThree && environment.ignoreDisableAddNewCardCheckCountries != "") {
                            var ignoreDisableAddNewCardCheckCountries = environment.ignoreDisableAddNewCardCheckCountries.split(',');
                            _this.ignoreAddNewCards = ignoreDisableAddNewCardCheckCountries.includes(selectedCountry.isocodeThree) ? true : false;
                        }
                        _this.checkoutConfig = _this._checkoutConfigService.getSettings(selectedCountry.isocodeThree, _this.memberInfo);
                        // this.isWorldPayEnabledCountry = this._configurationService.checkWorldPayEnabledCountry(selectedCountry.isocodeThree);
                        if (_this.memberInfo && _this.memberInfo.memberId && _this.checkoutConfig && _this.checkoutConfig.displayBusinessEntity) {
                            _this.loadMemberBasicInfo(_this.memberInfo.memberId);
                        }
                        // if (this.posRetailMemberEligibleCountries) {
                        //     const posMemberConfig: any = this.posRetailMemberEligibleCountries.find(x => x.countryCode === this.countryCode.toUpperCase());
                        //     if (posMemberConfig && this.memberInfo && this.memberInfo.memberTypeId === this.memberTypeEnum.RETAIL && posMemberConfig.enablePosOrderForRetail) {
                        //         this.isMemberEligibleToPlaceOrder = false;
                        //     }
                        // }
                        // this.isWorldpayPayment = this.checkoutConfig.isWorldpayPayment;
                        // this.isAdyenPayment = this.checkoutConfig.isAdyenPayment;
                        // this.isNIPayment = this.checkoutConfig.isNIPayment;
                        _this.selectedCountryCodeTwo = selectedCountry.isocodeTwo;
                        _this.paymentComponentSettings.isoCountryCode = selectedCountry.isocodeThree;
                        _this.paymentComponentSettings.isoTwoletterCountryCode = selectedCountry.isocodeTwo;
                    }
                    _this.isBackDateOrderAvailable(response.timeZoneOffset, response.operatingCountry);
                    _this.distributorMaxCC = storeInfo.distributorMaxCC;
                    if (_this.memberInfo && _this.memberInfo.fboId && _this.memberInfo.memberAllowedCountries
                        && _this.memberInfo.memberAllowedCountries.length > 0
                        && (+_this.memberInfo.memberTypeId === _this.memberTypeEnum.FPC || +_this.memberInfo.memberTypeId === _this.memberTypeEnum.DISTRIBUTOR)) {
                        if (_this.selectedIsoCountryCode) {
                            _this.getWholsesaleQualifiedDetails(_this.memberInfo.fboId, _this.selectedIsoCountryCode, storeInfo);
                        }
                        else {
                            _this.getMemberDiscountPercentages(storeInfo);
                        }
                    }
                    else {
                        _this.getMemberDiscountPercentages(storeInfo);
                    }
                    // delivery options api call
                    var memberType = void 0;
                    if (+_this.memberInfo.memberTypeId === MemberTypeEnum.GUEST) {
                        memberType = MemberType.GUEST;
                        _this.deliveryOptionPurchaseFlow = PurchaseFlows.RETAIL;
                        if (_this.isOrderSessionInfo) {
                            _this.sponsorInformation = _this.orderSession.sponsorInformation;
                        }
                    }
                    else if (+_this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR) {
                        memberType = MemberType.Distributor;
                        _this.deliveryOptionPurchaseFlow = PurchaseFlows.PERSONAL;
                    }
                    else if (+_this.memberInfo.memberTypeId === MemberTypeEnum.FPC) {
                        memberType = MemberType.PREFERRED_CUSTOMER;
                        _this.deliveryOptionPurchaseFlow = PurchaseFlows.PERSONAL;
                    }
                    else if (+_this.memberInfo.memberTypeId === MemberTypeEnum.RETAIL) {
                        memberType = MemberType.RETAIL;
                        _this.deliveryOptionPurchaseFlow = PurchaseFlows.RETAIL;
                    }
                    var getDeliveryOptionsRequest = {
                        memberTypeId: _this.memberInfo ? _this.memberInfo.memberTypeId : MemberTypeEnum.RETAIL,
                        memberType: memberType.toUpperCase(),
                        source: Source.POS,
                        countryCode: _this.countryCode,
                        purchaseFlow: _this.deliveryOptionPurchaseFlow,
                        storeId: _this.storeId
                    };
                    _this.shippingDeliveryOptionAvailable = false;
                    _this.pickupDeliveryOptionAvailable = false;
                    _this._orderService.getDeliveryOptions(_this.countryCode, getDeliveryOptionsRequest).subscribe(function (res) {
                        if (res) {
                            _this.dropShipDeliveryOptionDisabled = false;
                            _this.deliveryOptionResponse = res;
                            res.forEach(function (option) {
                                if (option.optionValue === DelivaryOptionType.Delivery) {
                                    _this.shippingDeliveryOptionAvailable = true;
                                }
                                if (option.optionValue === DelivaryOptionType.Pickup) {
                                    _this.pickupDeliveryOptionAvailable = true;
                                }
                                if (option.optionValue === DelivaryOptionType.Dropship) {
                                    if (option.optionDisabled) {
                                        _this.dropShipDeliveryOptionDisabled = true;
                                    }
                                    _this.pickupDeliveryOptionAvailable = true;
                                }
                            });
                            if (_this.deliveryOptionResponse && (_this.pickupDeliveryOptionAvailable || _this.shippingDeliveryOptionAvailable)) {
                                _this.isMemberEligibleToPlaceOrder = false;
                            }
                        }
                    });
                    if (_this.storeId && _this.storeId > 0 && _this.storeId !== response.id) {
                        var items = _this.posOrderFormGroup.get('items');
                        if (items && items.length > 0) {
                            while (items.length > 0) {
                                items.removeAt(0);
                            }
                            _this.taxableAmount = 0;
                            _this.updateTotalsAndShipMethod();
                            _this.getHandlingFeeCharges();
                        }
                    }
                    _this.countryTaxInclusive = storeInfo.taxInclusive;
                    _this.appConfig = _this._appConfigService.getSettings(_this.countryCode, _this.memberInfo); //storeConfiguration
                    _this.getOrderRules(storeInfo);
                    if (response.languages && response.languages.length > 0) {
                        _this.storeDefaultLanguage = response.languages.find(function (languageCulture) { return languageCulture.default; }).cultureName;
                        _this.payByLinkLanguageCode = _this.storeDefaultLanguage;
                        _this.payByLinkLanguageShortCode = response.languages.find(function (languageCulture) { return languageCulture.default; }).languageCode;
                        _this.languageShortCode = response.languages.find(function (languageCulture) { return languageCulture.default; }).languageCode;
                    }
                    else {
                        _this.storeDefaultLanguage = _this.languageCode;
                        _this.payByLinkLanguageCode = _this.payByLinkLanguageCode;
                        _this.payByLinkLanguageShortCode = _this.payByLinkLanguageShortCode;
                    }
                    _this.showPOSOrderValidation = false;
                    _this.storeInfo = storeInfo;
                    if (_this.memberInfo) {
                        _this.memberInfo = __assign({}, _this.memberInfo, { displayMiddleName: _this.storeInfo.displayMiddleName });
                    }
                    _this.overrideMinimumLimitIsEnabled = _this.getOverrideMinimumLimit();
                    _this.storeInfo.ccNumberDecimals = 3;
                    _this.storeInfo.ccNumberFormat = 'CR';
                    _this.storeInfo.ccSymbol = 'CC';
                    _this.paymentComponentSettings.languageCode = _this.languageCode;
                    _this.paymentComponentSettings.storeId = _this.storeInfo.id;
                    _this.paymentComponentSettings.orderType = OrderSourceTypes.POS,
                        _this.paymentComponentSettings.currencyCode = _this.storeInfo.currencyCode;
                    _this.paymentComponentSettings.numberDecimals = _this.storeInfo.numberDecimals;
                    _this.countryCode = _this.countryCode;
                    if (_this.isOrderSessionInfo) {
                        _this.loadproductsFromSession();
                        _this.updateTotalsAndShipMethod();
                    }
                    _this.phoneNumberFormat = _this._commonService.getPhoneNumberFormatByCountryCode(_this.countryCode);
                    _this.getPaymentMethodsByStore();
                    _this.getHandlingFeeCharges();
                    _this.isBackDateOrderAvailable(response.timeZoneOffset, response.operatingCountry);
                }
            }, function (error) {
                var notification = _this._translatePipe.get('order.Unable to fetch Store Details');
                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            });
        }
    };
    /**
     * @description
     * @date 2019-10-21
     * @private
     * @memberof OrderPromotionComponent
     */
    PosOrderPromotionComponent.prototype.getMemberDiscountPercentages = function (storeInfo) {
        var _this = this;
        var optin = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
        var wholeSaleQualified = this.memberInfo && this.memberInfo.wholeSaleQualified ? this.memberInfo.wholeSaleQualified : false;
        /* Logic changes for CSP-813: CSP - The pricing or Member Type should be considered based on the combination of
            Level, Opt-In, and Wholesale Qualified Status*/
        var memberTitleID = this.memberInfo ? this._orderService.getMemberTitleId(this.memberInfo) : MemberLevel.RETAIL;
        if (this.memberInfo) {
            this.memberInfo.transactionalWholesaleQualified = wholeSaleQualified;
            this.memberInfo.transactionalOptin = optin;
        }
        if (this.taxCalculationStatus) {
            this.updateTotalsAndShipMethod();
        }
        this.memberDiscountPercentage = null;
        this._commonService.getDiscountPercentages(wholeSaleQualified, optin, memberTitleID, storeInfo.id).
            subscribe(function (response) {
            if (response.id) {
                _this.memberDiscountPercentage = response;
                _this.isStoreDiscounPercentagetConfigured = true;
            }
            else {
                _this.isStoreDiscounPercentagetConfigured = false;
            }
        }, function (error) {
            _this.memberDiscountPercentage = null;
            var notification = _this._translatePipe.get('order.Store discount percentage configuration error');
            _this.isStoreDiscounPercentagetConfigured = false;
            _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        });
    };
    // region #Start Member Function Section
    /**
     * On Member Details Search
     */
    PosOrderPromotionComponent.prototype.searchMember = function () {
        this.isWhosaleCheckNotCalculated = false;
        this.isMemberHasAccessToOrder = true;
        this.searchReqValues = this.posOrderFormGroup.getRawValue();
        this.paymentComponentSettings.savedCards = [];
        var distributorIdPattern = /^\d\d\d-\d\d\d-\d\d\d-\d\d\d$/;
        var fboId = this.searchReqValues.memberInfo;
        if (new RegExp(distributorIdPattern).test(this.searchReqValues.memberInfo)) {
            fboId = fboId.replace(/-|\s/g, '');
        }
        this.memberSearchSubmitted = true;
        this.memberInfo = null;
        if (this.posOrderFormGroup.value.memberInfo && this.posOrderFormGroup.value.memberInfo.length > 0) {
            this.getMemberInfo(fboId);
        }
    };
    /**
     * Get Member Info by EmailID or FBOID
     */
    PosOrderPromotionComponent.prototype.getMemberInfo = function (memberDetails) {
        var _this = this;
        // this.posOrderFormGroup.controls['posLocation'].disable();
        this.memberDiscountPercentage = null;
        var type = '';
        type = memberDetails.indexOf('@') > -1 ? 'email' : 'fboId';
        this._orderService.getMemberInfo(memberDetails, type).subscribe(function (response) {
            if (_this.posLocations && _this.posLocations.length && _this.posLocations.length > 1) {
                _this.posOrderFormGroup.controls['posLocation'].enable();
            }
            if (response && response.memberId) {
                var fboId_1 = response.fboId;
                var firstName_1 = response.firstName;
                var lastName_1 = response.lastName;
                var memberlevel_1 = _this._commonService.getMemberLevel(response.memberLevelID);
                _this._commonService.getMemberStatus(fboId_1).subscribe(function (accountInfo) {
                    if (accountInfo && accountInfo.status === AccountRestrictionStatus.RESTRICTED && !_this.accountViewPermission) {
                        _this.accountRestriction = true;
                        var memberDetails_1 = {
                            fboId: fboId_1,
                            firstName: firstName_1,
                            lastName: lastName_1,
                            memberLevel: memberlevel_1
                        };
                        _this.memberDetails = memberDetails_1;
                        _this.isPaymentBlockEnabled = true;
                    }
                    else {
                        _this.getMemberInformation(response);
                    }
                });
            }
            else {
                if (_this.posLocations && _this.posLocations.length && _this.posLocations.length > 1) {
                    _this.posOrderFormGroup.controls['posLocation'].enable();
                }
                _this.clearAllTheForms();
                var notification = _this._translatePipe.get('order.Member Details Not Found');
                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            }
        }, function (error) {
            if (_this.posLocations && _this.posLocations.length && _this.posLocations.length > 1) {
                _this.posOrderFormGroup.controls['posLocation'].enable();
            }
            var notification = _this._translatePipe.get('order.Unable to retrieve Member Details');
            _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        });
    };
    PosOrderPromotionComponent.prototype.closeModal = function (status) {
        this.accountRestriction = status;
    };
    PosOrderPromotionComponent.prototype.getMemberInformation = function (response) {
        this.storeInfo = null;
        if (response && response.memberContacts) {
            var mobileNumber = response.memberContacts.find(function (x) { return (x.contactTypeID === ContactType.Mobile); });
            var phoneNumber = response.memberContacts.find(function (x) { return (x.contactTypeID === ContactType.Phone); });
            this.memberInfo = {
                mobile: mobileNumber && mobileNumber != 0 ? mobileNumber : null,
                phone: phoneNumber && phoneNumber != 0 ? phoneNumber : null
            };
            var defaultPhone = mobileNumber || phoneNumber;
            if (defaultPhone) {
                this.memberInfo.phone = defaultPhone.value;
                this.memberInfo.phoneType = defaultPhone.contactTypeID;
            }
        }
        this.phoneNumberFormat = this._commonService.getPhoneNumberFormatByCountryCode(this.countryCode);
        // Add Validation for Member Level
        this.getMemberLevelInfo(response);
    };
    PosOrderPromotionComponent.prototype.getMemberLevelInfo = function (memberResponse) {
        this.processMemberResponse(memberResponse);
        // this.posOrderFormGroup.controls['posLocation'].disable();
        // this._commonService.getMemberLevelDetails(memberResponse.fboId).subscribe((response) => {
        //     this.posOrderFormGroup.controls['posLocation'].enable();
        //     if (response) {
        //         memberResponse.memberTitle = response.memberLevel;
        //         if (+memberResponse.memberTypeId === this.memberTypeEnum.FPC) {
        //             memberResponse.memberTitle = MemberType.PREFERREDCUSTOMER;
        //         }
        //     }
        //     this.processMemberResponse(memberResponse);
        // }, (error) => {
        //     this.posOrderFormGroup.controls['posLocation'].enable();
        //     this.processMemberResponse(memberResponse);
        // });
    };
    PosOrderPromotionComponent.prototype.processMemberResponse = function (response) {
        var _this = this;
        this.isMemberEligibleToPlaceOrder = false;
        var notification = this._translatePipe.get('order.Member Details Found');
        this.memberTypeNotification = this._translatePipe.get('order.This member is not allowed to place pos order in this location');
        this.memberInfo = response;
        if (this.memberInfo && (+this.memberInfo.memberTypeId === this.memberTypeEnum.GUEST)) {
            this.memberInfo.memberTitle = MemberType.GUEST;
        }
        else if (+response.memberTypeId === this.memberTypeEnum.FPC || this.memberInfo.memberTitleId === MemberLevel.PREFERREDCUSTOMER) {
            this.memberInfo.memberTitle = MemberType.PREFERREDCUSTOMER;
        }
        if (this.memberInfo && this.memberInfo.memberTypeId === this.memberTypeEnum.DISTRIBUTOR && this.memberInfo.memberTitleId === MemberLevel.NOVICCUSTOMER) {
            this.memberInfo.memberTitle = MemberType.PREFERREDCUSTOMER;
        }
        if (+response.memberTypeId !== this.memberTypeEnum.DISTRIBUTOR) {
            this.memberInfo.vatRegistered = false;
        }
        if (response.memberTypeId == MemberTypeEnum.DISTRIBUTOR) {
            this.getMembergovernmentIdentificationsInfo(response.memberId);
        }
        this.orderTaxResponse = null;
        this.memberStatus = response.memberStatus;
        if (this.memberStatus && this.memberStatus.id) {
            this.isActive = (this.memberStatus.id === +MemberStatus.Active);
        }
        else {
            this.isActive = false;
        }
        console.log("this.isActive", this.isActive);
        if (response.memberTitleId && response.memberTypeId && (+response.memberTypeId === this.memberTypeEnum.GUEST)) {
            this.isMemberEligibleToPlaceOrder = true;
            this._commonService.createNotification('', this.memberTypeNotification.value, 'error');
        }
        this.memberSearchSubmitted = false;
        this.memberTypeId = this.memberInfo.memberTypeId;
        this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
        if (this.memberInfo.address) {
            this.paymentComponentSettings.billingAddress = this.memberInfo.address;
            var country = this.countries.filter(function (x) { return x.countryId === _this.memberInfo.address.countryId; })[0];
            this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
            this.paymentComponentSettings.billingAddress.zipCode = this.memberInfo.address.postalCode;
        }
        this.getMailingAddress(this.memberInfo);
        this.paymentComponentSettings.memberId = this.memberInfo.memberId;
        this.paymentComponentSettings.memberTypeId = this.memberInfo.memberTypeId;
        this.paymentComponentSettings.memberEmail = this.memberInfo.email ? this.memberInfo.email : '';
        this.paymentComponentSettings.distributorId = this.memberInfo.fboId;
        this.paymentComponentSettings.uniqueRefId = this.memberInfo.uniqueRefID ? this.memberInfo.uniqueRefID : '';
        var memberTitleID = this._orderService.getMemberTitleId(this.memberInfo);
        this.personalDiscountPercentage = this._commonService.getPersonalDiscount(memberTitleID);
        if (this.orderSession) {
            this.getPosLocations();
        }
        else {
            this.clearAllTheForms();
            this.orderSession = null;
        }
    };
    PosOrderPromotionComponent.prototype.loadMemberBasicInfo = function (memberId) {
        var _this = this;
        if (memberId && !this.businessEntityId) {
            this._customerService.getMemberBasicInfoById(memberId)
                .subscribe(function (res) {
                if (res && res.businessEntities) {
                    var activeBusinessEntity_1 = res.businessEntities.find(function (entity) { return entity.status === RowStatus.Active && entity.countryCodeId; });
                    if (activeBusinessEntity_1) {
                        var country = _this.countries && _this.countries.find(function (country) { return country.countryId && country.countryId === activeBusinessEntity_1.countryCodeId; });
                        if (activeBusinessEntity_1 && country.isocodeThree.toLowerCase() === _this.countryCode.toLowerCase()) {
                            if (_this._orderService.isValidDate(activeBusinessEntity_1.startDate, activeBusinessEntity_1.endDate)) {
                                _this.businessEntityId = activeBusinessEntity_1.id;
                            }
                            else {
                                _this.businessEntityId = null;
                            }
                        }
                    }
                }
            }, function (error) { });
        }
    };
    /**
     * Get wholesale qualified details for a FPC / FBO based on memberID and countryCode
     * @param memberID
     * @param countryCode
     */
    PosOrderPromotionComponent.prototype.getWholsesaleQualifiedDetails = function (fboId, memberHomeCountry, storeInfo) {
        var _this = this;
        this._commonService.getWholsesaleQualifiedDetails(fboId, memberHomeCountry)
            .subscribe(function (res) {
            try {
                if (res) {
                    _this.isWhosaleCheckNotCalculated = false;
                    if (res && res.error) {
                        _this.wholesaleCheckErrorNotifications();
                    }
                    _this.memberInfo.optin = res.optIn ? res.optIn : false;
                    _this.memberInfo.wholeSaleQualified = res.wholesaleQualified ? res.wholesaleQualified : false;
                    // Member wholesale qualified eligibility check
                    _this.memberInfo.transactionalWholesaleQualified = res.wholesaleQualified ? res.wholesaleQualified : false;
                    _this.memberInfo.transactionalOptin = res.optIn ? res.optIn : false;
                    var balance = void 0;
                    try {
                        balance = Number(res.balance);
                    }
                    catch (_a) {
                        balance = _this.distributorMaxCC;
                    }
                    if (!balance) {
                        balance = _this.distributorMaxCC;
                    }
                    _this.getMemberDiscountPercentages(storeInfo);
                }
            }
            catch (error) {
                _this.getMemberDiscountPercentages(storeInfo);
                _this.wholesaleCheckErrorNotifications();
            }
        }, function (error) {
            _this.getMemberDiscountPercentages(storeInfo);
            _this.wholesaleCheckErrorNotifications();
        });
    };
    PosOrderPromotionComponent.prototype.wholesaleCheckErrorNotifications = function () {
        this.isWhosaleCheckNotCalculated = true;
        var notification = this._translatePipe.get('order.The order is not receiving the PC Wholesale response from Valence. Please try again later.');
        this._commonService.createNotification('', notification.value, NotificationType.ERROR);
    };
    /**
     * map the billing address fields
     */
    PosOrderPromotionComponent.prototype.mapBillingAddress = function () {
        var _this = this;
        if (this.memberInfo && this.memberInfo.address) {
            this.paymentComponentSettings.billingAddress = this.memberInfo.address;
            var country = this.countries.filter(function (x) { return x.countryId === _this.memberInfo.address.countryId; })[0];
            this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
            this.paymentComponentSettings.billingAddress.zipCode = this.memberInfo.address.postalCode;
        }
    };
    /** Products
    * @returns Products
    */
    PosOrderPromotionComponent.prototype.getProductModels = function () {
        // const items: any = this.posOrderFormGroup.get('items');
        var productModels = [];
        if (this.products && this.products.length > 0) {
            for (var index = 0; index < this.products.length; index++) {
                var product = this.products[index];
                // const quantity = items.controls[index].controls['quantity'].value;
                if (product) {
                    var productModel = {
                        productID: product.id,
                        productHeight: product.shipping ? product.shipping.height : 0,
                        productWeight: product.shipping ? product.shipping.weight : 0,
                        productQuantity: product.quantity,
                        productLength: product.shipping ? product.shipping.length : 0,
                        productWidth: product.shipping ? product.shipping.width : 0,
                        wholesalePrice: product.wholesalePrice,
                        sellingPrice: product.applicablePrice,
                        isOrderLiteratureOnly: product.literature,
                        retailPrice: product.retailPrice,
                        weightMetricId: ProductWeightMetric.KGS,
                        isShippable: product.shipping ? product.shipping.shippingRequired : 0,
                        itemNumber: product.itemNumber
                    };
                    productModels.push(productModel);
                }
            }
        }
        return productModels;
    };
    /**
     * Decrement the item Quantity
     * @returns void
     */
    PosOrderPromotionComponent.prototype.decrementQuantity = function (index) {
        var _this = this;
        this.disableQty = true;
        var items = this.posOrderFormGroup.get('items');
        var productid = items.value[index].productId;
        var productids = [];
        productids.push(productid);
        this._customerService.getProductsByLocation(this.currentPosLocation.id, productids)
            .subscribe(function (response) {
            _this.productwareHouseLocation = response;
            if (_this.productwareHouseLocation && _this.productwareHouseLocation.length > 0) {
                if (_this.productwareHouseLocation[0].manageStock && _this.productwareHouseLocation[0].stockQuantity > 0) {
                    if (+items.value[index].quantity - 1 <= _this.productwareHouseLocation[0].stockQuantity) {
                        _this.decrementQuantityAndUpdateCart(index);
                    }
                    else {
                        var addedNotification = 'can not add product ' + items.value[index].productName + ' Avalible Quantity ' + _this.productwareHouseLocation[0].stockQuantity;
                        if (_this.taxCalculationStatus) {
                            _this.taxCalculationStatus = false;
                        }
                        _this._commonService.createNotification('', addedNotification, NotificationType.ERROR);
                        _this.disableQty = false;
                    }
                }
                if (_this.productwareHouseLocation[0].manageStock && _this.productwareHouseLocation[0].stockQuantity <= 0) {
                    if (_this.taxCalculationStatus) {
                        _this.taxCalculationStatus = false;
                    }
                    var addedNotification = 'can not add product ' + items.value[index].productName + ' Avalible Quantity 0';
                    _this._commonService.createNotification('', addedNotification, NotificationType.ERROR);
                }
                if (!_this.productwareHouseLocation[0].manageStock) {
                    _this.decrementQuantityAndUpdateCart(index);
                }
            }
            if (_this.productwareHouseLocation && _this.productwareHouseLocation.length == 0) {
                _this.decrementQuantityAndUpdateCart(index);
            }
        });
        console.log("decrementQuantity taxCalculationStatus", decodeURIComponent(encodeURIComponent(String(this.taxCalculationStatus))));
    };
    PosOrderPromotionComponent.prototype.decrementQuantityAndUpdateCart = function (index) {
        this.taxCalculationStatus = true;
        var items = this.posOrderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            if (items.controls[index].controls['quantity'].value > 1) {
                items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value - 1);
                items.controls[index].controls['quantity'].updateValueAndValidity();
                items.controls[index].controls['disableIncrement'].setValue(false);
            }
            this.setFocusbyID('quantity-' + (index));
            var sameProductIndex = this.getDepositFeeProductIndex(items, index);
            if (sameProductIndex >= 0) {
                this.decrementQuantityAndUpdateCart(sameProductIndex);
            }
            this.updateTotalsAndShipMethod();
            this.getHandlingFeeCharges();
        }
        console.log("decrementQuantityAndUpdateCart taxCalculationStatus", decodeURIComponent(encodeURIComponent(String(this.taxCalculationStatus))));
    };
    PosOrderPromotionComponent.prototype.getDepositFeeProductIndex = function (items, index) {
        if (this.productAssociationInfo) {
            var productid_1 = items.value[index].productId;
            var associateProduct_1 = this.productAssociationInfo.find(function (x) { return x.productId === productid_1; });
            if (associateProduct_1) {
                var sameProductIndex = items.controls.findIndex(function (item) { return item.controls['productId'].value === associateProduct_1.depositFeeProductId; });
                return sameProductIndex;
            }
            return;
        }
    };
    /**
    * Increment the item Quantity
    * @returns void
    */
    PosOrderPromotionComponent.prototype.incrementQuantity = function (index) {
        var _this = this;
        this.disableQty = true;
        var items = this.posOrderFormGroup.get('items');
        var productid = items.value[index].productId;
        var productids = [];
        productids.push(productid);
        this._customerService.getProductsByLocation(this.currentPosLocation.id, productids)
            .subscribe(function (response) {
            _this.productwareHouseLocation = response;
            if (_this.productwareHouseLocation && _this.productwareHouseLocation.length > 0) {
                if (_this.productwareHouseLocation[0].manageStock && _this.productwareHouseLocation[0].stockQuantity > 0) {
                    if (+items.value[index].quantity + 1 <= _this.productwareHouseLocation[0].stockQuantity) {
                        _this.incrementQuantityandAddtoCart(index);
                    }
                    else {
                        var addedNotification = 'can not add product ' + items.value[index].productName + ' Avalible Quantity ' + _this.productwareHouseLocation[0].stockQuantity;
                        if (_this.taxCalculationStatus) {
                            _this.taxCalculationStatus = false;
                        }
                        _this._commonService.createNotification('', addedNotification, NotificationType.ERROR);
                        _this.disableQty = false;
                    }
                }
                if (_this.productwareHouseLocation[0].manageStock && _this.productwareHouseLocation[0].stockQuantity == 0) {
                    if (_this.taxCalculationStatus) {
                        _this.taxCalculationStatus = false;
                    }
                    var addedNotification = 'can not add product ' + items.value[index].productName + ' Avalible Quantity 0';
                    _this._commonService.createNotification('', addedNotification, NotificationType.ERROR);
                }
                if (!_this.productwareHouseLocation[0].manageStock) {
                    _this.incrementQuantityandAddtoCart(index);
                }
            }
            if (_this.productwareHouseLocation && _this.productwareHouseLocation.length == 0) {
                _this.incrementQuantityandAddtoCart(index);
            }
        });
        console.log("incrementQuantity taxCalculationStatus", decodeURIComponent(encodeURIComponent(String(this.taxCalculationStatus))));
    };
    PosOrderPromotionComponent.prototype.incrementQuantityandAddtoCart = function (index) {
        this.taxCalculationStatus = true;
        var items = this.posOrderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value + 1);
            var product = items.controls[index].controls['productItem'].value;
            // //if ((items.controls[index].controls['quantity'].value > product.stockQuantity && product.manageStock) && !(product.stockAvailable && !product.manageStock)) {
            // if ((items.controls[index].controls['quantity'].value > product.stockQuantity && product.manageStock)) {
            //     items.controls[index].controls['quantity'].setValue(product.stockQuantity);
            //     const cartStockErrors: any = this._translatePipe.get('stockError.No Stock Available');
            //     this._commonService.createNotification('', cartStockErrors.value, NotificationType.ERROR);
            //     items.controls[index].controls['disableIncrement'].setValue(true);
            // } else {
            //     items.controls[index].controls['disableIncrement'].setValue(false);
            // }
            // items.controls[index].controls['disableIncrement'].setValue(false);
            items.controls[index].controls['quantity'].updateValueAndValidity();
            this.setFocusbyID('quantity-' + (index));
            var sameProductIndex = this.getDepositFeeProductIndex(items, index);
            if (sameProductIndex >= 0) {
                this.incrementQuantityandAddtoCart(sameProductIndex);
            }
            this.updateTotalsAndShipMethod();
            this.getHandlingFeeCharges();
        }
        console.log("incrementQuantityandAddtoCart taxCalculationStatus", decodeURIComponent(encodeURIComponent(String(this.taxCalculationStatus))));
    };
    PosOrderPromotionComponent.prototype.quantityChange = function (event, index) {
        var items = this.posOrderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            this.isFocused = false;
            items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value);
            items.controls[index].controls['quantity'].updateValueAndValidity();
        }
    };
    PosOrderPromotionComponent.prototype.setPreviousQuantity = function (value) {
        this.previousQuantity = value;
    };
    /**
    * @param  {number} index
    * @returns void
    */
    PosOrderPromotionComponent.prototype.updateQuantity = function (event, index) {
        var _this = this;
        var items = this.posOrderFormGroup.get('items');
        var productid = items.value[index].productId;
        var productids = [];
        productids.push(productid);
        var quantity = event.target ? +event.target.value : event;
        this._customerService.getProductsByLocation(this.currentPosLocation.id, productids)
            .subscribe(function (response) {
            _this.productwareHouseLocation = response;
            if (_this.productwareHouseLocation && _this.productwareHouseLocation.length > 0) {
                if (_this.productwareHouseLocation[0].manageStock && _this.productwareHouseLocation[0].stockQuantity > 0) {
                    if (quantity <= _this.productwareHouseLocation[0].stockQuantity) {
                        _this.cartLimitNotReach = false;
                        _this.updateQuantityAndAddtoCart(quantity, index);
                    }
                    else {
                        items.controls[index].controls['quantity'].setValue(_this.previousQuantity);
                        if (_this.taxCalculationStatus) {
                            _this.taxCalculationStatus = false;
                        }
                        var addedNotification = 'can not add product ' + items.value[index].productName + ' Avalible Quantity ' + _this.productwareHouseLocation[0].stockQuantity;
                        _this._commonService.createNotification('', addedNotification, NotificationType.ERROR);
                    }
                }
                if (_this.productwareHouseLocation[0].manageStock && _this.productwareHouseLocation[0].stockQuantity <= 0) {
                    if (_this.taxCalculationStatus) {
                        _this.taxCalculationStatus = false;
                    }
                    items.controls[index].controls['quantity'].setValue(_this.previousQuantity);
                    var addedNotification = 'can not add product ' + items.value[index].productName + ' Avalible Quantity 0';
                    _this._commonService.createNotification('', addedNotification, NotificationType.ERROR);
                }
                if (!_this.productwareHouseLocation[0].manageStock) {
                    _this.updateQuantityAndAddtoCart(quantity, index);
                }
            }
            if (_this.productwareHouseLocation && _this.productwareHouseLocation.length == 0) {
                _this.updateQuantityAndAddtoCart(quantity, index);
            }
        });
        console.log("updateQuantity taxCalculationStatus ", this.taxCalculationStatus);
    };
    PosOrderPromotionComponent.prototype.updateQuantityAndAddtoCart = function (quantity, index) {
        if (!this.isRestrictionPopupOpened && !this.addNewCardClicked) {
            var items = this.posOrderFormGroup.get('items');
            if (items && items.length > 0 && this.storeInfo) {
                if (items.controls[index].controls['quantity'].value > 1 ||
                    (quantity && parseInt(quantity, 10))) {
                    var product = items.controls[index].controls['productItem'].value;
                    items.controls[index].controls['quantity'].setValue((quantity));
                    // if (product && event.target.value > product.stockQuantity && product.manageStock) {
                    //     items.controls[index].controls['quantity'].setValue(product.stockQuantity);
                    //     const cartStockErrors: any = this._translatePipe.get('stockError.No Stock Available');
                    //     this._commonService.createNotification('', cartStockErrors.value, NotificationType.ERROR);
                    //     items.controls[index].controls['disableIncrement'].setValue(true);
                    // } else {
                    //     items.controls[index].controls['quantity'].setValue(event.target.value);
                    //     items.controls[index].controls['disableIncrement'].setValue(false);
                    // }
                    items.controls[index].controls['quantity'].updateValueAndValidity();
                }
                var sameProductIndex = this.getDepositFeeProductIndex(items, index);
                if (sameProductIndex >= 0) {
                    var depositFeeProductQuantity = +items.value[sameProductIndex].quantity;
                    depositFeeProductQuantity = depositFeeProductQuantity - this.previousQuantity;
                    depositFeeProductQuantity = depositFeeProductQuantity + quantity;
                    if (depositFeeProductQuantity >= 0) {
                        this.updateQuantityAndAddtoCart(depositFeeProductQuantity, sameProductIndex);
                    }
                }
                if (!this.isFocused) {
                    this.updateTotalsAndShipMethod();
                }
                if (this.isQuantityUpdate) {
                    this.getHandlingFeeCharges();
                }
                this.isFocused = false;
            }
        }
    };
    /**
     * disabling Submit button
     */
    PosOrderPromotionComponent.prototype.disableSubmitButton = function () {
        this.taxCalculationStatus = true;
    };
    /**
     * @returns void
     */
    PosOrderPromotionComponent.prototype.deleteItem = function (index) {
        var _this = this;
        var items = this.posOrderFormGroup.get('items');
        var productQuantity = +items.controls[index].controls['quantity'].value;
        if (items && items.length > 0) {
            if (this.productAssociationInfo) {
                var depositFeeEnabledCount = this._commonService.depositFeeEnabledProducts(items);
                var productId_1 = items.value[index].productId;
                var parentProduct_1 = this.productAssociationInfo.find(function (x) { return x.productId === productId_1; });
                if (parentProduct_1) {
                    // remove the parent product
                    items.removeAt(index);
                    var depositFeeProductIndex = items.controls.findIndex(function (item) { return item.controls['productId'].value === parentProduct_1.depositFeeProductId; });
                    if (depositFeeEnabledCount > 1) {
                        if (depositFeeProductIndex > -1) {
                            var depositFeeProductQuantity = +items.value[depositFeeProductIndex].quantity;
                            depositFeeProductQuantity = depositFeeProductQuantity - productQuantity;
                            if (depositFeeProductQuantity > 0) {
                                items.value[depositFeeProductIndex].quantity = depositFeeProductQuantity;
                                items.setValue(items.value);
                            }
                            else {
                                items.removeAt(depositFeeProductIndex);
                            }
                        }
                    }
                    else {
                        if (depositFeeProductIndex > -1) {
                            items.removeAt(depositFeeProductIndex);
                        }
                    }
                }
                else {
                    items.removeAt(index);
                }
            }
            else {
                items.removeAt(index);
            }
        }
        setTimeout(function () {
            if (_this.itemLevelSearch && _this.itemLevelSearch.nativeElement) {
                _this.itemLevelSearch.nativeElement.focus();
            }
        }, 500);
        this.updateTotalsAndShipMethod();
        this.getHandlingFeeCharges();
    };
    PosOrderPromotionComponent.prototype.addItemNumber = function () {
        this.items = this.posOrderFormGroup.get('items');
        this.items.push(this.createItemNumberGroup());
    };
    // region #Start Common Methods Section
    /**
        * Clear All the Forms
        * @param clearCountry
        * @param clearShippingAddress
        */
    PosOrderPromotionComponent.prototype.clearAllTheForms = function (clearMember) {
        if (clearMember === void 0) { clearMember = false; }
        this.paymentComponentSettings.webOrderId = '';
        this.selectedpayvisionCardInfo = null;
        this.bankDetailsList = [];
        this.subTotal = 0;
        this.retailSubTotal = 0.0;
        //this.shippingTax = 0;
        this.handlingCharges = 0;
        this.importFeeValue = 0;
        this.taxableAmount = 0;
        this.orderTaxResponse = null;
        this.products = [];
        this.totalCommissionableVolume = 0;
        this.shoppingCartCount = 0;
        this.memberLevelHistory = [];
        this.orderSubmitted = false;
        this.posOrderFormGroup.get('items').reset();
        this.orderSession = null;
        var arr = this.posOrderFormGroup.controls.items;
        arr.controls = [];
        this.businessEntityId = null;
        this.posOrderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
        if (clearMember) {
            this.posOrderFormGroup.controls['posLocation'].setValue('');
            this.posOrderFormGroup.controls['posLocation'].updateValueAndValidity();
            this.posOrderFormGroup.controls['memberInfo'].setValidators([Validators.required]);
            this.posOrderFormGroup.controls['memberInfo'].updateValueAndValidity();
            this.posOrderFormGroup.controls['memberInfo'].setValue('');
            this.memberInfo = null;
            this.orderFromLookup = false;
        }
        this.posOrderFormGroup.controls['itemSearch'].setValue('');
        this.posOrderFormGroup.controls['backDateOrder'].setValue(false);
        this.posOrderFormGroup.markAsUntouched();
        this.updateTotalsAndShipMethod();
        this.orderTaxResponse = null;
        if (!this.orderSession) {
            this.assignDefaultLocation();
            this.products = [];
        }
        this.isEnterPaymentDetailsEnabled = false;
        this.isPaymentBlockEnabled = false;
        if (this.externalPaymentForm && this.externalPaymentForm.get('payments')) {
            this.externalPaymentForm.get('payments').reset();
        }
        if (this.splitPaymentForm && this.splitPaymentForm.get('payments')) {
            this.splitPaymentForm.get('payments').reset();
        }
        this.placeOrderClicked = false;
        this.splitPayments = [];
        this.balanceOrderTotal = null;
        this.posPaymentMethods = [];
        this.posPaymentGroups = [];
        this.productAssociationInfo = [];
        this.depsoitFeeProductsInfo = [];
        this.isOverrideMinimumLimit = false;
        this.terminalDetails = null;
        this.isTerminalSelected = false;
        this.enablePaymentBlock(false);
    };
    PosOrderPromotionComponent.prototype.clearOnPosLocationChange = function () {
        this.paymentComponentSettings.webOrderId = '';
        this.selectedpayvisionCardInfo = null;
        this.bankDetailsList = [];
        this.subTotal = 0;
        this.retailSubTotal = 0.0;
        //this.shippingTax = 0;
        this.handlingCharges = 0;
        this.importFeeValue = 0;
        this.taxableAmount = 0;
        this.orderTaxResponse = null;
        this.products = [];
        this.totalCommissionableVolume = 0;
        this.shoppingCartCount = 0;
        this.memberLevelHistory = [];
        this.orderSubmitted = false;
        this.posOrderFormGroup.get('items').reset();
        this.orderSession = null;
        var arr = this.posOrderFormGroup.controls.items;
        arr.controls = [];
        this.businessEntityId = null;
        this.posOrderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
        this.posOrderFormGroup.controls['itemSearch'].setValue('');
        this.posOrderFormGroup.controls['backDateOrder'].setValue(false);
        // this.posOrderFormGroup.markAsUntouched();
        this.updateTotalsAndShipMethod();
        this.orderTaxResponse = null;
        if (!this.orderSession) {
            this.products = [];
        }
        this.isEnterPaymentDetailsEnabled = false;
        this.isPaymentBlockEnabled = false;
        if (this.externalPaymentForm && this.externalPaymentForm.get('payments')) {
            this.externalPaymentForm.get('payments').reset();
        }
        if (this.splitPaymentForm && this.splitPaymentForm.get('payments')) {
            this.splitPaymentForm.get('payments').reset();
        }
        this.placeOrderClicked = false;
        this.splitPayments = [];
        this.balanceOrderTotal = null;
        this.posPaymentMethods = [];
        this.posPaymentGroups = [];
        this.productAssociationInfo = [];
        this.depsoitFeeProductsInfo = [];
        this.isOverrideMinimumLimit = false;
        this.terminalDetails = null;
        this.isTerminalSelected = false;
    };
    /**
     * update Totals and ShipMethod
     */
    PosOrderPromotionComponent.prototype.updateTotalsAndShipMethod = function () {
        var _this = this;
        this.subTotal = 0;
        this.retailSubTotal = 0;
        this.products = [];
        this.totalCommissionableVolume = 0;
        this.shoppingCartCount = 0;
        var items = this.posOrderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            var _loop_1 = function (index) {
                var product = items.controls[index].controls['productItem'].value;
                var quantity = items.controls[index].controls['quantity'].value;
                if (product && quantity) {
                    var existProduct_1 = this_1.products.filter(function (productObj) { return productObj.id === product.id; })[0];
                    if (!existProduct_1) {
                        product.quantity = quantity;
                        this_1.products.push(product);
                    }
                    else {
                        var productIndex = this_1.products.findIndex(function (item) { return item.id === existProduct_1.id; });
                        this_1.products[productIndex].quantity = this_1.products[productIndex].quantity + quantity;
                    }
                    var address_1 = this_1.getPickUpAddress();
                    if (address_1 && address_1.countryId && this_1.countries && this_1.countries.length > 0) {
                        var country = this_1.countries.find(function (x) { return x.countryId === address_1.countryId; });
                        this_1.countryTaxInclusive = this_1.getCountryTaxInclusiveInfo(country);
                    }
                    var isEnableVATCalculation = this_1.appConfig && this_1.appConfig.enableVATCalculation;
                    var taxCalculated = this_1.appConfig.displayTaxInclusivePrice ? false : true;
                    this_1.displayPriceConfig = this_1._memberDisplayPriceConfigService
                        .getDisplayPriceConfig(PortalDisplayPage.PlaceOrder, this_1.storeInfo.taxInclusive, this_1.memberInfo, taxCalculated, this_1.countryTaxInclusive, this_1.storeInfo.homeIsocodeThree, isEnableVATCalculation);
                    var retailPrice = product.retailPrice;
                    if (this_1.displayPriceConfig) {
                        retailPrice = this_1.displayPriceConfig.displayRetailPrice ? product.retailPrice :
                            (this_1.displayPriceConfig.displayBaseRetailPrice ? product.baseRetailPrice : product.retailPrice);
                    }
                    this_1.subTotal = this_1.subTotal + this_1.getItemTotalSum(product);
                    this_1.retailSubTotal = this_1.retailSubTotal + (retailPrice * +quantity);
                    this_1.totalCommissionableVolume = this_1.totalCommissionableVolume + (product.commissionableVolume * +quantity);
                    this_1.shoppingCartCount += +product.quantity;
                }
            };
            var this_1 = this;
            for (var index = 0; index < items.length; index++) {
                _loop_1(index);
            }
            if (this.orderRules && this.orderRules.valueType === ValueType.PRICE && !(this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length)) {
                var subTotal = this.calculateSubtotalWithWholesalePrice(this.calculateItemsSubTotal(this.storeInfo));
                var literatureItems = this.getLiteratureItems(this.products);
                if (this.isMemberFboUpgraded) {
                    this.upgradeFboLimitExceeded = this.validateMemberMonthlyAmountLimit(subTotal);
                    if (this.upgradeFboLimitExceeded) {
                        this.checkMemberAccess();
                        return;
                    }
                    else {
                        this.isMemberHasAccessToOrder = true;
                    }
                }
                if (!((subTotal >= this.orderRules.minValue && subTotal <= this.orderRules.maxValue)
                    || (this.orderRules.includeLiterature && literatureItems && literatureItems.length === this.products.length
                        && subTotal <= this.orderRules.maxValue))) {
                    if (this.appConfig.orderMinMaxPriceValidation) {
                        this.minMaxPriceValidation = true;
                    }
                    if (subTotal > this.orderRules.maxValue) {
                        clearTimeout(this.cartMessageID);
                        var cartValueExceeded = this._translatePipe.get('order.Your cart must not exceed');
                        var maxValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.maxValue, this.storeInfo);
                        var cartValueExceededNotification_1 = cartValueExceeded.value + ' <b class="helvetica-bold">' +
                            maxValue + '</b>';
                        if (this.appConfig && this.appConfig.displayPurchaseLimitationMessage) {
                            this.cartMessageID = setTimeout(function () {
                                _this._commonService.createNotification('', cartValueExceededNotification_1, NotificationType.ERROR, 0, Constants.MAX_EXCEEDED);
                            }, 100);
                        }
                        this.cartLimitExceed = true;
                    }
                    else if (subTotal < this.orderRules.minValue && !this.isOverrideMinimumLimit) {
                        clearTimeout(this.cartMessageID);
                        var cartMinimumLimit = this._translatePipe.get('order.Order must meet a minimum of');
                        if (this.products && this.products.length &&
                            this.memberInfo && this.memberInfo.memberTypeId === this.memberTypeEnum.DISTRIBUTOR
                            && this.appConfig.displayPurchaseLimitationMessage
                            && this.orderRules && this.orderRules.minValueOnWholesalePrice && this.orderRules.valueType === ValueType.PRICE) {
                            cartMinimumLimit = this._translatePipe.get('order.Order must meet a minimum limit on wholesale price of');
                        }
                        if (this.overrideMinimumLimitIsEnabled) {
                            var overrideLimitLink = this._translatePipe.get("order.To Override Minimum Limit,click <a id='more-options'>here</a>");
                            var minValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.minValue, this.storeInfo);
                            var cartMinimumLimitNotification_1 = cartMinimumLimit.value + ' <b class="helvetica-bold">' +
                                minValue + '</b>.<b>' + overrideLimitLink.value + '</b>';
                            this.cartMessageID = setTimeout(function () {
                                var toast = _this._commonService.createNotification('', cartMinimumLimitNotification_1, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
                                toast.click.subscribe(function (event) {
                                    if (event.target.getAttribute(ImpersonateUserConstants.ID) === ImpersonateUserConstants.MORE_OPTIONS) {
                                        _this.overrideMinimumLimit.open();
                                    }
                                });
                            }, 100);
                            this.cartLimitNotReach = false;
                        }
                        else {
                            var minValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.minValue, this.storeInfo);
                            var cartMinimumLimitNotification_2 = cartMinimumLimit.value + ' <b class="helvetica-bold">' +
                                minValue + '</b>';
                            this.cartMessageID = setTimeout(function () {
                                _this._commonService.createNotification('', cartMinimumLimitNotification_2, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
                            }, 100);
                        }
                        this.cartLimitNotReach = true;
                    }
                    else {
                        this._commonService.removeNotification(Constants.MAX_EXCEEDED);
                        this._commonService.removeNotification(Constants.MIN_LIMIT);
                    }
                }
                else {
                    this.cartLimitExceed = false;
                    this.cartLimitNotReach = false;
                    this.minMaxPriceValidation = false;
                }
            }
        }
    };
    PosOrderPromotionComponent.prototype.getOverrideMinimumLimit = function () {
        if (this.userInfo && this.userInfo.allowedOperatingCountries && this.storeInfo && this.storeInfo.operatingCountry && !this.userInfo.hasSystemRole && this.operatingCountry) {
            var isoCodeThree_1 = this.storeInfo.operatingCountry;
            var allowedCountryIds = [];
            var operatingCountryId = this.operatingCountry.filter(function (operatingCountry) { return operatingCountry.value == isoCodeThree_1; });
            allowedCountryIds = this.userInfo.allowedOperatingCountries.split(",");
            if (operatingCountryId && operatingCountryId.length > 0) {
                return allowedCountryIds.includes(operatingCountryId[0].id.toString()) && this.hasMinimumOverrideLimit;
            }
            else {
                return false;
            }
        }
        return this.userInfo && this.userInfo.hasSystemRole === true ? true : false;
    };
    PosOrderPromotionComponent.prototype.getOperatingCountries = function () {
        var _this = this;
        this._customerService.getOperatingCountries().subscribe(function (response) {
            if (response) {
                _this.operatingCountry = response;
            }
        }, function (err) {
            console.log(err);
        });
    };
    PosOrderPromotionComponent.prototype.closeOverrideMinimumLimit = function () {
        this.isOverrideMinimumLimit = false;
        this.overrideMinimumLimit.close();
    };
    PosOrderPromotionComponent.prototype.overrideMinimumLimitValueCheck = function (event) {
        this.isOverrideMinimumLimit = event.currentTarget.checked;
    };
    PosOrderPromotionComponent.prototype.closeNotification = function () {
        this.isOverrideMinimumLimit === true ? this.enablePaymentBlock(true) : this.enablePaymentBlock(false);
        if (this.isOverrideMinimumLimit === true) {
            this.createOrder();
            this.cartLimitNotReach = false;
        }
        this._commonService.removeNotification(Constants.MIN_LIMIT);
        this._commonService.removeNotification(Constants.ORDER_LIMIT);
        this.overrideMinimumLimit.close();
    };
    /**
     * calculateSubtotalWithWholesalePrice()
     * @param shoppingCart
     */
    PosOrderPromotionComponent.prototype.calculateSubtotalWithWholesalePrice = function (orderSubTotal) {
        var _this = this;
        var subTotal = orderSubTotal;
        if (this.products && this.products.length &&
            this.memberInfo && this.memberInfo.memberTypeId === this.memberTypeEnum.DISTRIBUTOR
            && this.appConfig.displayPurchaseLimitationMessage
            && this.orderRules && this.orderRules.minValueOnWholesalePrice && this.orderRules.valueType === ValueType.PRICE) {
            subTotal = 0;
            this.products.forEach(function (item) {
                subTotal += ((_this.countryTaxInclusive ? item.wholesalePrice : item.baseWholesalePrice) * item.quantity);
            });
            // Should not apply wholesale price when user exceeds limit,
            // Wholesale price calculation applicable for minimum limit restriction
            if (orderSubTotal > this.orderRules.maxValue) {
                subTotal = orderSubTotal;
            }
        }
        return subTotal;
    };
    /**
     * Selected Shipping Address
     */
    PosOrderPromotionComponent.prototype.getBillingAddress = function () {
        var _this = this;
        var countryId = 0;
        if (this.countries && !this.billingAddressInfo.countryId) {
            var billingCountry = void 0;
            if (this.billingAddressInfo.countryCode && this.billingAddressInfo.countryCode.length > 2) {
                billingCountry =
                    this.countries.find(function (x) { return x.isocodeThree.toLowerCase()
                        === _this.billingAddressInfo.countryCode.toLowerCase(); });
            }
            else if (this.billingAddressInfo.countryCode && this.billingAddressInfo.countryCode.length === 2) {
                billingCountry =
                    this.countries.find(function (x) { return x.isocodeTwo.toLowerCase()
                        === _this.billingAddressInfo.countryCode.toLowerCase(); });
            }
            if (billingCountry) {
                countryId = billingCountry.countryId;
            }
        }
        var stateObj = this.getStateDetailsByStateIdOrCode(null, this.billingAddressInfo.state);
        var billingAddress = {
            addressLine1: this.billingAddressInfo.addressLine1,
            addressLine2: this.billingAddressInfo.addressLine2,
            addressLine3: this.billingAddressInfo.addressLine3,
            addressLine4: this.billingAddressInfo.addressLine4,
            city: this.billingAddressInfo.city || null,
            state: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            stateCode: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            countryCode: this.billingAddressInfo.countryCode,
            country: this.billingAddressInfo.countryCode,
            postalCode: this.billingAddressInfo.postalCode || this.billingAddressInfo.zip,
            zip: this.billingAddressInfo.postalCode || this.billingAddressInfo.zip,
            countryId: this.billingAddressInfo.countryId || countryId,
            stateId: this.billingAddressInfo.stateId || stateObj.id,
            name: this.billingAddressInfo.shipToName || this.billingAddressInfo.name || this.billingAddressInfo.firstName,
            addressType: AddressType.BILLING,
            countryCodeTwo: this.selectedCountryCodeTwo
        };
        return billingAddress;
    };
    PosOrderPromotionComponent.prototype.getPickUpAddress = function () {
        if (this.shipMethod && this.shipMethod.pickUpLocation) {
            this.shipMethod.pickUpLocation.addressType = AddressType.PICKUP;
            var countryObj = this.getCountryDetailsByCountryIdOrCode(null, this.selectedIsoCountryCode);
            var stateObj = this.getStateDetailsByStateIdOrCode(null, this.shipMethod.pickUpLocation.stateCode);
            if (countryObj) {
                this.shipMethod.pickUpLocation.countryId = countryObj.countryId;
            }
            if (stateObj) {
                this.shipMethod.pickUpLocation.stateId = stateObj.id;
            }
            this.shipMethod.pickUpLocation.name = this.shipMethod.pickUpLocation.pickupCenterName;
            this.shipMethod.pickUpLocation.postalCode = this.shipMethod.pickUpLocation.zip;
            return this.shipMethod.pickUpLocation;
        }
        else {
            return null;
        }
    };
    /**
     * Store Ware house Address
     */
    PosOrderPromotionComponent.prototype.getWarehouseAddress = function () {
        var warehouseAddress = null;
        if (this.storeInfo && this.storeInfo.warehouseAddress) {
            warehouseAddress = {
                addressLine1: this.storeInfo.warehouseAddress.addressLine1,
                addressLine2: this.storeInfo.warehouseAddress.addressLine2,
                addressLine3: this.storeInfo.warehouseAddress.addressLine3,
                addressLine4: this.storeInfo.warehouseAddress.addressLine4,
                city: this.storeInfo.warehouseAddress.city,
                state: this.storeInfo.warehouseAddress.stateCode,
                stateCode: this.storeInfo.warehouseAddress.stateCode,
                countryCode: this.storeInfo.warehouseAddress.countryCode || this.selectedIsoCountryCode,
                country: this.storeInfo.warehouseAddress.countryCode || this.selectedIsoCountryCode,
                postalCode: this.storeInfo.warehouseAddress.zipCode,
                zip: this.storeInfo.warehouseAddress.zipCode,
                countryId: this.storeInfo.warehouseAddress.countryId,
                stateId: this.storeInfo.warehouseAddress.stateOrProvinceId,
                name: null
            };
        }
        return warehouseAddress;
    };
    /**
     * verifyOrderRules
     * @returns boolean
     */
    PosOrderPromotionComponent.prototype.verifyOrderRules = function (isBackOrderDate) {
        var valid;
        valid = { thresholdCrossed: false, monthlyCCValid: false, memberCCOverride: false, cartLimitExceed: false, cartLimitNotReach: false, purchaseLimitExceed: false };
        var monthlyCCValid = false;
        var thresholdCrossed = false;
        var totalPoints = this.calculateTotalPoints();
        var subTotal = this.calculateSubtotalWithWholesalePrice(this.calculateItemsSubTotal(this.storeInfo));
        var literatureItems = this.getLiteratureItems(this.products);
        valid.purchaseLimitExceed = this.validateMemberMonthlyAmountLimit(totalPoints);
        if (this.orderRules && this.orderRules.valueType === ValueType.CC &&
            (totalPoints >= this.orderRules.minValue && totalPoints <= this.orderRules.maxValue)) {
            thresholdCrossed = false;
        }
        else if ((this.orderRules && this.orderRules.valueType === ValueType.PRICE) && (this.checkoutConfig.enableMinAndMaxLimitRules || this.checkoutConfig.enablePosOrderValidation)) {
            if (this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length) {
                thresholdCrossed = this.validateSubTotalBasedOnType(this.products, subTotal);
                if (subTotal > this.orderRules.maxValue && this.isPaymentBlockEnabled) {
                    valid.cartLimitExceed = true;
                }
                else if (subTotal < this.orderRules.minValue && this.isPaymentBlockEnabled) {
                    this.isOverrideMinimumLimit === true ? valid.cartLimitNotReach = false : valid.cartLimitNotReach = true;
                }
            }
            else if ((subTotal >= this.orderRules.minValue && subTotal <= this.orderRules.maxValue)
                || (this.orderRules.includeLiterature && literatureItems && literatureItems.length === this.products.length
                    && subTotal <= this.orderRules.maxValue)) {
                thresholdCrossed = false;
            }
            else if ((this.isOverrideMinimumLimit && subTotal <= this.orderRules.maxValue) ||
                (this.orderRules.includeLiterature && literatureItems && literatureItems.length === this.products.length
                    && subTotal <= this.orderRules.maxValue)) {
                thresholdCrossed = false;
                if (this.isOverrideMinimumLimit) {
                    valid.cartLimitNotReach = false;
                }
            }
            else {
                thresholdCrossed = true;
                if (subTotal > this.orderRules.maxValue) {
                    valid.cartLimitExceed = true;
                }
                else if (subTotal < this.orderRules.minValue) {
                    valid.cartLimitNotReach = true;
                }
            }
        }
        else {
            if (this.checkoutConfig.enableMinAndMaxLimitRules || this.checkoutConfig.enablePosOrderValidation) {
                thresholdCrossed = true;
                if ((this.orderRules && this.orderRules.valueType === ValueType.PRICE)) {
                    if (subTotal > this.orderRules.maxValue) {
                        valid.cartLimitExceed = true;
                    }
                    else if (subTotal < this.orderRules.minValue) {
                        valid.cartLimitNotReach = true;
                    }
                }
            }
        }
        if (this.memberInfo && this.memberOrderCCInfo) {
            var maxValue = void 0;
            if (!this.appConfig.displayPurchaseLimitationMessage && (this.orderRules &&
                this.orderRules.valueType === ValueType.PRICE && this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length)) {
                maxValue = this.orderRules.maxCCValue > this.memberOrderCCInfo.maxCCValue ? this.orderRules.maxCCValue : this.memberOrderCCInfo.maxCCValue;
                valid.monthlyCCValue = this.memberOrderCCInfo.maxCCValue;
            }
            else {
                maxValue = this.orderRules && this.orderRules.maxValue > this.memberOrderCCInfo.maxValue
                    ? this.orderRules.maxValue : this.memberOrderCCInfo.maxValue;
                valid.monthlyCCValue = this.memberOrderCCInfo.maxValue;
            }
            if ((totalPoints + this.memberOrderCCInfo.actualCCValue) > maxValue) {
                monthlyCCValid = true;
                thresholdCrossed = false;
            }
            // Monthly CC override for member
            if (this.memberCCOverride && this.memberCCOverride.overrideFlag) {
                var currentDate = this.momentConstructor(new Date()).format(DateConstants.DateFormat);
                var endDate = this.momentConstructor(new Date(this.memberCCOverride.effectiveEndDate))
                    .format(DateConstants.DateFormat);
                if (!isBackOrderDate) {
                    if (((totalPoints + this.memberOrderCCInfo.actualCCValue) > this.memberCCOverride.cVLimit)
                        && (new Date(currentDate) <= new Date(endDate))) {
                        valid.memberCCOverride = true;
                    }
                    else if ((this.orderRules && this.orderRules.maxValue < this.memberCCOverride.cVLimit)
                        && ((totalPoints + this.memberOrderCCInfo.actualCCValue) <= this.memberCCOverride.cVLimit)
                        && (new Date(currentDate) <= new Date(endDate))) {
                        monthlyCCValid = false;
                    }
                }
                else {
                    var createdDate = this.momentConstructor(this.memberCCOverride.effectiveStartDate)
                        .format(DateConstants.DateFormat);
                    if (((totalPoints + this.memberOrderCCInfo.actualCCValue) > this.memberCCOverride.cVLimit)
                        && (new Date(createdDate).getMonth() + 1 <= new Date().getMonth())) {
                        valid.memberCCOverride = true;
                    }
                    else if ((this.orderRules.maxValue < this.memberCCOverride.cVLimit) &&
                        ((totalPoints + this.memberOrderCCInfo.actualCCValue) <= this.memberCCOverride.cVLimit)
                        && (new Date(createdDate).getMonth() + 1 <= new Date().getMonth())) {
                        monthlyCCValid = false;
                    }
                }
            }
        }
        if (!totalPoints) {
            monthlyCCValid = false;
        }
        valid.thresholdCrossed = thresholdCrossed;
        valid.monthlyCCValid = monthlyCCValid;
        // for order rule value type: BOTH
        if (this.orderRules && this.orderRules.valueType === ValueType.BOTH) {
            var totalCC = (totalPoints + (this.memberOrderCCInfo ? this.memberOrderCCInfo.actualCCValue : 0));
            var details = this._commonService.validateSubTotalBasedOnBothPriceAndCC(this.orderRules, this.isLiteratureValidation(this.products), subTotal, totalCC);
            valid.cartLimitExceed = details.cartLimitExceed;
            valid.cartLimitNotReach = details.cartLimitNotReach;
            valid.monthlyCCValid = details.monthlyCCValid;
            valid.monthlyCCValue = details.monthlyCCValue;
            valid.thresholdCrossed = details.thresholdCrossed;
        }
        return valid;
    };
    PosOrderPromotionComponent.prototype.getLiteratureItems = function (products) {
        var _this = this;
        var literatureItems;
        if (products && products.length) {
            literatureItems = products.filter(function (item) { return item.literature; });
            if (this.orderRules && this.orderRules.itemNumbers && this.orderRules.itemNumbers.length) {
                var tripackItems = products.filter(function (item) { return _this.orderRules.itemNumbers.indexOf(+item.itemNumber) > -1; });
                if (tripackItems && tripackItems.length) {
                    literatureItems.push(tripackItems);
                }
            }
        }
        return literatureItems;
    };
    PosOrderPromotionComponent.prototype.validateMemberMonthlyAmountLimit = function (totalPoints) {
        var purchaseLimitExceed = false;
        var memberOrderRules = this.memberOrderCCInfo;
        if (this.orderRules && this.orderRules.valueType === ValueType.PRICE
            && memberOrderRules && (totalPoints + memberOrderRules.actualTotalValue) > this.orderRules.maxValue) {
            purchaseLimitExceed = true;
        }
        return purchaseLimitExceed;
    };
    PosOrderPromotionComponent.prototype.getMailingAddress = function (memberInfo) {
        var billingAddress = {};
        billingAddress = {
            firstName: memberInfo.firstName,
            lastName: memberInfo.lastname,
            addressLine1: memberInfo.address.addressLine1,
            addressLine2: memberInfo.address.addressLine2,
            city: memberInfo.address.city,
            id: memberInfo.address.id,
            addressType: memberInfo.address.addressTypeId,
            postalCode: memberInfo.address.zipCode,
            zip: memberInfo.address.zipCode,
            country: memberInfo.address.countryCodeTwo,
            countryCode: memberInfo.address.countryCodeTwo,
            countryId: memberInfo.address.countryId,
            state: this.getStatesCodeByByStateId(memberInfo.address.stateId)
        };
        this.paymentBillingAddress = billingAddress;
    };
    /**
     * Get total points
     */
    PosOrderPromotionComponent.prototype.calculateTotalPoints = function () {
        var _totalCV = 0;
        for (var i = 0; i < this.products.length; i++) {
            if (!this.products[i].literature) {
                _totalCV += this.products[i].commissionableVolume * this.products[i].quantity;
            }
        }
        return _totalCV;
    };
    /**
     * on click of checkout
     * @memberof CartComponent
     */
    PosOrderPromotionComponent.prototype.createOrder = function () {
        this.displayTryAgain = false;
        if (this.isWhosaleCheckNotCalculated) {
            this.wholesaleCheckErrorNotifications();
            return;
        }
        this.enablePaymentBlock(true);
        this.posPaymentGroups = [];
        var items = this.posOrderFormGroup.get('items');
        var productids = [];
        items.value.forEach(function (element) {
            productids.push(element.productId);
        });
        this.posStockAvailabilityCheck(productids, +this.posOrderFormGroup.controls['posLocation'].value);
    };
    PosOrderPromotionComponent.prototype.getPlaceOrderStatus = function () {
        var placeOrderDisabled = true;
        console.log("this.posOrderFormGroup.valid", this.posOrderFormGroup.valid);
        console.log("this.placeOrderClicked", this.placeOrderClicked);
        console.log("this.balanceOrderTotal", this.balanceOrderTotal);
        console.log("this.isPayByLinkValid", this.isPayByLinkValid);
        console.log("this.agreementCheckError", this.agreementCheckError);
        console.log("this.isPaymentBlockEnabled", this.isPaymentBlockEnabled);
        console.log("this.taxCalculationStatus", this.taxCalculationStatus);
        if (this.posOrderFormGroup.valid && !this.placeOrderClicked && this.isActive && (this.balanceOrderTotal === 0 ? true : false) && this.isPayByLinkValid && !this.agreementCheckError && this.isPaymentBlockEnabled && !this.taxCalculationStatus) {
            if (this.posOrderFormGroup.value.paymentSelector && +this.posOrderFormGroup.value.paymentSelector === PosPaymentGroupEnum.External_Payment) {
                if (this.externalPaymentForm.valid) {
                    placeOrderDisabled = false;
                }
            }
            else {
                placeOrderDisabled = false;
            }
        }
        console.log("placeOrderDisabled", placeOrderDisabled);
        return placeOrderDisabled;
    };
    PosOrderPromotionComponent.prototype.proceedCreateOrder = function () {
        this.checkMemberAccess();
        this._cacheService.set(CacheKey.CARTUPDATED, 'true');
        if (this.isMemberHasAccessToOrder && !this.upgradeFboLimitExceeded) {
            this.isSubmitted = true;
            if (!this.chRef['destroyed']) {
                this.chRef.detectChanges();
            }
            if (this.products && this.products.length) {
                var productIds = this.products.map(function (item) { return item.id; });
                if (productIds && productIds.length) {
                    var memberTitleId = this.memberInfo && this.memberInfo.memberTitleId;
                    // HARD_DOWNGRADE CHECK FOR FPC USERS
                    memberTitleId = this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId);
                    this.submitOrder();
                }
            }
        }
    };
    /**
     * @description To check stock available
     * @date 2019-09-20
     * @param {Product[]} products
     * @returns {Product[]}
     * @memberof OrderPromotionComponent
     */
    PosOrderPromotionComponent.prototype.stockAvailabilityCheck = function (products) {
        var cartProducts = this.products;
        if (cartProducts && products && products.length) {
            var noStockItems_1 = [];
            products.forEach(function (product) {
                var cartItem = cartProducts.find(function (item) { return item.id === product.id; });
                //if (cartItem && !((product.stockAvailable && !product.manageStock) || (product.manageStock && product.stockQuantity >= cartItem.quantity))) {
                if (cartItem && !(!product.manageStock || (product.manageStock && product.stockQuantity >= cartItem.quantity))) {
                    noStockItems_1.push(cartItem);
                }
            });
            return noStockItems_1;
        }
        return [];
    };
    PosOrderPromotionComponent.prototype.posStockAvailabilityCheck = function (productIds, posLocationid, placePosOrder) {
        var _this = this;
        var noStockItems = [];
        if (posLocationid && posLocationid > 0 && productIds && productIds.length > 0) {
            this._customerService.getProductsByLocation(posLocationid, productIds).subscribe(function (response) {
                var posProducts = response;
                if (posProducts && posProducts.length > 0) {
                    posProducts.forEach(function (pickUpProduct) {
                        var cartProduct = _this.posOrderFormGroup.value.items.find(function (product) { return product.productId === pickUpProduct.productId; });
                        if (cartProduct && pickUpProduct.manageStock && cartProduct.quantity > pickUpProduct.stockQuantity) {
                            cartProduct.stockQuantity = pickUpProduct.stockQuantity;
                            noStockItems.push(cartProduct);
                        }
                    });
                }
                _this.outOfStockItems = noStockItems;
                if (_this.outOfStockItems && _this.outOfStockItems.length > 0) {
                    _this.outOfStockModal.open();
                    _this.enablePaymentBlock(false);
                }
                else {
                    if (placePosOrder) {
                        _this.createPosOrderUpdate();
                    }
                    else {
                        _this.proceedCreateOrder();
                    }
                }
            }, function (error) {
                _this.enablePaymentBlock(false);
                var errorMessage = _this._translateService.get('common.Sorry, Something Went Wrong: Please try again later.');
                _this._commonService.createNotification('', errorMessage.value, NotificationType.ERROR);
            });
        }
    };
    PosOrderPromotionComponent.prototype.submitOrder = function (url) {
        this.isSubmitted = true;
        var requestUrl = '';
        this.orderSubmitted = true;
        requestUrl = url || ApiUrlConstants.orderApiUrl + '/V1/orders';
        if (this.posOrderFormGroup.valid) {
            var isBackDateOrder = this.posOrderFormGroup.value.backDateOrder;
            this.getMemberOrderRules(this.memberInfo, isBackDateOrder, requestUrl);
        }
    };
    PosOrderPromotionComponent.prototype.placeOrder = function (requestUrl) {
        var _this = this;
        var exceedMonthlyCCPopup = this._translatePipe
            .get('order.Your cart contains a case credit value that brings your total monthly case credits above the limit');
        var exceedMonthlyCCOverridePopup = this._translatePipe
            .get('order.Monthly CC limit reached');
        var orderRulesMaxValue = (this.orderRules && this.orderRules.maxValue) ? this.orderRules.maxValue : (this.orderRules && this.orderRules.literatureMaxValue) ? this.orderRules.literatureMaxValue : null;
        var maxValue = this._currencyPipe.getFormatedCurrencyWithSepartors((this._commonService.validateNumberDecimalPoint(orderRulesMaxValue) ? orderRulesMaxValue : orderRulesMaxValue) + '.00' || '0', this.storeInfo);
        var exceedPerOrderCC = this._translatePipe.get('order.The maximum limit for a Retail purchase is {{max}}. Please remove items from the shopping bag to continue.', { max: maxValue });
        var minimumCartLimit = this._translatePipe.get('order.Order must meet a minimum of');
        var maximumCartLimit = this._translatePipe.get('order.Cart must not exceed');
        var currentCC = this.calculateTotalPoints();
        if (this.thresholdCrossed && this.orderRules && this.orderRules.valueType !== ValueType.BOTH) {
            if (this.cartLimitExceed) {
                var cartMaximumLimitNotification = maximumCartLimit.value + ' <b class="helvetica-bold">' +
                    maxValue + '</b>';
                if (this.memberTypeId !== this.memberTypeEnum.RETAIL && this.memberInfo.memberTypeId !== this.memberTypeEnum.GUEST) {
                    this._commonService.createNotification('', cartMaximumLimitNotification, NotificationType.ERROR, 0, Constants.MAX_EXCEEDED);
                }
                this.isSubmitted = false;
            }
            else if (this.cartLimitNotReach) {
                if (this.products && this.products.length &&
                    this.memberInfo && this.memberInfo.memberTypeId === this.memberTypeEnum.DISTRIBUTOR
                    && this.appConfig.displayPurchaseLimitationMessage
                    && this.orderRules && this.orderRules.minValueOnWholesalePrice && this.orderRules.valueType === ValueType.PRICE) {
                    minimumCartLimit = this._translatePipe.get('order.Order must meet a minimum limit on wholesale price of');
                }
                if (this.overrideMinimumLimitIsEnabled) {
                    var overrideLimitLink = this._translatePipe.get("order.To Override Minimum Limit,click <a id='more-options'>here</a>");
                    var cartMinimumLimit = this._translatePipe.get('order.To register as an FBO the order must meet a minimum of');
                    var minValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.minValue, this.storeInfo);
                    var cartMinimumLimitNotification_3 = cartMinimumLimit.value + ' <b class="helvetica-bold">' +
                        minValue + '</b>.<b>' + overrideLimitLink.value + '</b>';
                    this.cartMessageID = setTimeout(function () {
                        var toast = _this._commonService.createNotification('', cartMinimumLimitNotification_3, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                        toast.click.subscribe(function (event) {
                            if (event.target.getAttribute(ImpersonateUserConstants.ID) === ImpersonateUserConstants.MORE_OPTIONS) {
                                _this.overrideMinimumLimit.open();
                            }
                        });
                    }, 100);
                }
                else {
                    var cartMinimumLimit = this._translatePipe.get('order.To register as an FBO the order must meet a minimum of');
                    var minValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.minValue, this.storeInfo);
                    var cartMinimumLimitNotification_4 = cartMinimumLimit.value + ' <b class="helvetica-bold">' +
                        minValue + '</b>';
                    this.cartMessageID = setTimeout(function () {
                        _this._commonService.createNotification('', cartMinimumLimitNotification_4, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                    }, 100);
                }
                this.isSubmitted = false;
            }
            else {
                this._commonService.removeNotification(Constants.MAX_EXCEEDED);
                this._commonService.removeNotification(Constants.MIN_LIMIT);
            }
        }
        if ((((this.orderRules && !this.thresholdCrossed) || !this.orderRules) && (!this.memberCCOverrideLimitExceeded) &&
            ((this.memberOrderCCInfo && !this.memberCCLimitExceeded) || !this.memberOrderCCInfo))
            || (!currentCC && this.orderRules.valueType !== ValueType.BOTH)) {
            this.submitPlaceOrder(requestUrl);
        }
        if ((this.memberCCLimitExceeded || this.thresholdCrossed) && !this.memberCCOverrideLimitExceeded) {
            var monthlyCCContent = exceedMonthlyCCPopup.value + ' <b class="helvetica-bold">'
                + this.monthlyCCValue + '</b>';
            if (this.orderRules && this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length) {
                if (this.memberCCLimitExceeded) {
                    this.isPaymentBlockEnabled = false;
                    this._commonService.createNotification('', monthlyCCContent, NotificationType.ERROR);
                }
                if (this.cartLimitExceed || this.cartLimitNotReach) {
                    var isLiteratureValidation = this.isLiteratureValidation(this.products);
                    var invalidProductPopup = this._translateService.get('order.Your cart must be a minimum amount of {{min}} and  a maximum amount of {{max}}', {
                        min: isLiteratureValidation ? this.orderRules.literatureMinValue : this.orderRules.minValue,
                        max: isLiteratureValidation ? this.orderRules.literatureMaxValue : this.orderRules.maxValue
                    });
                    this._commonService.createNotification('', invalidProductPopup.value, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                    this.enablePaymentBlock(false);
                }
                else {
                    this._commonService.removeNotification(Constants.ORDER_LIMIT);
                }
            }
            else if (!this.appConfig.displayPurchaseLimitationMessage) {
                if (this.memberTypeId !== this.memberTypeEnum.RETAIL && this.memberTypeId !== this.memberTypeEnum.GUEST) {
                    this._commonService.createNotification('', monthlyCCContent, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                }
                else {
                    this._commonService.createNotification('', exceedPerOrderCC.value, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                }
            }
            this.isSubmitted = false;
        }
        if (this.memberCCOverrideLimitExceeded) {
            this._commonService.createNotification('', exceedMonthlyCCOverridePopup.value, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
            this.isSubmitted = false;
        }
        else {
            this._commonService.removeNotification(Constants.MIN_LIMIT);
        }
    };
    /**
     * @description
     * @date 2019-09-04
     * @memberof OrderPromotionComponent
     */
    PosOrderPromotionComponent.prototype.submitPlaceOrder = function (requestUrl) {
        var orderRequest = this.prepareOrderRequest();
        if ((orderRequest.taxMetaData && this.isTaxMetaDataAvailable) || (!orderRequest.taxMetaData && !this.isTaxMetaDataAvailable)) {
            var compareTaxValues = this.appConfig && this.appConfig.ignoreCompareTax ? true : this.compareTax(orderRequest);
            if (compareTaxValues) {
                this.comparePriceTier(orderRequest, requestUrl);
            }
            else {
                var notification = this._translatePipe.get('order.There is a mismatch in tax calculation. Please try again later.');
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                this.isSubmitted = false;
                this.enablePaymentBlock(false);
            }
        }
        else {
            var notification = this._translatePipe.get('order.Tax is not mapped. Please try again later.');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            this.isSubmitted = false;
        }
    };
    /**
     * @description compare tax
     * @date 2019-10-31
     * @param {Order} orderRequest
     * @returns {boolean}
     * @memberof OrderPromotionComponent
     */
    PosOrderPromotionComponent.prototype.compareTax = function (orderRequest) {
        if (orderRequest && orderRequest.taxMetaData && orderRequest.taxMetaData.orderTaxCharges
            && orderRequest.taxMetaData.orderTaxCharges.length > 0) {
            var totalTaxAmount_1 = 0;
            var totalTaxChargeBased_1 = 0;
            orderRequest.taxMetaData.orderTaxCharges.forEach(function (tax) {
                totalTaxAmount_1 = totalTaxAmount_1 + parseFloat(tax.taxAmount.toFixed(2));
                totalTaxChargeBased_1 = totalTaxChargeBased_1 + tax.taxChargeBased;
            });
            totalTaxAmount_1 = this._currencyPipe.getFormatedCurrency(totalTaxAmount_1, this.storeInfo);
            if (orderRequest.orderTax.toFixed(2) === totalTaxAmount_1.toFixed(2) && this.compareOrderTotal(totalTaxAmount_1, totalTaxChargeBased_1, orderRequest)) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return true;
        }
    };
    PosOrderPromotionComponent.prototype.compareOrderTotal = function (totalTaxAmount, totalTaxChargeBased, orderRequest) {
        var countryCodes = ['ARE', 'QAT', 'OMN', 'KWT', 'SAU', 'BHR'];
        if (totalTaxChargeBased && totalTaxAmount && orderRequest && orderRequest.orderLineItems && orderRequest.orderLineItems.length > 0
            && countryCodes.indexOf(orderRequest.countryCode) >= 0) {
            var taxTotal = totalTaxChargeBased + totalTaxAmount;
            var lineItemTotal_1 = 0;
            orderRequest.orderLineItems.forEach(function (lineItems) {
                lineItemTotal_1 = lineItemTotal_1 + lineItems.unitTax + lineItems.totalAmount;
            });
            if ((Math.round((taxTotal + Number.EPSILON) * 100) / 100) == (Math.round((lineItemTotal_1 + Number.EPSILON) * 100) / 100)) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return true;
        }
    };
    /**
     * create order log request parameter
     */
    PosOrderPromotionComponent.prototype.createOrderLog = function (res, message) {
        var _this = this;
        var orderLogRequest = {
            'messageTypeId': MessageTypeEnum.OrderLogsMessageType,
            'orderId': res.id,
            'webOrderId': res.webOrderId,
            'message': message ? message : 'Order Placed by the agent',
            'source': Constants.CUSTOMER_SERIVCE
        };
        this._orderService.createOrderLog(orderLogRequest).subscribe(function (response) { }, function (error) {
            _this._commonService.createNotification('', 'Failed to Create order log', NotificationType.ERROR);
        });
    };
    PosOrderPromotionComponent.prototype.orderSuccess = function (response) {
        this.paymentComponentSettings.webOrderId = response.webOrderId;
        this.paymentComponentSettings.orderReferenceId = response.id;
        this.orderFromLookup = false;
        this.fboid = '';
        this.clearAllTheForms(true);
        this.orderSubmitted = false;
        this.orderSession = null;
        this.openOrderViewTab(this.paymentComponentSettings.webOrderId);
        this.paymentComponentSettings = new PaymentComponentSettings();
    };
    PosOrderPromotionComponent.prototype.processPaymentAfterOrderCreation = function () {
    };
    PosOrderPromotionComponent.prototype.openOrderViewTab = function (weborderID, country) {
        var orderInfo = new OrderInfoTab();
        orderInfo.webOrderID = weborderID;
        orderInfo.tabForOrderPromotion = true;
        orderInfo.homeCountry = this.selectedIsoCountryCode || country;
        orderInfo.newOrder = true;
        orderInfo.acceptDocuments = this.acceptPaymentDocuments;
        this.messageService.setOrderHistoryTab(orderInfo);
    };
    PosOrderPromotionComponent.prototype.prepareOrderRequest = function () {
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        var orderTypeId = PurchaseFlow.Personal_Order;
        // Updating the orderType ID based on the memberId
        var memberTitleId = this.memberInfo ? this._orderService.getMemberTitleId(this.memberInfo) : MemberLevel.RETAIL;
        if (this.memberTypeId === this.memberTypeEnum.GUEST || this.memberTypeId === this.memberTypeEnum.RETAIL) {
            orderTypeId = PurchaseFlow.Retail;
        }
        var orderRequest = {
            backDateOrder: this.posOrderFormGroup.value.backDateOrder,
            countryCode: this.selectedIsoCountryCode,
            orderStatusId: OrderStatus.Pending,
            memberId: this.memberInfo ? this.memberInfo.memberId : null,
            email: this.memberInfo ? this.memberInfo.email : null,
            languageCode: this.languageShortCode,
            languageCulture: this.storeDefaultLanguage,
            storeId: this.storeInfo.id,
            orderTypeId: orderTypeId,
            memberLevelId: memberTitleId,
            importFeeValue: this.importFeeValue,
            distrubutorId: this.memberInfo && this.memberInfo.fboId ? this.memberInfo.fboId : null,
            orderSubTotal: this.calculateItemsSubTotal(this.storeInfo),
            orderTotalAfterDiscount: null,
            orderTotal: this.calculateOrderTotal(),
            orderTax: this.taxableAmount,
            currencyId: this.storeInfo.currencyId,
            source: OrderSourceTypes.POS,
            orderGroupId: this.orderType.REGULAR,
            orderLineItems: this.getOrderLineItems(this.countryTaxInclusive),
            orderShippings: this.getOrderShippings(),
            orderDiscounts: null,
            orderPayments: [],
            billingAddressModel: null,
            addresses: this.getAddresses(),
            currencyCode: this.storeInfo.currencyCode,
            createdBy: this.userInfo ? this.userInfo.userId : null,
            loggedInUserId: this.userInfo ? this.userInfo.userId : null,
            loggedInUserName: this.userInfo ? this.userInfo.userName : null,
            taxMetaData: this.orderTaxResponse ? this.orderTaxResponse.taxMetaData : null,
            erpTaxMetaData: this.orderTaxResponse ? this.orderTaxResponse.erpTaxMetaData : null,
            priceTierName: this.getPriceTier(),
            wholesaleQualified: this.memberInfo && this.memberInfo.wholeSaleQualified ? this.memberInfo.wholeSaleQualified : false,
            memberTypeId: this.memberTypeId,
            sponsorId: this.memberInfo ? this.memberInfo.sponsorId : this.sponsorInformation
                ? this.sponsorInformation.sponsorId : null,
            personalDiscountPercentage: this.memberInfo ? this._commonService.getDiscountPerc(this.memberDiscountPercentage)
                : this.personalDiscountPercentage,
            memberLevelDiscount: this.memberInfo ? this._commonService.getDiscountPerc(this.memberDiscountPercentage) : 0,
            wholesaleQualifiedDiscount: this.memberInfo ?
                this._commonService.getWholesaleQualifiedDisc(this._orderService
                    .getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId)) : 0,
            optIn: this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false,
            vatRegistered: this.memberInfo && this.memberInfo.vatRegistered ? this.memberInfo.vatRegistered : false,
            vatID: this.memberInfo && this.memberInfo.vatRegistered ? this.memberInfo.governmentId : null,
            accountLevelId: this._commonService.getMemberAccountLevelId(this.memberInfo),
            businessEntityId: this.businessEntityId,
            overrideMinimumLimit: this.isOverrideMinimumLimit,
            sourceTypeId: 5
        };
        console.log('DATA build');
        return orderRequest;
    };
    PosOrderPromotionComponent.prototype.getCountryTaxInclusiveInfo = function (country) {
        var countryTaxInclusive = false;
        if (country && country.countryMetadata &&
            country.countryMetadata.length > 0 &&
            country.countryMetadata[0].metadata) {
            countryTaxInclusive = (country.countryMetadata[0].metadata[0].value === 'TRUE') ? true : false;
        }
        return countryTaxInclusive;
    };
    PosOrderPromotionComponent.prototype.comparePriceTier = function (orderRequest, requestUrl) {
        var _this = this;
        var memberDetails = this.memberInfo ? this.memberInfo : null;
        if (orderRequest && orderRequest.orderLineItems && orderRequest.orderLineItems.length > 0 && memberDetails) {
            var wholesaleQualified = memberDetails && memberDetails.wholeSaleQualified
                ? memberDetails.wholeSaleQualified : false;
            var optin = memberDetails && memberDetails.optin ? memberDetails.optin : false;
            var memberTitleId = memberDetails && memberDetails.memberLevelId
                ? this.memberInfo.memberLevelId : memberDetails && memberDetails.memberTitleId ? memberDetails.memberTitleId : null;
            var memberTypeId = memberDetails && memberDetails.memberTypeId ? memberDetails.memberTypeId : null;
            // HARD_DOWNGRADE CHECK FOR FPC USERS
            memberTitleId = this._orderService.getDowngradeTitleID(memberTypeId, memberTitleId);
            this._orderService.getPriceTierByMemberId(this.storeInfo.id, memberTitleId, wholesaleQualified, optin, this.storeInfo.taxInclusive).subscribe(function (response) {
                if (response && response.priceTireName) {
                    var priceTierName_1 = response.priceTireName;
                    var isPriceTierMatched_1 = true;
                    orderRequest.orderLineItems.forEach(function (item) {
                        if (priceTierName_1 !== item.priceTierName) {
                            isPriceTierMatched_1 = false;
                        }
                    });
                    _this.checkLineItemsPriceTier(isPriceTierMatched_1, orderRequest, requestUrl);
                }
                else {
                    _this.checkLineItemsPriceTier(false, orderRequest, requestUrl);
                }
            }, function (error) {
                _this.enablePaymentBlock(false);
                _this.checkLineItemsPriceTier(false, orderRequest, requestUrl);
            });
        }
        else {
            this.checkLineItemsPriceTier(true, orderRequest, requestUrl);
        }
    };
    /**
     * @description check line items pricetier
     * @date 2019-10-16
     * @param {boolean} isPlaceOrder
     * @param {*} orderRequest
     * @returns {void}
     * @memberof OrderPromotionComponent
     */
    PosOrderPromotionComponent.prototype.checkLineItemsPriceTier = function (isPlaceOrder, orderRequest, requestUrl) {
        if (isPlaceOrder) {
            this.submitOrderBasedOnPriceTierCheck(orderRequest, requestUrl);
        }
        else {
            if (orderRequest.orderLineItems && orderRequest.orderLineItems.length > 0) {
                var productIds = orderRequest.orderLineItems.map(function (item) { return item.productId; });
                if (productIds && productIds.length) {
                    this.posOrderFormGroup.get('items').reset();
                    var arr = this.posOrderFormGroup.controls.items;
                    arr.controls = [];
                    this.getProductsByIds(productIds, this.storeInfo);
                    var notification = this._translatePipe.get('order.Product prices are updated. please verify and submit order');
                    this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    this.isSubmitted = false;
                }
            }
            this.enablePaymentBlock(false);
        }
    };
    /**
     * @description submit Order
     * @date 2019-10-17
     * @param {*} orderRequest
     * @memberof OrderPromotionComponent
     */
    PosOrderPromotionComponent.prototype.submitOrderBasedOnPriceTierCheck = function (orderRequest, requestUrl) {
        var _this = this;
        if (orderRequest) {
            this.enablePaymentBlock(true);
            this._orderService.createNewOrder(orderRequest, requestUrl).subscribe(function (response) {
                if (response) {
                    if (response.json().status === 'COMPLETED' && response.json().responseModel
                        && response.json().responseModel.success) {
                        if (_this.appConfig && _this.appConfig.freeShippingFPCOrder) {
                            _this.removeMemberDiscountOffer(_this.memberInfo.memberId);
                        }
                        _this.paymentComponentSettings.webOrderId = response.json().responseModel.webOrderId;
                        _this.paymentComponentSettings.orderReferenceId = response.json().responseModel.id;
                        _this.CreatePOSOrderInfo = response.json().responseModel;
                        _this._cacheService.set(CacheKey.CREATE_POS_ORDER_INFO_SESSION_CODE, response.json().responseModel);
                        // this.createOrderLog(response.json().responseModel);
                        // this.orderSuccess(response.json().responseModel);
                        var subTotal = _this.calculateItemsSubTotal(_this.storeInfo);
                        _this.isOverrideMinimumLimit && _this.hasMinimumOverrideLimit && subTotal <= _this.orderRules.minValue ? true : false;
                        _this.onEnterPaymentDetailsClick();
                    }
                    else if (response.json().responseModel.validations.some(function (x) { return x.code === ResponseStatus.TAX_ERROR; })) {
                        _this._commonService.createNotification('', 'Tax is not calculated. Please Click Enter Payment Details to proceed', NotificationType.ERROR);
                        _this.isPaymentBlockEnabled = false;
                    }
                    else if (response.json().responseModel.validations.find(function (x) { return x.field === 'VAT REGITSTER'; })) {
                        var notification = _this._translatePipe.get('order.VAT Registered Price Error');
                        _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    }
                    else if (response.json().responseModel && response.json().responseModel.validations.length > 0) {
                        _this._commonService.createNotification('', response.json().responseModel.validations[0].message, NotificationType.ERROR);
                    }
                    _this.isSubmitted = false;
                }
            }, function (error) {
                var notification = _this._translatePipe.get('order.The order cannot be created at this time. Please try again later.');
                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                _this.isSubmitted = false;
                _this.enablePaymentBlock(false);
            });
        }
    };
    /**
* @returns OrderLineItem
*/
    PosOrderPromotionComponent.prototype.getOrderLineItems = function (countryTaxInclusive) {
        var _this = this;
        var lineItems = [];
        // const items: any = this.posOrderFormGroup.get('items');
        if (this.products && this.products.length > 0) {
            var itemLineNumber_1 = 0;
            var lineItemTax_1;
            this.products.sort(function (x, y) {
                return (x.comboBOMEnabled === y.comboBOMEnabled) ? 0 : x.comboBOMEnabled ? 1 : -1;
            });
            this.products.forEach(function (product) {
                if (product) {
                    var unitPrice = countryTaxInclusive ? product.applicablePrice : product.catalogPrice;
                    var retailPrice = countryTaxInclusive ? product.retailPrice : product.baseRetailPrice;
                    var wholesalePrice = countryTaxInclusive ? product.wholesalePrice : product.baseWholesalePrice;
                    if (_this.displayPriceConfig) {
                        unitPrice = _this.displayPriceConfig.displayApplicablePrice ? product.applicablePrice :
                            (_this.displayPriceConfig.displayComputedTaxInclusivePrice ? product.computedTaxInclusivePrice :
                                (_this.displayPriceConfig.displayCatalogPrice ? product.catalogPrice : product.applicablePrice));
                        retailPrice = _this.displayPriceConfig.displayRetailPrice ? product.retailPrice :
                            _this.displayPriceConfig.displayBaseRetailPrice ? product.baseRetailPrice : product.retailPrice;
                        wholesalePrice = _this.displayPriceConfig.displayWholesalePrice ? product.wholesalePrice :
                            _this.displayPriceConfig.displayBaseWholesalePrice ? product.baseWholesalePrice : product.wholesalePrice;
                    }
                    if (_this.orderTaxResponse && _this.orderTaxResponse.cart && _this.orderTaxResponse.cart.orderLineItems
                        && _this.orderTaxResponse.cart.orderLineItems.length > 0) {
                        lineItemTax_1 = _this.orderTaxResponse.cart.orderLineItems.find(function (y) { return y.itemNumber === product.itemNumber; });
                    }
                    var unitDiscountPrice = _this.memberInfo && _this.memberInfo.transactionalWholesaleQualified ?
                        (product.baseWholesalePrice - product.catalogPrice) : 0;
                    var lineItem = {
                        discountPercentage: product.discountPercentage,
                        literature: product.literature,
                        orderLineNumber: ++itemLineNumber_1,
                        productId: product.id,
                        itemNumber: product.itemNumber,
                        productName: product.displayName ? product.displayName : product.name,
                        unitRetailPrice: retailPrice,
                        unitWholeSalePrice: wholesalePrice,
                        unitBaseWholeSalePrice: product.baseWholesalePrice,
                        unitPaidPrice: unitPrice,
                        taxInclusive: (_this.checkoutConfig && _this.checkoutConfig.storeTaxExclusivePrice) ? false : countryTaxInclusive,
                        unitTaxExclusiveRetailPrice: product.baseRetailPrice,
                        unitTaxExclusivePaidPrice: product.catalogPrice,
                        unitCommissionablePrice: 0,
                        importedMeasurementUnit: product.importedMeasurementUnit,
                        revisionNumber: product.revisionNumber,
                        taxRate: product.taxRate || 0,
                        unitTax: lineItemTax_1 ? lineItemTax_1.salesTax : 0,
                        unitTaxablePrice: lineItemTax_1 && lineItemTax_1.taxablePrice ? lineItemTax_1.taxablePrice : 0,
                        unitQualificationValue: product.commissionableVolume || 0,
                        quantity: product.quantity,
                        freeshipping: false,
                        shippable: product.shipping ? product.shipping.shippingRequired : null,
                        fboEligible: _this.getFBOEigibleProduct(product),
                        downloadActivated: product.downloadableProduct,
                        weight: product.shipping ? product.shipping.weight : null,
                        height: product.shipping ? product.shipping.height : null,
                        length: product.shipping ? product.shipping.length : null,
                        width: product.shipping ? product.shipping.width : null,
                        // totalAmount: this._currencyPipe.getFormatedCurrency(x.applicablePrice * x.quantity),
                        totalAmount: _this._currencyPipe.getFormatedCurrency(_this.getItemTotalSum(product), _this.storeInfo),
                        discountAmount: _this._currencyPipe.getFormatedCurrency(_this.calculateDiscountAmount(product, _this.displayPriceConfig), _this.storeInfo),
                        personalDiscount: _this._currencyPipe.getFormatedCurrency(((parseFloat(product.retailPrice.toFixed(2)) * product.quantity
                            * _this.personalDiscountPercentage) / 100), _this.storeInfo),
                        priceTierName: product.priceTierName,
                        netUnitPrice: _this.appConfig && _this.appConfig.calculateNetUnitPrice
                            && _this.memberInfo && _this.memberInfo.transactionalWholesaleQualified
                            && _this.memberInfo.transactionalOptin ? _this.calculateNetUnitPrice(product) : 0,
                        unitDiscount: unitDiscountPrice,
                        lineDiscount: unitDiscountPrice * product.quantity,
                        comboBOMEnabledProduct: product.display ? (product.display.comboBOMEnabled ? true : false) : false,
                        depositFeeProduct: product.display ? (product.display.depositFeeProduct ? true : false) : false,
                        depositFeeEnabledProduct: product.productMetaData ? (product.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1'; }) ? true : false) : false,
                        shippableFulfillment: product.shipping ? (product.shipping.shippableFulfillment ? true : false) : false
                    };
                    lineItems.push(lineItem);
                }
            });
        }
        return lineItems;
    };
    /**
     * @description get FBO eligible product
     * @date 2019-07-04
     * @private
     * @param {Product} product
     * @returns {boolean}
     * @memberof OrderPromotionComponent
     */
    PosOrderPromotionComponent.prototype.getFBOEigibleProduct = function (product) {
        if (product.productMetaData) {
            var fboEligibilty = product.productMetaData.
                find(function (x) { return x.metaTitle === ProductMetatDataValue.DISTRIBUTORELIGIBLE; });
            if (fboEligibilty && fboEligibilty.metaKeyWords === '1') {
                return true;
            }
        }
    };
    PosOrderPromotionComponent.prototype.getOrderShippings = function () {
        var _this = this;
        var orderShippings = [];
        var selectedPOSLocation = this.posLocations.find(function (location) {
            return location.id === +_this.posOrderFormGroup.controls['posLocation'].value;
        });
        var orderShipping = {
            deliveryPreferenceId: DeliveryPreference.PICKUP,
            shipMethodId: this.posOrderFormGroup.value.posLocation,
            shortCode: this.shipMethod.shortCode,
            distributionCenter: selectedPOSLocation ? selectedPOSLocation.name : ''
        };
        orderShippings.push(orderShipping);
        return orderShippings;
    };
    /**
      * @returns payment method
      */
    PosOrderPromotionComponent.prototype.getPaymentMethodById = function (paymentMethodId) {
        var paymentType;
        switch (paymentMethodId) {
            case this.paymentTypeEnum.Credit_Card:
                paymentType = PaymentMethodTypes.Credit_Card;
                break;
            case this.paymentTypeEnum.eCheck:
                paymentType = PaymentMethodTypes.eCheck;
                break;
            case this.paymentTypeEnum.Money_order:
                paymentType = PaymentMethodTypes.Money_order;
                break;
            case this.paymentTypeEnum.Cash:
                paymentType = PaymentMethodTypes.Cash;
                break;
            case this.paymentTypeEnum.Ideal:
                paymentType = PaymentMethodTypes.Ideal;
                break;
            case this.paymentTypeEnum.PayPal:
                paymentType = PaymentMethodTypes.PayPal;
                break;
            case this.paymentTypeEnum.Cash_On_Delivery:
                paymentType = PaymentMethodTypes.Cash_On_Delivery;
                break;
            case this.paymentTypeEnum.Bank_Transfer:
                paymentType = PaymentMethodTypes.Bank_Transfer;
                break;
            case this.paymentTypeEnum.Direct_Debit:
                paymentType = PaymentMethodTypes.Direct_Debit;
                break;
            default:
                paymentType = PaymentMethodTypes.Credit_Card;
                break;
        }
        return paymentType;
    };
    PosOrderPromotionComponent.prototype.getAddresses = function () {
        var addresses = [];
        var pickupAddress = this.getPickUpAddress();
        if (pickupAddress) {
            pickupAddress.deliveryInstruction = pickupAddress && pickupAddress.instruction ? pickupAddress.instruction : '';
            pickupAddress.email = pickupAddress.email ? pickupAddress.email : null;
            addresses.push(pickupAddress);
        }
        if (this.posOrderFormGroup.controls['paymentSelector'].value === this.selectEnum.secondOption.toString()) {
            addresses.push(this.getBillingAddress());
        }
        return addresses;
    };
    PosOrderPromotionComponent.prototype.calculateOrderTotal = function () {
        var totalCost = 0;
        var calculateVatTax = true;
        if (this.memberInfo && this.memberInfo.vatRegistered
            && this.countryTaxInclusive) {
            if ((this.appConfig && this.appConfig.enableVatItemizationForNonVat) || this.appConfig.displayTaxInclusivePrice) {
                if (this.appConfig && this.appConfig.calculateVatForVatRegisterUser) {
                    calculateVatTax = true;
                }
                else {
                    calculateVatTax = false;
                }
            }
            totalCost = this.calculateItemsSubTotal(this.storeInfo) + (this.importFeeValue) + (this.handlingCharges) + (calculateVatTax ? this.taxableAmount || 0 : 0);
        }
        else {
            if (this.appConfig && this.appConfig.enableVatItemizationForNonVat) {
                if (this.memberInfo && this.memberInfo.memberTypeId === this.memberTypeEnum.DISTRIBUTOR) {
                    calculateVatTax = true;
                }
                else {
                    calculateVatTax = false;
                }
            }
            var isCalculateTaxExclusivePrice = this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice;
            totalCost = this.calculateItemsSubTotal(this.storeInfo) + (this.importFeeValue) + (this.handlingCharges)
                + ((this.countryTaxInclusive === false || isCalculateTaxExclusivePrice) ? (calculateVatTax ? this.taxableAmount || 0 : 0) : 0);
        }
        if (this.storeInfo) {
            totalCost = Number(totalCost.toFixed(Math.max(0, ~~this.storeInfo.numberDecimals)));
        }
        this.orderTotal = totalCost;
        return totalCost;
    };
    /**
   * @param  {any} shippingInfo
   * @returns void
   */
    PosOrderPromotionComponent.prototype.calculateOrderTax = function () {
        var _this = this;
        this.taxCalculationStatus = true;
        this.orderTaxResponse = null;
        if (this.storeInfo && this.products && this.products.length > 0 && this.shippingMethodId) {
            var taxRequest = this.prepareTaxRequest();
            if (taxRequest && taxRequest.fromAddress && taxRequest.toAddress) {
                this._orderService.calculateOrderTax(taxRequest)
                    .subscribe(function (taxResponse) {
                    _this.disableQty = false;
                    if (taxResponse && taxResponse.success) {
                        _this.isTaxMetaDataAvailable = taxResponse.taxMetaData ? true : false;
                        if (taxResponse.cart && taxResponse.cart.totalTax >= 0) {
                            taxResponse.cart.totalTax = _this._currencyPipe.getFormatedCurrency(taxResponse.cart.totalTax, _this.storeInfo);
                            _this.orderTaxResponse = taxResponse;
                            _this.taxableAmount = taxResponse.cart.totalTax;
                            if (_this.orderTaxResponse && _this.orderTaxResponse.taxMetaData
                                && _this.orderTaxResponse.taxMetaData.orderTaxCharges
                                && _this.orderTaxResponse.taxMetaData.orderTaxCharges.length > 0) {
                                var gst = _this.orderTaxResponse.taxMetaData
                                    .orderTaxCharges.find(function (tax) { return tax.taxChargeType === TaxType.GST_TAX; });
                                var pst = _this.orderTaxResponse.taxMetaData
                                    .orderTaxCharges.find(function (tax) { return tax.taxChargeType === TaxType.PST_TAX; });
                                _this.gstTax = gst ? gst.taxAmount : 0;
                                _this.pstTax = pst ? pst.taxAmount : 0;
                                // if (this.countryTaxInclusive) {
                                //     const shippingLineItem = this.orderTaxResponse.taxMetaData
                                //         .orderTaxCharges.find(tax => tax.taxChargeType === TaxType.NOR && tax.lineNo === 0);
                                //     if (shippingLineItem) {
                                //         this.shippingTax = shippingLineItem.taxAmount;
                                //     }
                                // }
                            }
                        }
                        setTimeout(function () {
                            _this.taxCalculationStatus = false;
                        }, 500);
                    }
                }, function (error) {
                    if (error) {
                        var taxResponse = error;
                        if (taxResponse && taxResponse.validations && taxResponse.validations.length > 0) {
                            if ((taxResponse.validations.map(function (validation) { return validation.name; }).indexOf(CommonConstant.Order_Tax)) > -1) {
                                var notification = _this._translatePipe.get('order.Tax cannot be calculated now. Please try again later.');
                                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                            }
                            else {
                                var notification = _this._translatePipe.get('order.' + taxResponse.validations[0].message);
                                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                            }
                        }
                        _this.disableQty = false;
                    }
                });
            }
        }
        console.log("calculateOrderTax taxCalculationStatus", decodeURIComponent(encodeURIComponent(String(this.taxCalculationStatus))));
    };
    PosOrderPromotionComponent.prototype.prepareTaxRequest = function () {
        var _this = this;
        var memberTitleId = this.memberInfo ? this._orderService.getMemberTitleId(this.memberInfo) : MemberLevel.RETAIL;
        var posLocation = this.posLocations.find(function (x) { return x.id === _this.shippingMethodId; });
        var taxRequest = {
            orderID: 0,
            memberID: this.memberInfo ? this.memberInfo.memberId : null,
            shopingCart: this.mapCartToTaxCart(),
            fromAddress: this.getPickUpAddress(),
            toAddress: this.getPickUpAddress(),
            memberNumber: this.memberInfo ? this.memberInfo.fboId : null,
            orderNumber: 0,
            storeID: posLocation ? posLocation.storeId : null,
            priceTierName: this.getPriceTier(),
            currencyCode: this.storeInfo.currencyCode,
            countryCode: this.selectedIsoCountryCode.toLowerCase(),
            deliveryTypeId: ShippingType.PICKUP,
            orderSource: 'POS',
            orderTypeId: 2,
            conversionRate: 1,
            memberLevelId: memberTitleId,
            wholesaleQualified: this.memberInfo ? this.memberInfo.wholeSaleQualified : null,
            vatRegistered: this.memberInfo && this.memberInfo.vatRegistered ? this.memberInfo.vatRegistered : false,
            isDiscountedShipping: this.posOrderFormGroup.value.isShippingDiscountApplied,
            memberType: MemberTypeEnum[this.memberTypeId]
        };
        return taxRequest;
    };
    /**
      * @returns TaxCart
      */
    PosOrderPromotionComponent.prototype.mapCartToTaxCart = function () {
        var taxCart = {
            shippingTax: 0,
            shipMethodId: this.shippingMethodId,
            importFeeValue: this.importFeeValue || 0,
            importFeeEnabled: this.importFeeEnabled,
            orderLineItems: this.mapItemstoTaxItems()
        };
        return taxCart;
    };
    /**
     * @returns CartItems
     */
    PosOrderPromotionComponent.prototype.mapItemstoTaxItems = function () {
        var _this = this;
        var address = this.getPickUpAddress();
        var taxItems = [];
        if (this.products && this.products.length > 0) {
            var itemLineNumber_2 = 0;
            if (address && address.countryId && this.countries && this.countries.length > 0) {
                var country = this.countries.find(function (x) { return x.countryId === address.countryId; });
                this.countryTaxInclusive = this.getCountryTaxInclusiveInfo(country);
            }
            this.products.forEach(function (x) {
                var taxablePrice;
                var paidPrice;
                if (_this.checkoutConfig && _this.checkoutConfig.calculateTaxExclusivePrice) {
                    taxablePrice = x.catalogPrice;
                    paidPrice = x.applicablePrice;
                }
                else {
                    taxablePrice = ((_this.checkoutConfig.catalogPriceAsTaxablePrice ||
                        (address && address.stateCode && address.stateCode === 'PR')) ? x.catalogPrice : x.retailPrice);
                    paidPrice = ((_this.checkoutConfig.applicablePriceAspaidPrice ||
                        (address && address.stateCode && address.stateCode === 'PR')) ? x.applicablePrice : x.retailPrice);
                }
                var taxItem = {
                    lineNumber: ++itemLineNumber_2,
                    itemNumber: x.itemNumber,
                    taxablePrice: _this.getTaxablePrice(taxablePrice, x),
                    quantity: +x.quantity,
                    taxCode: null,
                    description: '',
                    taxInclusive: _this.countryTaxInclusive ? true : false,
                    resale: false,
                    resalePrice: 0,
                    taxBreakDown: x.taxBreakDown,
                    productIdentifier: null,
                    retailPrice: x.retailPrice,
                    paidPrice: _this.getPaidPrice(paidPrice, x),
                    wholeSalePrice: x.wholesalePrice,
                    salesTax: 0,
                    revisionNumber: x.revisionNumber,
                    itemWeight: x.shipping && x.shipping.weight ? x.shipping.weight : 0,
                    importedMeasurementUnit: x.importedMeasurementUnit,
                    unitTaxExclusiveRetailPrice: x.baseRetailPrice,
                    computedTaxInclusivePrice: x.computedTaxInclusivePrice,
                    comboBOMEnabled: x.display ? (x.display.comboBOMEnabled ? x.display.comboBOMEnabled : false) : false,
                    computedComboTaxTotals: x.computedComboTaxTotals && x.computedComboTaxTotals.length > 0 ? x.computedComboTaxTotals : []
                };
                taxItems.push(taxItem);
            });
        }
        return taxItems;
    };
    PosOrderPromotionComponent.prototype.getTaxablePrice = function (taxablePrice, item) {
        var enableWHLSAL00ForAsstSupervisor = this._commonService.isWHLSAL00enabledForAsstSupervisor(this.selectedIsoCountryCode);
        if (this.appConfig && this.appConfig.calculateNetUnitPrice
            && this.memberInfo && this.memberInfo.transactionalWholesaleQualified
            && this.memberInfo.transactionalOptin && !this.memberInfo.vatRegistered &&
            (this.memberInfo.memberTitleId > MemberLevel.ASSISTANTSUPERVISOR
                || this.memberInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
                    && enableWHLSAL00ForAsstSupervisor)) {
            return this.calculateNetUnitPrice(item);
        }
        else if (this.memberInfo && this.memberInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
            && !enableWHLSAL00ForAsstSupervisor) {
            return item.catalogPrice;
        }
        else if (this.checkoutConfig && this.checkoutConfig.applicablePriceAsTaxablePrice && (item.priceTierName === PriceTier.NEWDST || item.priceTierName === PriceTier.WHLSAL)) {
            return item.applicablePrice;
        }
        else {
            return taxablePrice;
        }
    };
    PosOrderPromotionComponent.prototype.getPaidPrice = function (paidPrice, item) {
        if (this.checkoutConfig && this.checkoutConfig.applicablePriceAsTaxablePrice && (item.priceTierName === PriceTier.NEWDST || item.priceTierName === PriceTier.WHLSAL)) {
            return item.applicablePrice;
        }
        else {
            return paidPrice;
        }
    };
    PosOrderPromotionComponent.prototype.getPriceTier = function () {
        var priceTierName = '';
        if (this.products && this.products.length > 0) {
            priceTierName = this.products[0].priceTierName;
        }
        return priceTierName;
    };
    PosOrderPromotionComponent.prototype.addNewProductItem = function (items, index, product) {
        var itemValue = product.itemNumber + ' - ' + product.name;
        items.controls[index].controls['itemNumber'].setValue(itemValue);
        var itemImage = (product.imageModelList && product.imageModelList.length > 0)
            ? (product.imageModelList[0].details.find(function (imageDetail) { return imageDetail.type === ImageType.Thumbnail; })) : '';
        var imageUrl = (itemImage && itemImage.url) ? (environment.cdnURL + '/' + itemImage.url)
            : (environment.uiTemplateBaseUrl + '/images/no_image.png');
        var isDepositFeeProduct = product.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_PRODUCT && x.metaKeyWords === '1'; });
        var depositFeeEnabled = product.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1'; });
        items.controls[index].controls['productImage'].setValue(imageUrl);
        items.controls[index].controls['productNumber'].setValue(product.itemNumber);
        items.controls[index].controls['productName'].setValue(product.displayName ? product.displayName : product.name);
        items.controls[index].controls['productId'].setValue(product.id);
        items.controls[index].controls['productItem'].setValue(product);
        items.controls[index].controls['disableIncrement'].setValue(false);
        items.controls[index].controls['isDepositFeeProduct'].setValue(!!isDepositFeeProduct);
        items.controls[index].controls['depositFeeEnabled'].setValue(!!depositFeeEnabled);
        return items;
    };
    PosOrderPromotionComponent.prototype.checkStockAvalible = function (product) {
        var _this = this;
        var productids = [];
        productids.push(product.id);
        this._customerService.getProductsByLocation(this.currentPosLocation.id, productids)
            .subscribe(function (response) {
            _this.productwareHouseLocation = response;
            if (_this.productwareHouseLocation && _this.productwareHouseLocation.length > 0) {
                return true;
            }
            if (_this.productwareHouseLocation && _this.productwareHouseLocation.length == 0) {
                return true;
            }
        });
    };
    PosOrderPromotionComponent.prototype.setFocusbyID = function (id) {
        setTimeout(function () {
            var element = document.getElementById(id);
            if (element) {
                element.focus();
                element.select();
            }
        }, 500);
    };
    PosOrderPromotionComponent.prototype.moveToItemLevelSearchBlock = function (event) {
        if (this.itemLevelSearch && this.itemLevelSearch.nativeElement) {
            this.itemLevelSearch.nativeElement.focus();
        }
    };
    /**
     * @description item number search in table
     * @date 2019-09-25
     * @param {*} event
     * @memberof OrderPromotionComponent
     */
    PosOrderPromotionComponent.prototype.itemLevelSearchEvent = function (event) {
        if (event.currentTarget.value && this.posOrderFormGroup && this.posOrderFormGroup.value && this.posOrderFormGroup.value.items.length > 0) {
            var items = this.posOrderFormGroup.get('items');
            var product = this.posOrderFormGroup.value.items.find(function (i) { return i.productNumber === event.currentTarget.value; });
            var sameProductIndex = items.controls.findIndex(function (item) {
                return item.controls['productNumber'].value === event.currentTarget.value;
            });
            if (sameProductIndex >= 0 && product) {
                this.incrementQuantity(sameProductIndex);
                this.posOrderFormGroup.controls['itemLevelSearch'].setValue('');
            }
            else {
                this.itemLevelSearchEventUpdate(event);
            }
        }
        else {
            this.itemLevelSearchEventUpdate(event);
        }
    };
    PosOrderPromotionComponent.prototype.itemLevelSearchEventUpdate = function (event) {
        var _this = this;
        if (event.currentTarget.value) {
            this.taxCalculationStatus = true;
            this.observableSource(event.currentTarget.value, true).subscribe(function (products) {
                var responseproducts = products;
                if (responseproducts.length > 0) {
                    var product_1 = responseproducts[0];
                    if (product_1 && product_1.id) {
                        _this._customerService.getProductsByLocation(_this.currentPosLocation.id, [product_1.id])
                            .subscribe(function (response) {
                            _this.productwareHouseLocation = response;
                            var items = _this.posOrderFormGroup.get('items');
                            if (_this.productwareHouseLocation && _this.productwareHouseLocation.length > 0) {
                                if (_this.productwareHouseLocation[0].manageStock && _this.productwareHouseLocation[0].stockQuantity > 0) {
                                    if (items && items.length >= 0) {
                                        var sameProductIndex = items.controls.findIndex(function (item) {
                                            return item.controls['productNumber'].value === product_1.itemNumber;
                                        });
                                        if (sameProductIndex >= 0) {
                                            if (+items.controls[sameProductIndex].controls['quantity'].value + 1 <= _this.productwareHouseLocation[0].stockQuantity) {
                                                items.controls[sameProductIndex].controls['quantity']
                                                    .setValue(+items.controls[sameProductIndex].controls['quantity'].value + 1);
                                                _this.setFocusbyID('quantity-' + (sameProductIndex));
                                            }
                                            else {
                                                var addedNotification = 'can not add product ' + items.value[sameProductIndex].productName + ' Avalible Quantity ' + _this.productwareHouseLocation[0].stockQuantity;
                                                _this._commonService.createNotification('', addedNotification, NotificationType.ERROR);
                                                if (_this.itemLevelSearch && _this.itemLevelSearch.nativeElement) {
                                                    _this.itemLevelSearch.nativeElement.focus();
                                                }
                                                _this.taxCalculationStatus = false;
                                            }
                                        }
                                        else {
                                            _this.addItemNumber();
                                            var index = (items.length - 1);
                                            items.controls[index].controls['quantity'].setValidators([Validators.required]);
                                            if (!items.controls[index].controls['quantity'].value) {
                                                items.controls[index].controls['quantity'].setValue(1);
                                            }
                                            items.controls[index].controls['quantity'].updateValueAndValidity();
                                            items = _this.addNewProductItem(items, index, product_1);
                                            _this.setFocusbyID('quantity-' + (items.length - 1));
                                        }
                                    }
                                    _this.updateTotalsAndShipMethod();
                                    _this.getHandlingFeeCharges();
                                }
                                if (_this.productwareHouseLocation[0].manageStock && _this.productwareHouseLocation[0].stockQuantity <= 0) {
                                    var addedNotification = 'Out of stock -' + product_1.displayName;
                                    if (_this.taxCalculationStatus) {
                                        _this.taxCalculationStatus = false;
                                    }
                                    _this._commonService.createNotification('', addedNotification, NotificationType.ERROR);
                                    _this.posOrderFormGroup.controls['itemSearch'].setValue('');
                                }
                                if (!_this.productwareHouseLocation[0].manageStock) {
                                    _this.addItemNumber();
                                    var index = (items.length - 1);
                                    items.controls[index].controls['quantity'].setValidators([Validators.required]);
                                    if (!items.controls[index].controls['quantity'].value) {
                                        items.controls[index].controls['quantity'].setValue(1);
                                    }
                                    items.controls[index].controls['quantity'].updateValueAndValidity();
                                    items = _this.addNewProductItem(items, index, product_1);
                                    _this.setFocusbyID('quantity-' + (items.length - 1));
                                    _this.updateTotalsAndShipMethod();
                                    _this.getHandlingFeeCharges();
                                }
                            }
                            if (_this.productwareHouseLocation && _this.productwareHouseLocation.length == 0) {
                                _this.addItemNumber();
                                var index = (items.length - 1);
                                items.controls[index].controls['quantity'].setValidators([Validators.required]);
                                if (!items.controls[index].controls['quantity'].value) {
                                    items.controls[index].controls['quantity'].setValue(1);
                                }
                                items.controls[index].controls['quantity'].updateValueAndValidity();
                                items = _this.addNewProductItem(items, index, product_1);
                                _this.setFocusbyID('quantity-' + (items.length - 1));
                                _this.updateTotalsAndShipMethod();
                                _this.getHandlingFeeCharges();
                            }
                            var isDepositFeeProductEnabled = product_1.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1'; });
                            if (isDepositFeeProductEnabled && _this.productwareHouseLocation && _this.productwareHouseLocation.length > 0 &&
                                ((_this.productwareHouseLocation[0].manageStock && _this.productwareHouseLocation[0].stockQuantity > 0) || !_this.productwareHouseLocation[0].manageStock)) {
                                _this.getDepositFeeProduct(product_1);
                                _this.updateTotalsAndShipMethod();
                                _this.getHandlingFeeCharges();
                            }
                        }, function (error) {
                            var errorMessage = _this._translatePipe.get('common.Sorry, Something Went Wrong: Please try again later.');
                            _this._commonService.createNotification('', errorMessage.value, NotificationType.ERROR);
                        });
                    }
                }
                else {
                    var items = _this.posOrderFormGroup.get('items');
                    if (items && items.length > 0) {
                        if (_this.taxCalculationStatus) {
                            _this.taxCalculationStatus = false;
                        }
                    }
                    if (_this.itemLevelSearch && _this.itemLevelSearch.nativeElement) {
                        _this.itemLevelSearch.nativeElement.focus();
                    }
                    var notification = _this._translatePipe.get('order.Invalid Item Number');
                    _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                }
                _this.posOrderFormGroup.controls['itemLevelSearch'].setValue('');
            });
        }
        console.log("itemLevelSearchEventUpdate taxCalculationStatus", this.taxCalculationStatus);
    };
    /**
     * @description Check stock available or not
     * @date 2019-09-25
     * @param {Product} product
     * @returns {boolean}
     * @memberof OrderPromotionComponent
     */
    PosOrderPromotionComponent.prototype.stockAvailable = function (product) {
        //return (product.manageStock && product.stockQuantity > 0) || (product.stockAvailable && !product.manageStock);
        return (product.manageStock && product.stockQuantity > 0) || !product.manageStock;
    };
    PosOrderPromotionComponent.prototype.getDepositFeeProduct = function (product) {
        var _this = this;
        this.disableQty = true;
        var depositFeeProduct = null;
        this.searchProduct = product ? product : this.searchProduct;
        var productAssociation = this.productAssociationInfo.find(function (x) { return x.productId === _this.searchProduct.id; });
        if (productAssociation) {
            depositFeeProduct = this.depsoitFeeProductsInfo.find(function (x) { return x.id === productAssociation.depositFeeProductId; });
            ;
            if (depositFeeProduct) {
                depositFeeProduct.productQuantity = 1;
                this.searchProduct = depositFeeProduct;
                this.onItemSelect(true);
            }
        }
        else {
            var wholesaleQualified = this.memberInfo && this.memberInfo.wholeSaleQualified
                ? this.memberInfo.wholeSaleQualified : false;
            var optin = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
            this._customerService.getRelatedProducts(this.storeId, this.searchProduct.id, 2, this.memberInfo.memberTitleId, this.countryCode, this.storeDefaultLanguage, this.purchaseFlowType, this.storeInfo.taxInclusive, wholesaleQualified, optin)
                .subscribe(function (response) {
                if (response && response.length) {
                    depositFeeProduct = response[0];
                    var depositFeeProductInfo = _this.depsoitFeeProductsInfo.find(function (x) { return x.id === depositFeeProduct.id; });
                    _this.productAssociationInfo.push({
                        productId: _this.searchProduct.id,
                        depositFeeProductId: depositFeeProduct.id
                    });
                    if (!depositFeeProductInfo) {
                        _this.depsoitFeeProductsInfo.push(depositFeeProduct);
                    }
                    _this.searchProduct = depositFeeProduct;
                    _this.onItemSelect(true);
                }
            });
        }
    };
    /**
     * @description auto complete search
     * @date 2019-09-25
     * @memberof OrderPromotionComponent
     */
    PosOrderPromotionComponent.prototype.onItemSelect = function (isDepositFeeProductEnabled) {
        var _this = this;
        if (!isDepositFeeProductEnabled) {
            this.searchProduct = this.posOrderFormGroup.controls['itemSearch'].value;
        }
        var items = this.posOrderFormGroup.get('items');
        var sameProductIndex = items.controls.findIndex(function (item) { return item.controls['productNumber'].value === _this.searchProduct.itemNumber; });
        if (this.searchProduct && this.searchProduct.id) {
            console.log("onItemSelect taxCalculationStatus", this.taxCalculationStatus);
            this.disablePaymentDetailButton();
            var productids = [];
            productids.push(this.searchProduct.id);
            this.posOrderFormGroup.controls['itemSearch'].setValue('');
            this._customerService.getProductsByLocation(this.currentPosLocation.id, productids)
                .subscribe(function (response) {
                _this.productwareHouseLocation = response;
                if (_this.productwareHouseLocation && _this.productwareHouseLocation.length > 0) {
                    if (_this.productwareHouseLocation[0].manageStock && _this.productwareHouseLocation[0].stockQuantity > 0) {
                        if (sameProductIndex >= 0) {
                            if (+items.controls[sameProductIndex].controls['quantity'].value + 1 <= _this.productwareHouseLocation[0].stockQuantity) {
                                _this.addProductItemtoCart();
                            }
                            else {
                                var addedNotification = 'can not add product ' + items.value[sameProductIndex].productName + ' Avalible Quantity ' + _this.productwareHouseLocation[0].stockQuantity;
                                if (_this.taxCalculationStatus) {
                                    _this.taxCalculationStatus = false;
                                }
                                _this._commonService.createNotification('', addedNotification, NotificationType.ERROR);
                                _this.posOrderFormGroup.controls['itemSearch'].setValue('');
                            }
                        }
                        else {
                            _this.addProductItemtoCart();
                        }
                    }
                    if (_this.productwareHouseLocation[0].manageStock && _this.productwareHouseLocation[0].stockQuantity <= 0) {
                        var addedNotification = 'Out of stock -' + _this.searchProduct.displayName;
                        if (_this.taxCalculationStatus) {
                            _this.taxCalculationStatus = false;
                        }
                        _this._commonService.createNotification('', addedNotification, NotificationType.ERROR);
                        _this.posOrderFormGroup.controls['itemSearch'].setValue('');
                    }
                    if (!_this.productwareHouseLocation[0].manageStock) {
                        _this.addProductItemtoCart();
                    }
                }
                if (_this.productwareHouseLocation && _this.productwareHouseLocation.length == 0) {
                    _this.addProductItemtoCart();
                }
            });
            console.log("onItemSelect taxCalculationStatus 2", this.taxCalculationStatus);
        }
        // else {
        //         this._commonService.createNotification('', 'Out of stock - '
        //             + (this.posOrderFormGroup.controls['itemSearch'].value.name || ''), NotificationType.ERROR);
        //         this.posOrderFormGroup.controls['itemSearch'].setValue('');
        //         setTimeout(() => {
        //             if (this.seachItemElement && this.seachItemElement.nativeElement) {
        //                 this.seachItemElement.nativeElement.focus();
        //             }
        //         }, 500);
        //     }
    };
    PosOrderPromotionComponent.prototype.addProductItemtoCart = function () {
        var _this = this;
        this.posOrderFormGroup.controls['itemSearch'].setValue('');
        var items = this.posOrderFormGroup.get('items');
        if (items && items.length >= 0) {
            this.taxCalculationStatus = true;
            var sameProductIndex = items.controls.findIndex(function (item) { return item.controls['productNumber'].value === _this.searchProduct.itemNumber; });
            if (sameProductIndex >= 0) {
                items.controls[sameProductIndex].controls['quantity'].setValue(+items.controls[sameProductIndex].controls['quantity'].value + 1);
                this.posOrderFormGroup.controls['itemSearch'].setValue('');
                this.setFocusbyID('quantity-' + (sameProductIndex));
            }
            else {
                this.addItemNumber();
                var index = (items.length - 1);
                items.controls[index].controls['quantity'].setValidators([Validators.required]);
                if (!items.controls[index].controls['quantity'].value) {
                    items.controls[index].controls['quantity'].setValue(1);
                }
                items.controls[index].controls['quantity'].updateValueAndValidity();
                if (this.searchProduct) {
                    var typHeadItem = this.searchProduct;
                    this.posOrderFormGroup.controls['itemSearch'].setValue('');
                    items = this.addNewProductItem(items, index, typHeadItem);
                }
                this.updateTotalsAndShipMethod();
                this.isFocused = true;
                this.setFocusbyID('quantity-' + (items.length - 1));
            }
            var isDepositFeeProductEnabled = this.searchProduct.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED; });
            if (isDepositFeeProductEnabled) {
                this.getDepositFeeProduct();
            }
            this.updateTotalsAndShipMethod();
            this.getHandlingFeeCharges();
        }
        console.log("addProductItemtoCart taxCalculationStatus", this.taxCalculationStatus);
    };
    PosOrderPromotionComponent.prototype.allowOnlyNumbers = function (event) {
        this.isFocused = false;
        if (event.keyCode !== 8) {
            var value = (event.key ? event.key : '');
            var pattern = /^[0-9]*$/;
            if (!new RegExp(pattern).test(value)) {
                event.preventDefault();
            }
        }
    };
    /**
     * @description save billing address
     * @date 2018-11-19
     * @param {Address} address
     * @memberof OrderPromotionComponent
     */
    PosOrderPromotionComponent.prototype.saveBillingAddress = function (address) {
        if (address) {
            this.billingAddressInfo = this.mapVerifiedAddressToFormFields(address);
            if (this.saveEcheckFormBtn) {
                this.saveEcheckFormBtn.nativeElement.click();
            }
        }
    };
    // *************************payvision payment section*******************************/
    /**
     * @description Load Member Saved Cards
     * @date 2018-08-30
     * @memberof PaymentComponent
     */
    PosOrderPromotionComponent.prototype.loadSavedCardsForMemberId = function (memberId, countryCode) {
        var _this = this;
        var paymentInstrumentId = this._cacheService.get(CacheKey.PaymentInstrumentId);
        this._payvisionService.getSavedPayvisonCards(memberId, countryCode, paymentInstrumentId).subscribe(function (savedCardResponse) {
            if (savedCardResponse && savedCardResponse.savedCards && savedCardResponse.savedCards.length > 0) {
                _this.paymentComponentSettings.savedCards = savedCardResponse.savedCards;
                _this.paymentComponentSettings.savedCards.forEach(function (card) {
                    card.notes = card.defaultCard ? PaymentConstants.default : '';
                });
                //  if (this.orderSession) {
                if (paymentInstrumentId) {
                    var selectedCard = _this.paymentComponentSettings.savedCards.find(function (x) { return x.id === paymentInstrumentId; });
                    if (selectedCard) {
                        var indexPostion = _this.paymentComponentSettings.savedCards.findIndex(function (x) { return x.id === paymentInstrumentId; });
                        _this.paymentComponentSettings.savedCards.splice(indexPostion, 1);
                        _this.paymentComponentSettings.savedCards.unshift(selectedCard);
                        _this.selectedpayvisionCardInfo = selectedCard;
                    }
                    _this.posOrderFormGroup.controls['paymentInstrumentId'].setValue(paymentInstrumentId);
                    _this.posOrderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
                    _this._cacheService.remove(CacheKey.PaymentInstrumentId);
                }
                else {
                    if (_this.paymentComponentSettings.savedCards && _this.paymentComponentSettings.savedCards.length > 0) {
                        var defaultCard = _this.paymentComponentSettings.savedCards.find(function (card) { return card.expired === false && card.defaultCard === true; });
                        if (defaultCard) {
                            _this.posOrderFormGroup.controls['paymentInstrumentId'].setValue(defaultCard.id);
                            _this.selectSavedCard(defaultCard);
                        }
                        else {
                            var isDefaultCard_2 = false;
                            _this.paymentComponentSettings.savedCards.forEach(function (card) {
                                if (card.expired === false && isDefaultCard_2 === false) {
                                    isDefaultCard_2 = true;
                                    _this.posOrderFormGroup.controls['paymentInstrumentId'].setValue(card.id);
                                    _this.selectSavedCard(card);
                                }
                            });
                        }
                    }
                    else {
                        _this.posOrderFormGroup.controls['paymentInstrumentId'].setValue('');
                        // this.posOrderFormGroup.controls['paymentInstrumentId'].setValidators([Validators.required]);
                        _this.posOrderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
                    }
                }
            }
            else {
                _this.paymentComponentSettings.savedCards = [];
            }
        }, function (error) {
            _this.paymentComponentSettings.isAddNewCard = false;
        });
    };
    /**
     * @description To get the card image
     * @date 2018-08-27
     * @param {*} cardType
     * @returns {string}
     * @memberof PaymentComponent
     */
    PosOrderPromotionComponent.prototype.getImagePath = function (cardType) {
        if (cardType) {
            switch (true) {
                case cardType.toUpperCase() === PaymentCardTypes.VISA:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/visa.png';
                    break;
                case (cardType.toUpperCase() === PaymentCardTypes.MASTER
                    || cardType.toUpperCase() === PaymentCardTypes.MASTER_WORLDPAY
                    || cardType.toUpperCase() === PaymentCardTypes.MASTERCARD):
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/mastercard.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.AMEX:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/amercianexpress.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.MAESTRO:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/maestro.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.DINERS:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/dinner-club.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.JCB:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/jcb.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.DISCOVER:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/discovernetwork.png';
                    break;
                default:
                    this.paymentComponentSettings.cardTypeImage = null;
                    break;
            }
        }
        return this.paymentComponentSettings.cardTypeImage;
    };
    /**
   * verified Address Mapping
   * @param  {any}  address
   * @returns any
   */
    PosOrderPromotionComponent.prototype.mapVerifiedAddressToFormFields = function (address) {
        if (address) {
            var countryObj = this.getCountryDetailsByCountryIdOrCode(null, address.country);
            var stateObj = this.getStateDetailsByStateIdOrCode(null, address.state);
            var mapAddressToFields = {
                name: address.name,
                firstName: address.firstName,
                middleName: address.middleName,
                lastName: address.lastName,
                addressLine1: address.addressLine1,
                addressLine2: address.addressLine2,
                addressLine3: address.addressLine3 ? address.addressLine3 : '',
                addressLine4: address.addressLine4 ? address.addressLine4 : '',
                postalCode: address.postalCode,
                city: address.city,
                stateId: stateObj.id,
                stateCode: stateObj.stateCode,
                countryCode: countryObj.countryCode || countryObj.isocodeThree,
                countryId: countryObj.countryId,
                phone: address.phone ? address.phone.replace(/[^a-zA-Z0-9]/g, '') : null,
                addressVerified: (this.appConfig && this.appConfig.skipAddressVerification) ? true : address.addressVerified,
                latitude: address.latitude,
                longitude: address.longitude,
                id: address.id,
                phoneType: address.phoneType,
                saveForFutureUse: this.posOrderFormGroup.value.saveForFutureUse,
                disableAddressBlock: address.disableAddressBlock,
                deliveryInstruction: address.deliveryInstruction,
                email: address.email ? address.email : null
            };
            return mapAddressToFields;
        }
    };
    /**
     * On change of card
     */
    PosOrderPromotionComponent.prototype.selectSavedCard = function (cardDetails, isNewCard, amount) {
        this._cacheService.set(CacheKey.IsRefreshed, true);
        this.addNewCardClicked = false;
        this.paymentComponentSettings.amount = amount;
        this.mapBillingAddress();
        this.isNewCardClicked = isNewCard;
        if (isNewCard) {
            this.selectedpayvisionCardInfo = null;
            this.addOrderInfoToSession();
            if (this.isWorldpayPayment) {
                this.showWorldpayXml = true;
                this.showWorldPayXMLPopup.open();
            }
            else if (this.isAdyenPayment) {
                this.paymentComponentSettings.amount = this.orderTotal ? this.orderTotal : this.calculateOrderTotal();
                this.showAdyenPayment = true;
                this.showAdyenPaymentPopup.open();
            }
            else if (this.isNIPayment) {
                this.showNIPayment = true;
                this.showNIPopup.open();
            }
            else if (this.isNexioPayment && this.enableNexioPaymentForPickUpCenter) {
                this.showNexioPayment = true;
                this.showNexioPopup.open();
            }
            else {
                this.addNewpayvisionCard = true;
                this.payvisionPayment.open();
            }
        }
        else {
            this.selectedpayvisionCardInfo = cardDetails;
            this.addNewpayvisionCard = false;
            this.showWorldpayXml = false;
            this.showNIPayment = false;
            this.showAdyenPayment = false;
            this.showNexioPayment = false;
        }
    };
    PosOrderPromotionComponent.prototype.addOrderInfoToSession = function () {
        sessionStorage.removeItem(CacheKey.OrderInfo);
        sessionStorage.removeItem(CacheKey.posOrderPaymentStatus);
        var formValues = this.posOrderFormGroup.value;
        var OrderInfo = {
            products: this.products,
            countryId: formValues.countryId,
            deliveryPreference: formValues.deliveryPreference,
            memberInfo: formValues.memberInfo,
            orderType: formValues.orderType,
            paymentSelector: formValues.paymentSelector,
            shipMethodId: formValues.shipMethodId,
            orderFromLookup: this.orderFromLookup,
            saveForFutureUse: this.posOrderFormGroup.value.saveForFutureUse,
            isSavedAddress: this.address ? this.address.isSavedAddress : null,
            savePaymentMethod: this.savePaymentMethod ? this.savePaymentMethod : false,
            language: this.posOrderFormGroup.value.language,
            minMaxPriceValidation: this.minMaxPriceValidation,
            posLocation: this.posOrderFormGroup.value.posLocation,
            splitPayments: this.splitPayments,
            paymentComponentSettings: this.paymentComponentSettings,
            orderTotal: this.orderTotal,
            businessEntityId: this.businessEntityId,
            isOverrideMinimumLimit: this.isOverrideMinimumLimit
        };
        sessionStorage.setItem(CacheKey.OrderInfo, JSON.stringify(OrderInfo));
    };
    /**
     *load procducts from session
     */
    PosOrderPromotionComponent.prototype.loadproductsFromSession = function () {
        var _this = this;
        this.orderSession.products.forEach(function (product) {
            _this.addItemNumber();
            var items = _this.posOrderFormGroup.get('items');
            if (items && items.length > 0) {
                var index = (items.length - 1);
                if (product) {
                    var itemValue = product.itemNumber + ' - ' + product.name;
                    items.controls[index].controls['itemNumber'].setValue(itemValue);
                    var itemImage = (product.imageModelList && product.imageModelList.length > 0)
                        ? (product.imageModelList[0].details.find(function (imageDetail) { return imageDetail.type === ImageType.Thumbnail; })) : '';
                    var imageUrl = (itemImage && itemImage.url) ? (environment.cdnURL + '/' + itemImage.url)
                        : (environment.uiTemplateBaseUrl + '/images/no_image.png');
                    var isDepositFeeProduct = product.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_PRODUCT && x.metaKeyWords === '1'; });
                    var depositFeeEnabled = product.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1'; });
                    items.controls[index].controls['productImage'].setValue(imageUrl);
                    items.controls[index].controls['productNumber'].setValue(product.itemNumber);
                    items.controls[index].controls['productName'].setValue(product.displayName ? product.displayName : product.name);
                    items.controls[index].controls['productId'].setValue(product.id);
                    items.controls[index].controls['productItem'].setValue(product);
                    items.controls[index].controls['disableIncrement'].setValue(false);
                    items.controls[index].controls['quantity'].setValidators([Validators.required]);
                    items.controls[index].controls['quantity'].updateValueAndValidity();
                    items.controls[index].controls['quantity'].setValue(product.quantity);
                    items.controls[index].controls['isDepositFeeProduct'].setValue(!!isDepositFeeProduct);
                    items.controls[index].controls['depositFeeEnabled'].setValue(!!depositFeeEnabled);
                }
            }
        });
        this.updateTotalsAndShipMethod();
        this.getHandlingFeeCharges();
    };
    /**
     * on close of payvision form popup
     */
    PosOrderPromotionComponent.prototype.onPayvisionFormClose = function () {
        this._cacheService.remove(CacheKey.IsRefreshed);
        sessionStorage.removeItem(CacheKey.OrderInfo);
        sessionStorage.removeItem(CacheKey.posOrderPaymentStatus);
        this.posOrderFormGroup.controls['paymentInstrumentId'].setValue('');
        this.addNewpayvisionCard = false;
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.payvisionPayment.close();
        this.paymentComponentSettings.payvisionFormLoaded = false;
        // To remove payvision Configurations
        this._commonService.unloadPayvisionWidget();
    };
    /**
    * @returns any
    */
    PosOrderPromotionComponent.prototype.getOrderPaymentInfo = function () {
        var payments = [];
        if (this.paymentComponentSettings.webOrderId) {
            var paymentMethodType = void 0;
            paymentMethodType = this.getPaymentMethodById(+this.posOrderFormGroup.controls['paymentSelector'].value);
            var orderPayment = {
                savePaymentMethod: this.savePaymentMethod && this.posOrderFormGroup.value.orderType !== this.orderType.NEW_GUEST_RETAIL
                    ? this.savePaymentMethod : false,
                paymentAmount: this.calculateOrderTotal(),
                redirect: false,
                orderSourceTypeId: OrderSourceValue.CUSTOMER,
                memberPaymentMethodId: +this.posOrderFormGroup.controls['paymentSelector'].value,
                //  === this.selectEnum.firstOption.toString() ? this.getPaymentMethodId('Credit_Card') : this.getPaymentMethodId('eCheck'),
                creditCardModel: {
                    currencyCode: this.storeInfo.currencyCode,
                    paymentToken: this.posOrderFormGroup.controls['paymentSelector'].value === this.selectEnum.firstOption.toString()
                        ? this.selectedpayvisionCardInfo.token : null,
                    paymentMethodType: paymentMethodType,
                    maskedCreditCardNumber: this.posOrderFormGroup.controls['paymentSelector'].value
                        === this.selectEnum.firstOption.toString() ? this.selectedpayvisionCardInfo.maskedCard : null,
                    cardHolderName: this.posOrderFormGroup.controls['paymentSelector'].value === this.selectEnum.firstOption.toString()
                        ? this.selectedpayvisionCardInfo.nameOnTheCard : null,
                    expMonth: this.posOrderFormGroup.controls['paymentSelector'].value === this.selectEnum.firstOption.toString()
                        ? this.selectedpayvisionCardInfo.expiryMonth : null,
                    expYear: this.posOrderFormGroup.controls['paymentSelector'].value === this.selectEnum.firstOption.toString()
                        ? this.selectedpayvisionCardInfo.expiryYear : null
                },
                paymentECheck: (this.posOrderFormGroup.controls['paymentSelector'].value === this.selectEnum.secondOption.toString()) ? this.getEcheckInfo() : null
            };
            payments.push(orderPayment);
        }
        return payments;
    };
    /**
         * get controls of items
         */
    PosOrderPromotionComponent.prototype.getItemsControl = function () {
        return this.posOrderFormGroup.get('items');
    };
    /**
     * On paste event for member Info
     */
    PosOrderPromotionComponent.prototype.onPasteEvent = function () {
        var _this = this;
        setTimeout(function () {
            _this.posOrderFormGroup.controls['memberInfo'].setValue(_this.posOrderFormGroup.controls['memberInfo'].value.trim());
        }, 0);
    };
    // *************************************** ECheck Payment****************************/
    /**
     * Get ECheck payment
     */
    PosOrderPromotionComponent.prototype.getSavedEchecks = function () {
        var _this = this;
        if (this.memberInfo.memberId) {
            this._echeckService.getSavedEchecks(this.memberInfo.memberId, this.selectedIsoCountryCode, this.eCheckTokenRes)
                .subscribe(function (response) {
                if (response && response.length > 0) {
                    _this.paymentComponentSettings.savedEChecks = response;
                    if (_this.echeckRequest && _this.echeckRequest.reusable) {
                        var selectedCard = _this.paymentComponentSettings.savedEChecks.find(function (x) { return x.id === _this.echeckRequest.id; });
                        if (selectedCard) {
                            var indexPostion = _this.paymentComponentSettings.savedEChecks
                                .findIndex(function (x) { return x.id === _this.echeckRequest.id; });
                            _this.paymentComponentSettings.savedEChecks.splice(indexPostion, 1);
                            _this.paymentComponentSettings.savedEChecks.unshift(selectedCard);
                            _this.posOrderFormGroup.controls['paymentInstrumentId'].setValue(_this.echeckRequest.id);
                        }
                        else {
                            var index = _this.paymentComponentSettings.savedEChecks.length - 1;
                            _this.posOrderFormGroup.controls['paymentInstrumentId']
                                .setValue(_this.paymentComponentSettings.savedEChecks[index].id);
                        }
                        // this.selectECheck();
                    }
                }
                else {
                    _this.paymentComponentSettings.savedEChecks = [];
                    _this.savedEChecks = '';
                }
                _this.savedEChecks = JSON.stringify(_this.paymentComponentSettings.savedEChecks);
            });
        }
    };
    /**
     * On payment group radio button change
     */
    PosOrderPromotionComponent.prototype.onPaymentMethodGroupChange = function (groupId) {
        if (groupId === this.posPaymentGroupEnum.External_Payment) {
            this.isPayByLinkValid = true;
            this.agreementCheckError = false;
            this.clearPaymentMethodTypeFormForm();
            this.buildExternalPaymentForm();
            this.balanceOrderTotal = this.orderTotal;
        }
        else if (groupId === this.posPaymentGroupEnum.Integrated_Payments) {
            this.isTerminalSelected = false;
            this.createPaymentMethodTypeForm();
            this.balanceOrderTotal = 0;
        }
        else if (groupId === this.posPaymentGroupEnum.Split_Payment) {
            this.isPayByLinkValid = true;
            this.agreementCheckError = false;
            this.clearPaymentMethodTypeFormForm();
            this.buildSplitPaymentForm();
            this.balanceOrderTotal = 0;
        }
    };
    /**
     * on change of payment method
     */
    PosOrderPromotionComponent.prototype.onPaymentMethodChnage = function () {
        var _this = this;
        this.createOrder();
        this.posOrderFormGroup.controls['paymentInstrumentId'].setValue('');
        this.selectedpayvisionCardInfo = null;
        this.echeckRequest = null;
        var options = [this.paymentTypeEnum.Money_order, this.paymentTypeEnum.Bank_Transfer,
            this.paymentTypeEnum.Cash_On_Delivery, this.paymentTypeEnum.Pay_By_Link];
        if (options.some(function (x) { return x == (+_this.posOrderFormGroup.controls['paymentSelector'].value); })) {
            this.posOrderFormGroup.controls['paymentInstrumentId'].setValidators([]);
        }
        else {
            // this.posOrderFormGroup.controls['paymentInstrumentId'].setValidators([Validators.required]);
        }
        this.posOrderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
    };
    /**
    * @description to get payment terms and Conditions documents
    * @param storeInfo
    */
    PosOrderPromotionComponent.prototype.getPaymentTermsAndPoliciesDocuments = function () {
        var _this = this;
        var accountlevelID = this._commonService.getMemberAccountLevelId(this.memberInfo);
        if (accountlevelID) {
            this._documentService.getDocuments(Portal.Csp, accountlevelID, DisplaySectionId.Payment_Page, this.countryCode, this.storeDefaultLanguage).subscribe(function (res) {
                if (res && res[0] && res[0].body && res[0].body.length > 0) {
                    _this.paymentTermsAndPoliciyDocuments = res[0].body;
                    _this.paymentTermsAndPoliciyDocuments.forEach(function (item) {
                        item.isSelected = true;
                    });
                }
            }, function (error) {
            });
        }
    };
    PosOrderPromotionComponent.prototype.checkPaymentTermsAndPolicies = function (index) {
        this.paymentTermsAndPoliciyDocuments[index].isSelected = !this.paymentTermsAndPoliciyDocuments[index].isSelected;
        this.checkPaymentDocumentsSelected();
    };
    PosOrderPromotionComponent.prototype.checkPaymentDocumentsSelected = function () {
        if (this.paymentTermsAndPoliciyDocuments && !this.paymentTermsAndPoliciyDocuments.every(function (x) { return x.isSelected; })) {
            this.agreementCheckError = true;
        }
        else {
            this.agreementCheckError = false;
        }
    };
    PosOrderPromotionComponent.prototype.getAcceptPaymentDocuments = function () {
        if (+this.paymentMethodTypeForm.controls['paymentMethodType'].value == this.paymentTypeEnum.Direct_Debit) {
            this.acceptPaymentDocuments = {
                memberId: this.memberInfo.memberId,
                memberTypeId: this.memberInfo.memberTypeId,
                documents: this.paymentTermsAndPoliciyDocuments
            };
        }
        else {
            this.acceptPaymentDocuments = null;
        }
    };
    /**
     *  getting pos payment methods after clicking
     * Enter payment details button
     */
    PosOrderPromotionComponent.prototype.onEnterPaymentDetailsClick = function () {
        var _this = this;
        this.enablePaymentBlock(true);
        this.balanceOrderTotal = this.orderTotal;
        this._orderService.getPosPaymentMethods(this.storeId, this.currentPosLocation.id, PurchaseFlow.Personal_Order).subscribe(function (response) {
            _this.terminalDownConfig = MULTI_SELECT_CONFIG_INTEGRATED_TERMINAL;
            if (response && response.posPaymentMethodModels) {
                _this.posPaymentMethods = response.posPaymentMethodModels;
                if (_this.posPaymentMethods && _this.posPaymentMethods.length > 0) {
                    _this.posPaymentGroups = [];
                    _this.terminalOptions = [];
                    _this.posPaymentMethods.forEach(function (payment) {
                        if (payment.rowStateID === RowStatus.Active && payment.storePOSTerminalId) {
                            var terminalModel = Object.assign({}, payment.terminalModel);
                            _this.terminalOptions.push(terminalModel);
                        }
                        if (_this.posPaymentGroups.length === 0) {
                            _this.posPaymentGroups.push({
                                id: payment.paymentMethodsModel.paymentGroupID,
                                name: payment.paymentMethodsModel.groupName
                            });
                        }
                        else {
                            var group = _this.posPaymentGroups.find(function (paymentGroup) {
                                return paymentGroup.id === payment.paymentMethodsModel.paymentGroupID;
                            });
                            if (!group) {
                                _this.posPaymentGroups.push({
                                    id: payment.paymentMethodsModel.paymentGroupID,
                                    name: payment.paymentMethodsModel.groupName
                                });
                            }
                        }
                    });
                    if (_this.posPaymentMethods && _this.posPaymentMethods.length > 0) {
                        _this.integratedPaymentMethods = _this.posPaymentMethods.filter(function (x) { return x.paymentMethodsModel.paymentGroupID === _this.posPaymentGroupEnum.Integrated_Payments && x.paymentMethodsModel.paymentMethodId > 0 && x.paymentMethodsModel.paymentMethodId != PaymentType.INTEGRATED_TERMINAL; });
                        var integratedTerminalPaymentMethod = _this.posPaymentMethods.find(function (x) { return x.paymentMethodsModel.paymentMethodId === PaymentType.INTEGRATED_TERMINAL; });
                        if (integratedTerminalPaymentMethod && _this.terminalOptions && _this.terminalOptions.length > 0) {
                            _this.prepareIntegratedPaymentMethods(integratedTerminalPaymentMethod);
                        }
                    }
                    var directDebitIndex = _this.integratedPaymentMethods.findIndex(function (x) { return x.paymentMethodsModel
                        && x.paymentMethodsModel.paymentMethodId == PaymentType.Direct_Debit; });
                    if (directDebitIndex > -1 && _this.memberInfo && _this.memberInfo.memberId
                        && _this.memberInfo.memberTypeId == MemberTypeEnum.DISTRIBUTOR) {
                        _this.filterDirectDebitPayment(directDebitIndex);
                    }
                    else {
                        if (directDebitIndex > -1) {
                            _this.integratedPaymentMethods.splice(directDebitIndex, 1);
                        }
                        _this.buildPaymentForm();
                    }
                }
                else {
                    _this.enablePaymentBlock(false);
                    var errorMessage = 'POS Payment methods are not configured, Please select Different Location.';
                    _this._commonService.createNotification('', errorMessage, NotificationType.ERROR);
                }
            }
        }, function (error) {
            _this.enablePaymentBlock(false);
            var errorMessage = _this._translatePipe.get('common.Sorry, Something Went Wrong: Please try again later.');
            _this._commonService.createNotification('', errorMessage.value, NotificationType.ERROR);
        });
    };
    PosOrderPromotionComponent.prototype.prepareIntegratedPaymentMethods = function (integratedTerminalPaymentMethod) {
        this.integratedPaymentMethods.push({
            terminals: this.terminalOptions,
            locationId: integratedTerminalPaymentMethod.locationId ? integratedTerminalPaymentMethod.locationId : null,
            orderTypeId: integratedTerminalPaymentMethod.orderTypeId ? integratedTerminalPaymentMethod.orderTypeId : null,
            paymentMethodsModel: integratedTerminalPaymentMethod.paymentMethodsModel ? integratedTerminalPaymentMethod.paymentMethodsModel : null,
            rowStateId: integratedTerminalPaymentMethod.rowStateId ? integratedTerminalPaymentMethod.rowStateId : null,
            rowStateID: integratedTerminalPaymentMethod.rowStateID ? integratedTerminalPaymentMethod.rowStateID : null,
            storeID: integratedTerminalPaymentMethod.storeID ? integratedTerminalPaymentMethod.storeID : null
        });
    };
    PosOrderPromotionComponent.prototype.filterDirectDebitPayment = function (directDebitIndex) {
        var _this = this;
        var operatingCompany = this.storeInfo && this.storeInfo.homeIsocodeThree ? this.storeInfo.homeIsocodeThree : null;
        var storeId = this.storeInfo && this.storeInfo.id ? this.storeInfo.id : null;
        this._customerService.getMemberBankDetails(this.memberInfo.memberId, storeId, operatingCompany).subscribe(function (res) {
            if (!res || res && !res.accountNumber || res && res.accountNumber && !res.directDebitEnabled) {
                _this.integratedPaymentMethods.splice(directDebitIndex, 1);
            }
            _this.buildPaymentForm();
        }, function (error) {
            _this.integratedPaymentMethods.splice(directDebitIndex, 1);
            _this.buildPaymentForm();
        });
    };
    /**
     * When edit cart button click
     */
    PosOrderPromotionComponent.prototype.onEditCartClick = function () {
        this.isPaymentBlockEnabled = false;
        this.isEnterPaymentDetailsEnabled = false;
        this.placeOrderClicked = false;
        this.paymentComponentSettings.webOrderId = '';
        this.buildExternalPaymentForm();
        this.buildSplitPaymentForm();
        this.createPaymentMethodTypeForm();
    };
    /**
     * On External payment method radio button change
     */
    PosOrderPromotionComponent.prototype.onExternalPaymentMethodChange = function (event, paymentMethodId, index) {
        this.balanceOrderTotal = this.orderTotal;
        console.log("this.balanceOrderTotal", this.balanceOrderTotal);
        var externalPaymentForm = this.externalPaymentForm.get('payments');
        var i = 0;
        for (i; i < externalPaymentForm.length; i++) {
            if (i !== index) {
                externalPaymentForm.controls[i].controls['amount'].setValue('');
                externalPaymentForm.controls[i].controls['paymentMethodId'].setValue('');
                externalPaymentForm.controls[i].controls['paymentNote'].setValue('');
                externalPaymentForm.controls[i].controls['amount'].clearValidators();
                externalPaymentForm.controls[i].controls['amount'].setErrors(null);
                externalPaymentForm.controls[i].controls['paymentMethodId'].clearValidators();
                externalPaymentForm.controls[i].controls['paymentMethodId'].setErrors(null);
                externalPaymentForm.controls[i].controls['paymentCheckNumber'].setValue('');
                externalPaymentForm.controls[i].updateValueAndValidity();
            }
        }
        externalPaymentForm.controls[index].controls['amount'].setValue('');
        externalPaymentForm.controls[index].controls['paymentMethodId'].setValue(this.getPaymentMethodId(this.posPaymentGroupEnum.External_Payment, index));
        externalPaymentForm.controls[index].controls['amount'].setValidators([Validators.required]);
        externalPaymentForm.controls[index].controls['amount'].updateValueAndValidity();
    };
    PosOrderPromotionComponent.prototype.onSplitPaymentMethodChange = function ($event, index) {
        var payments = this.splitPaymentForm.get('payments');
        payments.controls[index].controls['amount'].setValue('');
        payments.controls[index].updateValueAndValidity();
    };
    /**
     * on payment method amount change
     */
    PosOrderPromotionComponent.prototype.onPaymentMethodAmountChange = function (event, groupId, index) {
        var paymentSelector = +this.posOrderFormGroup.controls['paymentSelector'].value;
        if (paymentSelector === this.posPaymentGroupEnum.External_Payment) {
            var data = this.getSelectedExternalPaymentData();
            this.balanceOrderTotal = this.orderTotal - data.amount;
        }
        else if (paymentSelector === this.posPaymentGroupEnum.Split_Payment) {
            // need to add split payment logic below value is temprory
            this.balanceOrderTotal = 0;
        }
        else if (paymentSelector === this.posPaymentGroupEnum.Integrated_Payments) {
            this.balanceOrderTotal = 0;
        }
    };
    PosOrderPromotionComponent.prototype.getSelectedExternalPaymentData = function () {
        var _this = this;
        var externalPaymentForm = this.externalPaymentForm.get('payments');
        var i = 0;
        var data = {};
        for (i; i < externalPaymentForm.length; i++) {
            if (externalPaymentForm.controls[i].controls['paymentMethodId'].value
                && externalPaymentForm.controls[i].controls['paymentMethodId'].value !== ''
                && externalPaymentForm.controls[i].controls['paymentMethodId'].value > 0) {
                var payments = this.posPaymentMethods.filter(function (paymentMethod) {
                    return paymentMethod.paymentMethodsModel.paymentGroupID === _this.posPaymentGroupEnum.External_Payment;
                });
                data = {
                    paymentGroupId: this.posPaymentGroupEnum.External_Payment,
                    paymentMethodName: PosPaymentMethodsEnum[+externalPaymentForm.controls[i].controls['paymentMethodId'].value],
                    paymentMethodId: externalPaymentForm.controls[i].controls['paymentMethodId'].value,
                    paymentStatus: externalPaymentForm.controls[i].controls['paymentStatus'].value,
                    paymentNote: externalPaymentForm.controls[i].controls['paymentNote'].value,
                    amount: externalPaymentForm.controls[i].controls['amount'].value,
                    paymentCheckNumber: externalPaymentForm.controls[i].controls['paymentCheckNumber'].value,
                };
            }
        }
        return data;
    };
    PosOrderPromotionComponent.prototype.prepareIntegratedPaymentData = function () {
        if (this.terminalDetails) {
            this.terminalPOIId = this.terminalDetails.deviceModel + "-" + this.terminalDetails.serialNumber;
            this.paymentProcessingPopup.open();
            var orderDescription = this.products && this.products &&
                this.products.length > 0 ? this.products[0].name : 'order description';
            var initiatePaymentRequest = {
                email: this.memberInfo.email ? this.memberInfo.email : '',
                firstName: this.memberInfo.firstName,
                lastName: this.memberInfo.lastName,
                languageCode: this.languageCode,
                languageCulture: this._commonService.getLanguageCulture(this.storeInfo, this.countryCode, this.memberInfo),
                customerId: this.memberInfo.memberId,
                paymentMethodType: PaymentMethodTypes.Integrated_Terminal_Adyen,
                terminalDetails: this.terminalDetails,
                terminalPOIId: this.terminalPOIId,
                countryCode: this.selectedIsoCountryCode,
                amount: {
                    currency: this.storeInfo.currencyCode,
                    value: this.calculateOrderTotal()
                },
                distributorId: this.memberInfo.fboId,
                orderTypeId: this.orderType.POS,
                webOrderID: this.paymentComponentSettings.webOrderId,
                orderReferenceId: this.paymentComponentSettings.orderReferenceId,
                storeID: this.storeInfo.id,
                orderSource: OrderSources.POS,
                description: orderDescription,
                shippingAddress: this.getPayByLinkShippingAddress()
            };
            this._cacheService.set(CacheKey.SelectedTerminalDetails, this.paymentMethodTypeForm.controls['preselectTerminal'].value);
            this.initiateTerminalPayment(initiatePaymentRequest);
        }
    };
    PosOrderPromotionComponent.prototype.terminalSelection = function (terminalID) {
        this.terminalDetails = this.terminalOptions.find(function (x) { return (x.id == +terminalID); });
    };
    PosOrderPromotionComponent.prototype.getSelectedCreditCardData = function () {
        var data = {};
        data = {
            paymentGroupId: this.posPaymentGroupEnum.Integrated_Payments,
            paymentMethodId: PosPaymentMethodsEnum.Credit_Card,
            paymentMethodName: PosPaymentMethodsEnum[1],
            paymentStatus: '',
            paymentNote: '',
            amount: '',
            paymentCheckNumber: '',
            distrubutorId: this.memberInfo && this.memberInfo.fboId ? this.memberInfo.fboId : null
        };
        return data;
    };
    /**
     * when confirm button click on split payment
     */
    PosOrderPromotionComponent.prototype.onPaymentConfirmClick = function (index) {
    };
    /**
     * on change of Echeck
     */
    PosOrderPromotionComponent.prototype.selectECheck = function (echeckDetails, isNewEcheck) {
        if (isNewEcheck) {
            this.buildEcheckForm();
            this.echeckSubmitted = false;
            this.eCheckValidationMessages = [];
            this.eCheckPaymentPopup.open();
            this.addNeweCheck = true;
        }
        else {
            this.selectedECheckInfo = echeckDetails;
            this.billingAddressInfo = echeckDetails.billingAddress;
            this.addNeweCheck = false;
            this.echeckRequest = {
                portalCsp: true,
                id: this.addNeweCheck ? 0 : this.selectedECheckInfo.id,
                portalType: EcheckPortalTypes.CustomerCare,
                accountNumber: this.selectedECheckInfo.accountNumber,
                routingNumber: this.selectedECheckInfo.routingNumber,
                bankName: this.selectedECheckInfo.bankName,
                accountType: this.selectedECheckInfo.accountType,
                nameOnBankAccount: this.selectedECheckInfo.nameOnBankAccount,
                reusable: this.selectedECheckInfo.reusable,
                defaultECheck: this.selectedECheckInfo.defaultECheck,
                customerId: this.memberInfo.memberId,
                billingAddress: this.getBillingAddressForECheck(),
                billingAddressId: null,
                billingAddressRequired: true,
                customMessage: '',
                storeId: this.storeInfo.id,
                email: this.selectedECheckInfo.email,
                phone: this.selectedECheckInfo.phone
            };
            if (this.paymentFormBtn && this.paymentFormBtn.nativeElement) {
                this.paymentFormBtn.nativeElement.focus();
            }
        }
    };
    /**
     * when Echeck form is closed
     */
    PosOrderPromotionComponent.prototype.onECheckFormClose = function () {
        this.eCheckPaymentPopup.close();
        this.addNeweCheck = false;
        this.posOrderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedEcheckDdl && this.savedEcheckDdl.nativeElement) {
            this.savedEcheckDdl.nativeElement.focus();
        }
    };
    /**
     * buildEcheckForm
     */
    PosOrderPromotionComponent.prototype.buildEcheckForm = function () {
        var phone = '';
        var email = '';
        if (this.memberInfo) {
            email = this.memberInfo.email;
            if (this.phoneNumberFormat) {
                phone = this._maskPipe.transform(this.memberInfo.phone, this.phoneNumberFormat);
            }
            else {
                phone = this.memberInfo.phone;
            }
        }
        this.echeckForm = this._formbuilder.group({
            routerNumber: ['', [Validators.required, Utils.alphaNumericCharacterValidation, Validators.maxLength(9)]],
            accountNumber: ['', [Validators.required, CustomValidators.requiredNotEmpty]],
            accountType: ['', [Validators.required]],
            bankName: ['', [Validators.required, CustomValidators.requiredNotEmpty]],
            nameOnBankAccount: ['', [Validators.required, CustomValidators.requiredNotEmpty, Utils.alphaNumericCharacterValidation, Validators.maxLength(25)]],
            reuse: [false],
            billingAddressId: [''],
            customMessage: [''],
            email: [email, Validators.required],
            phone: [phone, [Validators.required, EcheckPhoneNumberValidation.PhoneNumberValidation]]
        });
    };
    PosOrderPromotionComponent.prototype.validateNewECheck = function () {
        this.echeckSubmitted = true;
        if (this.echeckForm.valid) {
            var echeckFormValue_1 = this._commonService.trimObjectValues(this.echeckForm.value);
            if (echeckFormValue_1.phone) {
                var phoneCode = PhoneCodesConstants.phoneCodes.find(function (x) { return echeckFormValue_1.phone.toUpperCase().indexOf(x.name) > -1; });
                if (phoneCode) {
                    echeckFormValue_1.phone = echeckFormValue_1.phone;
                }
                else {
                    if (this.phoneNumberFormat) {
                        echeckFormValue_1.phone = this._maskPipe.transform(echeckFormValue_1.phone, this.phoneNumberFormat);
                    }
                    else {
                        echeckFormValue_1.phone = echeckFormValue_1.phone;
                    }
                }
            }
            var currentDate = new Date();
            var validateECheckReq = {
                accountNumber: echeckFormValue_1.accountNumber,
                accountType: echeckFormValue_1.accountType,
                bankName: echeckFormValue_1.bankName,
                routingNumber: echeckFormValue_1.routerNumber,
                addressOne: this.billingAddressInfo.addressLine1,
                addressTwo: this.billingAddressInfo.addressLine2,
                city: this.billingAddressInfo.city,
                country: this.paymentComponentSettings.isoTwoletterCountryCode,
                state: this.billingAddressInfo.stateCode,
                zip: this.billingAddressInfo.postalCode,
                email: echeckFormValue_1.email,
                phone: echeckFormValue_1.phone,
                paymentMethodType: this.paymentComponentSettings.paymentMethodTypes.eCheck
            };
            this.validateECheck(validateECheckReq);
        }
    };
    PosOrderPromotionComponent.prototype.validateECheck = function (validateECheckReq) {
        var _this = this;
        this.eCheckValidationMessages = [];
        this._echeckService.validateEcheck(validateECheckReq)
            .subscribe(function (response) {
            if (response && response.success) {
                _this.savePersonalEcheck(validateECheckReq);
            }
            else if (response && !response.success && response.validations.length > 0) {
                _this.eCheckValidationMessages = response.validations.map(function (validation) { return validation.message; });
            }
            else {
                _this.eCheckValidationMessages.push('Echeck validation failed.');
            }
        }, function (error) {
            _this.eCheckValidationMessages.push('Echeck validation failed.');
        });
    };
    /**
     * save personal echecks
     */
    PosOrderPromotionComponent.prototype.savePersonalEcheck = function (eCheckInfo) {
        var _this = this;
        this.echeckRequest = {
            portalCsp: true,
            id: this.addNeweCheck ? 0 : this.selectedECheckInfo.id,
            portalType: EcheckPortalTypes.CustomerCare,
            accountNumber: eCheckInfo.accountNumber,
            routingNumber: eCheckInfo.routingNumber,
            bankName: eCheckInfo.bankName,
            accountType: eCheckInfo.accountType,
            nameOnBankAccount: this.addNeweCheck ? eCheckInfo.name : this.selectedECheckInfo.nameOnBankAccount,
            reusable: this.addNeweCheck ? this.echeckForm.value.reuse : this.selectedECheckInfo.reusable,
            defaultECheck: this.addNeweCheck ? false : this.selectedECheckInfo.defaultECheck,
            customerId: this.memberInfo.memberId,
            billingAddress: this.getBillingAddressForECheck(),
            billingAddressId: null,
            billingAddressRequired: true,
            customMessage: '',
            storeId: this.storeInfo.id,
            email: eCheckInfo.email,
            phone: eCheckInfo.phone
        };
        this._echeckService.savePersonalCheck(this.memberInfo.memberId, this.echeckRequest)
            .subscribe(function (response) {
            if (response) {
                _this.eCheckTokenRes = response;
                _this.echeckSubmitted = false;
                if (_this.addNeweCheck) {
                    _this.eCheckPaymentPopup.close();
                    var savedEChecks = JSON.parse(_this.savedEChecks);
                    _this.paymentComponentSettings.savedEChecks = savedEChecks;
                    if (_this.echeckRequest) {
                        _this.echeckRequest.id = +(atob(_this.eCheckTokenRes));
                    }
                    if (_this.echeckRequest && _this.echeckRequest.reusable) {
                        _this.posOrderFormGroup.controls['paymentInstrumentId'].setValue(+(atob(_this.eCheckTokenRes)));
                        _this.getSavedEchecks();
                    }
                    else {
                        _this.posOrderFormGroup.controls['paymentInstrumentId'].setValue(+(atob(_this.eCheckTokenRes)));
                    }
                    // }
                }
                if (_this.paymentFormBtn && _this.paymentFormBtn.nativeElement) {
                    _this.paymentFormBtn.nativeElement.focus();
                }
            }
            else {
                _this.eCheckValidationMessages.push('Echeck validation failed.');
            }
        }, function (error) {
            _this.eCheckValidationMessages.push('Echeck validation failed.');
        });
    };
    /**
     * map billing address for e-Check
     */
    PosOrderPromotionComponent.prototype.getBillingAddressForECheck = function () {
        var stateObj = this.getStateDetailsByStateIdOrCode(null, this.billingAddressInfo.state);
        var billingAddress = {
            id: null,
            addressLine1: this.billingAddressInfo.addressLine1,
            addressLine2: this.billingAddressInfo.addressLine2 || '',
            addressLine3: this.billingAddressInfo.addressLine3 || '',
            addressLine4: this.billingAddressInfo.addressLine4 || '',
            stateId: this.billingAddressInfo.stateId || stateObj.id,
            countryId: this.billingAddressInfo.countryId,
            city: this.billingAddressInfo.city,
            state: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            stateCode: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            country: this.billingAddressInfo.countryCode,
            countryCode: this.billingAddressInfo.countryCode,
            postalCode: this.billingAddressInfo.postalCode,
            name: this.billingAddressInfo.shipToName || this.billingAddressInfo.name || this.billingAddressInfo.firstName,
            firstName: this.billingAddressInfo.shipToName || this.billingAddressInfo.name,
            phone: ''
        };
        return billingAddress;
    };
    /**
     * map Echeck Info for payment
     */
    PosOrderPromotionComponent.prototype.getEcheckInfo = function () {
        var eCheckInfo = {
            bankName: this.echeckRequest.bankName,
            accountNumber: this.echeckRequest.accountNumber,
            routingNumber: this.echeckRequest.routingNumber,
            accountType: this.echeckRequest.accountType,
            mecTransactionID: '',
            nameOnBankAccount: this.echeckRequest.nameOnBankAccount,
            customMessage: '',
            reusable: this.echeckRequest.reusable,
            eCheckID: this.eCheckTokenRes ? parseInt(atob(this.eCheckTokenRes), 10) : this.echeckRequest ? this.echeckRequest.id : 0,
            email: this.echeckRequest.email,
            phone: this.echeckRequest.phone
        };
        return eCheckInfo;
    };
    /**
     * @description add mask while chnaging phone number
     *
     * @memberof EcheckComponent
     */
    PosOrderPromotionComponent.prototype.onChangeEcheckPhone = function ($event) {
        var value = this.echeckForm.controls['phone'].value;
        var updatedValue = value;
        var alphaNumericValue = value.replace(/[^a-z0-9]/gi, '');
        if (value.match(/[a-zA-Z]/)) {
            if (alphaNumericValue.substr(0, 3).match(/[a-zA-Z]/)) {
                updatedValue = value.replace(/[^a-z0-9]/gi, '');
            }
            else if (alphaNumericValue.substr(3, 3).match(/[a-zA-Z]/)) {
                updatedValue = this._maskPipe.transform(value, '(000) AAAAAAA');
            }
            else if (alphaNumericValue.substr(6, 4).match(/[a-zA-Z]/)) {
                updatedValue = this._maskPipe.transform(value, '(000) 000-AAAA');
            }
        }
        else {
            if (alphaNumericValue.length !== 3) {
                if (this.phoneNumberFormat) {
                    updatedValue = this._maskPipe.transform(value, this.phoneNumberFormat);
                }
                else {
                    updatedValue = value;
                }
            }
        }
        this.echeckForm.controls['phone'].setValue(updatedValue);
    };
    PosOrderPromotionComponent.prototype.onWorldpayXMLFormClose = function () {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showWorldpayXml = false;
        sessionStorage.removeItem(CacheKey.OrderInfo);
        sessionStorage.removeItem(CacheKey.posOrderPaymentStatus);
        this.posOrderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showWorldPayXMLPopup.close();
    };
    // ======================Worldpay End===================================================
    PosOrderPromotionComponent.prototype.onAdyenPaymentFormClose = function () {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showAdyenPayment = false;
        sessionStorage.removeItem(CacheKey.OrderInfo);
        sessionStorage.removeItem(CacheKey.posOrderPaymentStatus);
        this.posOrderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showAdyenPaymentPopup.close();
    };
    // ======================Adyen payment End===================================================
    PosOrderPromotionComponent.prototype.onNIFormClose = function () {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showNIPayment = false;
        sessionStorage.removeItem(CacheKey.OrderInfo);
        sessionStorage.removeItem(CacheKey.posOrderPaymentStatus);
        this.posOrderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showNIPopup.close();
    };
    PosOrderPromotionComponent.prototype.onNexioFormClose = function () {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showNexioPayment = false;
        sessionStorage.removeItem(CacheKey.OrderInfo);
        sessionStorage.removeItem(CacheKey.posOrderPaymentStatus);
        this.posOrderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showNexioPopup.close();
    };
    // getPaymentMethod by Store
    PosOrderPromotionComponent.prototype.getPaymentMethodsByStore = function (memberTypeId) {
        var _this = this;
        var fpc5PercentEnabled = false;
        if (this.appConfig && this.appConfig.fpc5PercentEnabled) {
            fpc5PercentEnabled = true;
        }
        this.credit_Card_show = this.money_Order_show = this.cash_on_delivery_show
            = this.bank_transfer_show = this.echeck_show = false;
        this._orderService.getPaymentMethodsByStore(this.storeId, this.countryCode, this.storeDefaultLanguage ? this.storeDefaultLanguage : this.languageCode, this.memberInfo ? this.memberInfo.memberTypeId : memberTypeId, this.memberInfo ? this.memberInfo.wholeSaleQualified : null, fpc5PercentEnabled).subscribe(function (response) {
            if (response) {
                _this.storePaymentInfo = response;
                _this.initializePaymentMethods();
                _this.storePaymentInfo.forEach(function (paymentMethod) {
                    if (paymentMethod.paymentMethodId === PaymentType.Credit_Card) {
                        _this.credit_Card_show = true;
                        if (paymentMethod.paymentProcessor === PaymentProcessorAlias.ADYEN) {
                            _this.isAdyenPayment = true;
                        }
                        else if (paymentMethod.paymentProcessor === PaymentProcessorAlias.NI) {
                            _this.isNIPayment = true;
                        }
                        else if (paymentMethod.paymentProcessor === PaymentProcessorAlias.WPAYXML) {
                            _this.isWorldpayPayment = true;
                        }
                        else if (paymentMethod.paymentProcessor === PaymentProcessorAlias.NEXIO && _this.enableNexioPaymentForPickUpCenter) {
                            _this.isNexioPayment = true;
                        }
                    }
                    else if (paymentMethod.paymentMethodId === PaymentType.Money_order) {
                        _this.money_Order_show = true;
                    }
                    else if (paymentMethod.paymentMethodId === PaymentType.eCheck) {
                        _this.echeck_show = true;
                    }
                    else if (paymentMethod.paymentMethodId === PaymentType.Bank_Transfer) {
                        _this.bank_transfer_show = true;
                        _this.getBankDetails();
                    }
                    else if (paymentMethod.paymentMethodId === PaymentType.Cash_On_Delivery) {
                        _this.cash_on_delivery_show = true;
                    }
                });
                var option = _this.credit_Card_show ? _this.paymentTypeEnum.Credit_Card : _this.echeck_show
                    ? _this.paymentTypeEnum.eCheck : _this.money_Order_show ? _this.paymentTypeEnum.Money_order
                    : _this.bank_transfer_show ? _this.paymentTypeEnum.Bank_Transfer : _this.cash_on_delivery_show ? _this.paymentTypeEnum.Cash_On_Delivery : null;
                if (option) {
                    //this.setPaymentMethod(option);
                }
                _this.savePaymentMethod = _this.orderSession && _this.orderSession.savePaymentMethod ?
                    _this.orderSession.savePaymentMethod : false;
                _this.loadSavedCardsForMemberId(_this.memberInfo.memberId, _this.countryCode);
                _this.getSavedEchecks();
            }
        });
    };
    PosOrderPromotionComponent.prototype.initializePaymentMethods = function () {
        this.isWorldpayPayment = false;
        this.isAdyenPayment = false;
        this.isNIPayment = false;
        this.isNexioPayment = false;
    };
    /**
   * @description get Order Min Max Business Rules
   * @memberof OrderPromotionComponent
   */
    PosOrderPromotionComponent.prototype.getOrderRules = function (storeInfo) {
        var _this = this;
        var userInfo = this.memberInfo;
        var isFboUpgradeFlow = false;
        if (userInfo) {
            userInfo.memberTitleId =
                this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId);
            isFboUpgradeFlow = (+this.memberInfo.memberTypeId === this.memberTypeEnum.DISTRIBUTOR &&
                this.appConfig && this.appConfig.displayPurchaseLimitationMessage);
        }
        var orderRulesRequest = {
            countryCode: this.selectedIsoCountryCode,
            memberTitleId: userInfo ? userInfo.memberTitleId : MemberLevel.RETAIL,
            orderType: userInfo && userInfo.memberTitleId !== MemberLevel.RETAIL ? MemberOrderType.Personal
                : MemberOrderType.Retail
        };
        if (!isFboUpgradeFlow) {
            this.getBusinessOrderRules(orderRulesRequest);
        }
        this._orderService.getMemberOrderRestrictionsInfo(userInfo, this.selectedIsoCountryCode)
            .subscribe(function (response) {
            if (response) {
                _this.restrictedDays = response.restrictedDays;
                _this.getMemberRankLevelHistory(orderRulesRequest, storeInfo, userInfo, isFboUpgradeFlow);
            }
        }, function (error) {
        });
        if (userInfo && userInfo.memberId && userInfo.memberTitleId !== MemberLevel.RETAIL) {
            if (!isFboUpgradeFlow) {
                this.getMemberOrderRules(userInfo, false);
            }
            this.getMemberCCOverrides(userInfo.memberId);
        }
    };
    PosOrderPromotionComponent.prototype.getMemberRankLevelHistory = function (orderRulesRequest, storeInfo, userInfo, isFboUpgradeFlow) {
        var _this = this;
        if (!isFboUpgradeFlow) {
            return;
        }
        this.isFBOValidationPending = true;
        this._commonService.getMemberRankLevelHistory(this.memberInfo.memberId, storeInfo.countryId)
            .subscribe(function (response) {
            if (response) {
                _this.memberLevelHistory = response;
                var memberLevelInfo = _this.memberLevelHistory
                    .find(function (memberLevel) { return memberLevel.memberTitleId === MemberTitleExtEnums.PreferredCustomer; });
                var isMemberFboUpgraded = memberLevelInfo ? true : false;
                var dateParts = _this.memberInfo.enrolmentDate ? _this.memberInfo.enrolmentDate.split('-') : _this.memberInfo.createdDate.split('-');
                var enrollmentWindowDate = new Date(+dateParts[0], +dateParts[1] - 1, +dateParts[2]);
                ;
                enrollmentWindowDate.setHours(0, 0, 0, 0);
                enrollmentWindowDate.setDate(enrollmentWindowDate.getDate() + _this.restrictedDays);
                var currentDate = new Date();
                currentDate.setHours(0, 0, 0, 0);
                _this.isFBOValidationPending = false;
                if (isMemberFboUpgraded && (enrollmentWindowDate.getTime() > currentDate.getTime())) {
                    orderRulesRequest.optinFbo = true;
                    _this.isMemberFboUpgraded = true;
                    _this.getBusinessOrderRules(orderRulesRequest, userInfo, true);
                }
                else {
                    _this.isMemberFboUpgraded = false;
                    _this.getBusinessOrderRules(orderRulesRequest);
                    _this.getMemberOrderRules(userInfo, false);
                }
            }
            else {
                _this.memberLevelHistory = [];
                _this.isMemberFboUpgraded = false;
                _this.isFBOValidationPending = false;
                _this.getMemberOrderRules(userInfo, false);
                _this.getBusinessOrderRules(orderRulesRequest);
            }
        });
    };
    PosOrderPromotionComponent.prototype.getBusinessOrderRules = function (orderRulesRequest, userInfo, isFboUpgradeFlow) {
        var _this = this;
        this._orderService.getOrderBusinessRules(orderRulesRequest)
            .subscribe(function (response) {
            if (response) {
                _this.orderRules = response;
                if (isFboUpgradeFlow) {
                    _this.getMemberOrderRules(userInfo, false, null, true);
                }
            }
        }, function (error) {
        });
    };
    /**
     * Get member cc overrides
     * @param memberId
    */
    PosOrderPromotionComponent.prototype.getMemberCCOverrides = function (memberId) {
        var _this = this;
        this._customerService.getMemberCCOverride(this.storeId, memberId)
            .subscribe(function (response) {
            if (response && response.length) {
                _this.memberCCOverride = response[0];
            }
        }, function (err) {
        });
    };
    /** get Member Order rules
     * @description
     * @date 2019-05-20
     * @memberof OrderPromotionComponent
     */
    PosOrderPromotionComponent.prototype.getMemberOrderRules = function (userInfo, isBackOrderDate, requestUrl, isFboUpgradeFlow) {
        var _this = this;
        this.memberOrderCCInfo = null;
        var fromDate;
        var toDate;
        if (userInfo) {
            userInfo.memberTitleId =
                this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId);
        }
        if (isFboUpgradeFlow) {
            fromDate = this.memberInfo.enrolmentDate.substr(0, 10);
            var enrollDate = new Date(fromDate);
            var orderToDateStr = enrollDate.setDate(enrollDate.getDate() + this.restrictedDays);
            toDate = moment(orderToDateStr).format(DateConstants.DOBFormat);
        }
        this._orderService.getMemberOrderBusinessRules(userInfo.memberId, this.storeId, isBackOrderDate, this.selectedIsoCountryCode, userInfo.memberTitleId, null, fromDate, toDate)
            .subscribe(function (response) {
            if (response) {
                var memberOrderRules = response;
                var frequencyType_1 = _this.isMemberFboUpgraded ? Constants.FREQUENCY_ABSOLUTE : Constants.FREQUENCY_MONTHLY;
                _this.memberOrderCCInfo = memberOrderRules.memberOrderCCInfo.filter(function (x) { return x.frequency === frequencyType_1; })[0];
                var validateOrderRule = _this.verifyOrderRules(isBackOrderDate);
                _this.upgradeFboLimitExceeded = frequencyType_1 === Constants.FREQUENCY_ABSOLUTE ?
                    validateOrderRule.purchaseLimitExceed : false;
                _this.thresholdCrossed = validateOrderRule.thresholdCrossed;
                _this.memberCCLimitExceeded = validateOrderRule.monthlyCCValid;
                _this.monthlyCCValue = validateOrderRule.monthlyCCValue;
                _this.memberCCOverrideLimitExceeded = validateOrderRule.memberCCOverride;
                _this.cartLimitExceed = validateOrderRule.cartLimitExceed;
                _this.cartLimitNotReach = validateOrderRule.cartLimitNotReach;
                if (requestUrl) {
                    _this.placeOrder(requestUrl);
                }
            }
        }, function (error) {
            _this.enablePaymentBlock(false);
            var errorMessage = _this._translatePipe.get('common.Sorry, Something Went Wrong: Please try again later.');
            _this._commonService.createNotification('', errorMessage.value, NotificationType.ERROR);
        });
    };
    /**
     * @description savePayment methos
     * @memberof OrderPromotionComponent
     */
    PosOrderPromotionComponent.prototype.savePaymentMethodClicked = function (savePaymentMethod) {
        this.savePaymentMethod = !savePaymentMethod;
    };
    /**
     * check member has access to place an order
     */
    PosOrderPromotionComponent.prototype.checkMemberAccess = function () {
        if (this.isMemberEligibleToPlaceOrder) {
            this.isMemberEligibleToPlaceOrder = true;
            this._commonService.createNotification('', this.memberTypeNotification.value, NotificationType.ERROR);
            return;
        }
        if (this.memberInfo && this.posOrderFormGroup && this.posOrderFormGroup.value.orderType === this.orderType.POS
            && this.restrictedDays > 0) {
            var enrollmentDate = void 0;
            enrollmentDate = this.memberInfo.enrolmentDate ? new Date(this.memberInfo.enrolmentDate) : new Date(this.memberInfo.createdDate);
            enrollmentDate.setHours(0, 0, 0, 0);
            enrollmentDate.setDate(enrollmentDate.getDate() + this.restrictedDays);
            var currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);
            if (this.isFBOValidationPending) {
                return;
            }
            if (this.upgradeFboLimitExceeded && this.isMemberFboUpgraded) {
                this.displayPurchaseLimitMessage(enrollmentDate);
                this.isMemberHasAccessToOrder = this.calculateItemsSubTotal(this.storeInfo) > 0 ? true : false;
                return;
            }
            else if (this.isMemberFboUpgraded) {
                this.isMemberHasAccessToOrder = true;
                this._commonService.removeNotification(Constants.PURCHASE_WINDOW);
            }
            else if (enrollmentDate.getTime() > currentDate.getTime() && this.memberInfo.fboId && !this.isMemberFboUpgraded) {
                var restrictPlacingOrder = true;
                if ((this.memberInfo.sponsorTransactionalSourceId == transactional.SPNC && this.countryCode && environment.skipOrderRestrictionCountriesOnSPNCTransaction.includes(this.countryCode.toUpperCase()))) {
                    restrictPlacingOrder = false;
                }
                if (restrictPlacingOrder) {
                    var nextOrderDate = moment(enrollmentDate).format(DateConstants.DateFormat);
                    var orderPlacingError = this._translatePipe.get('order.Next Order is permitted after');
                    this._commonService.createNotification('', orderPlacingError.value + nextOrderDate, NotificationType.ERROR);
                    this.isMemberHasAccessToOrder = false;
                }
            }
        }
    };
    PosOrderPromotionComponent.prototype.displayPurchaseLimitMessage = function (enrollmentDate) {
        var purchaseLimitExceedMessage = this._translatePipe
            .get('order.Orders should not exceed an aggregate of ||maxValue|| until ||endDate||')['value'];
        var nextOrderEligibleDate = moment(enrollmentDate).format(DateConstants.DateFormat);
        var maxValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.maxValue, this.storeInfo);
        purchaseLimitExceedMessage = this._translateKey.transform(purchaseLimitExceedMessage, {
            maxValue: maxValue,
            endDate: nextOrderEligibleDate
        });
        this._commonService.createNotification('', purchaseLimitExceedMessage, NotificationType.ERROR, 0, Constants.PURCHASE_WINDOW);
    };
    /**
    *
    * @param items
    */
    PosOrderPromotionComponent.prototype.getItemVolumeSum = function (items) {
        return items
            .map(function (x) { return x.taxAmount; })
            .reduce(function (a, b) { return a + b; });
    };
    PosOrderPromotionComponent.prototype.trackByItem = function (index) {
        return index;
    };
    PosOrderPromotionComponent.prototype.validateSubTotalBasedOnType = function (products, subTotal) {
        var isThresholdCrossed = true;
        var itemSubTotal = subTotal;
        var orderMinValue = this.orderRules.minValue;
        var orderMaxValue = this.orderRules.maxValue;
        if (this.isLiteratureValidation(products)) {
            orderMinValue = this.orderRules.literatureMinValue;
            orderMaxValue = this.orderRules.literatureMaxValue;
        }
        if (itemSubTotal >= orderMinValue && itemSubTotal <= orderMaxValue) {
            isThresholdCrossed = false;
        }
        if (itemSubTotal <= orderMinValue) {
            this.isOverrideMinimumLimit === true ? isThresholdCrossed = false : isThresholdCrossed = true;
        }
        return isThresholdCrossed;
    };
    PosOrderPromotionComponent.prototype.isLiteratureValidation = function (products) {
        var literatureItems = this.getLiteratureItems(products);
        var isLiterature = literatureItems && literatureItems.length && products && products.length
            && products.length === literatureItems.length;
        return isLiterature;
    };
    /**
*
* @param items
*/
    PosOrderPromotionComponent.prototype.getItemTotalSum = function (item) {
        return this.calculateSubTotal(this.storeInfo, this.countryTaxInclusive, item, this.memberInfo, true);
    };
    /**
      * Get Total CartItems Cost.
      */
    PosOrderPromotionComponent.prototype.calculateSubTotal = function (store, taxInclusiveShippingCountry, item, userInfo, taxCalculated) {
        var subTotal = 0;
        if (item) {
            var isEnableVATCalculation = this.appConfig && this.appConfig.enableVATCalculation;
            var isCalculateTaxExclusivePrice = this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice;
            if (userInfo && store && store.taxInclusive && isEnableVATCalculation) {
                subTotal += this.calculateSubtotalForVatAndNonVatRegisteredUser(item, store, taxInclusiveShippingCountry, userInfo, taxCalculated);
            }
            else {
                subTotal += this.calculateItemSubtotal(item, store, taxInclusiveShippingCountry, isCalculateTaxExclusivePrice, userInfo);
            }
        }
        if (store) {
            // tslint:disable-next-line:no-bitwise
            subTotal = Number(subTotal.toFixed(Math.max(0, ~~store.numberDecimals)));
        }
        return subTotal;
    };
    /**
     * calculate subtotal for vat and not vat registered user
     * calculateSubtotalForVatAndNonVatRegisteredUser()
     */
    PosOrderPromotionComponent.prototype.calculateSubtotalForVatAndNonVatRegisteredUser = function (item, store, taxInclusiveShippingCountry, userInfo, taxCalculated) {
        if (!item.literature && (taxCalculated || !userInfo.vatRegistered)) {
            if (userInfo.transactionalOptin &&
                userInfo.transactionalWholesaleQualified
                && (userInfo.memberTitleId > MemberLevel.ASSISTANTSUPERVISOR
                    || (userInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
                        && this._commonService.isWHLSAL00enabledForAsstSupervisor(store.homeIsocodeThree)))) {
                var total = Number(item[(userInfo.vatRegistered || !taxInclusiveShippingCountry)
                    ? 'catalogPrice' : 'computedTaxInclusivePrice']);
                return (Math.round((total + Number.EPSILON) * 100) / 100) * item.quantity;
            }
            else {
                return Number(item[(userInfo.vatRegistered || !taxInclusiveShippingCountry)
                    ? 'catalogPrice' : 'applicablePrice'].
                    // tslint:disable-next-line:no-bitwise
                    toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
            }
        }
        else if (taxCalculated && (userInfo.vatRegistered)) {
            return Number(item.catalogPrice.
                // tslint:disable-next-line:no-bitwise
                toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
        }
        else {
            return this.calculateItemSubtotal(item, store, taxInclusiveShippingCountry, null, userInfo);
        }
    };
    /**
    * calculate subtotal
    * calculateItemSubtotal()
    */
    PosOrderPromotionComponent.prototype.calculateItemSubtotal = function (item, store, taxInclusiveShippingCountry, isCalcTaxExclusivePrice, userInfo) {
        if (this.appConfig && this.appConfig.enableVatItemizationForNonVat) {
            var productPrice = 'applicablePrice';
            if (userInfo && (userInfo.vatRegistered || (!userInfo.vatRegistered && userInfo.memberTypeId === MemberTypeId.DISTRIBUTOR))) {
                productPrice = 'catalogPrice';
            }
            return Number(item[productPrice].
                // tslint:disable-next-line:no-bitwise
                toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
        }
        else {
            return Number(item[(taxInclusiveShippingCountry === false || isCalcTaxExclusivePrice) ? 'catalogPrice' : 'applicablePrice'].
                // tslint:disable-next-line:no-bitwise
                toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
        }
    };
    /**
     *
     */
    PosOrderPromotionComponent.prototype.calculateDiscountAmount = function (item, displayPriceConfig) {
        var discountAmount = 0;
        discountAmount = (parseFloat(item.baseRetailPrice.toFixed(2)) * item.quantity) -
            (parseFloat(item.catalogPrice.toFixed(2)) * item.quantity);
        return discountAmount;
    };
    /**
  * Get Total CartItems Cost.
  */
    PosOrderPromotionComponent.prototype.calculateItemsSubTotal = function (store) {
        var itemsSubTotal = 0;
        if (store) {
            var isCalculateTaxExclusivePrice = this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice;
            var isEnableVATCalculation = this.appConfig && this.appConfig.enableVATCalculation;
            for (var i = 0; i < this.products.length; i++) {
                if (this.memberInfo && store.taxInclusive && isEnableVATCalculation) {
                    itemsSubTotal += this.calculateSubtotalForVatAndNonVatRegisteredUser(this.products[i], store, this.countryTaxInclusive, this.memberInfo, true);
                }
                else {
                    itemsSubTotal += this.calculateItemSubtotal(this.products[i], store, this.countryTaxInclusive, isCalculateTaxExclusivePrice, this.memberInfo);
                }
            }
            // tslint:disable-next-line:no-bitwise
            itemsSubTotal = Number(itemsSubTotal.toFixed(Math.max(0, ~~store.numberDecimals)));
        }
        return itemsSubTotal;
    };
    /**
    * @description this method will remove member discount offer for UK FPC second order
    * @memberof OrderSummaryNewComponent
    */
    PosOrderPromotionComponent.prototype.removeMemberDiscountOffer = function (memberId) {
        this._commonService.removeMemberDiscountOffer(memberId)
            .subscribe(function (response) {
        });
    };
    PosOrderPromotionComponent.prototype.calculateNetUnitPrice = function (product) {
        var netUnitPrice = product.computedTaxInclusivePrice / (1 + (product.taxRate / 100));
        return Math.round((netUnitPrice + Number.EPSILON) * 100) / 100;
    };
    Object.defineProperty(PosOrderPromotionComponent.prototype, "cartItems", {
        get: function () {
            return this.posOrderFormGroup.get('items');
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @description will be called on Quanity Change
     * @date 2020-11-02
     * @param {*} event
     * @memberof PosOrderPromotionComponent
     */
    PosOrderPromotionComponent.prototype.onQuantityChange = function (event) {
        this.isQuantityUpdate = true;
    };
    PosOrderPromotionComponent.prototype.clearOutOfStockItems = function () {
        var items = this.posOrderFormGroup.get('items');
        if (this.outOfStockItems && this.outOfStockItems.length) {
            var productIds = this.outOfStockItems.map(function (product) { return product.productItem.id; });
            this.removeOutOfStockItems(items, productIds);
            this.updateTotalsAndShipMethod();
            this.isSubmitted = false;
            this.outOfStockModal.close();
        }
    };
    PosOrderPromotionComponent.prototype.closeOutOfStockForm = function () {
        this.outOfStockModal.close();
        this.isSubmitted = false;
    };
    PosOrderPromotionComponent.prototype.removeOutOfStockItems = function (items, productIds) {
        productIds.forEach(function (id) {
            var productIndex = items.value.findIndex(function (product) { return product.productId === id; });
            if (productIndex > -1) {
                items.removeAt(productIndex);
            }
        });
    };
    PosOrderPromotionComponent.prototype.displayPaymentNote = function (index) {
        var payments = this.externalPaymentForm.controls['payments'];
        var displayNote = false;
        if (payments && payments.controls[index] && payments.controls[index].controls['paymentMethodId']) {
            var paymentMethodId = +payments.controls[index].controls['paymentMethodId'].value;
            if (paymentMethodId &&
                ((paymentMethodId === PosPaymentMethodsEnum.Personal_Check))) {
                displayNote = true;
                payments.controls[index].controls['paymentNote'].setValidators([Validators.maxLength(15)]);
                payments.controls[index].controls['paymentNote'].updateValueAndValidity();
            }
            else {
                displayNote = false;
            }
        }
        return displayNote;
    };
    PosOrderPromotionComponent.prototype.displayPaymentCheckNumber = function (index) {
        var payments = this.externalPaymentForm.controls['payments'];
        var displayCheckNumber = false;
        if (payments && payments.controls[index] && payments.controls[index].controls['paymentMethodId']) {
            var paymentMethodId = +payments.controls[index].controls['paymentMethodId'].value;
            if (paymentMethodId && paymentMethodId === PosPaymentMethodsEnum.Bonus_Check) {
                displayCheckNumber = true;
                payments.controls[index].controls['paymentCheckNumber'].setValidators([Validators.maxLength(15)]);
                payments.controls[index].controls['paymentCheckNumber'].updateValueAndValidity();
            }
            else {
                displayCheckNumber = false;
            }
        }
        return displayCheckNumber;
    };
    PosOrderPromotionComponent.prototype.buildPayByLinkForm = function () {
        this.emailForm = this._formbuilder.group({
            payByLinkEmail: ['', [Validators.required]]
        });
    };
    PosOrderPromotionComponent.prototype.emailCheck = function () {
        if (this.emailForm.controls['payByLinkEmail'].value !== '' && this.emailForm.controls['payByLinkEmail'].valid) {
            this.isPayByLinkValid = true;
        }
        else {
            this.isPayByLinkValid = false;
        }
    };
    /**
     * disabling Enter Payment Detail Button when Product Quantity is updated in CART
     */
    PosOrderPromotionComponent.prototype.disablePaymentDetailButton = function () {
        this.taxCalculationStatus = true;
        this.isEnterPaymentDetailsEnabled = true;
    };
    /**
     * event for OrderBackDate CheckBox change
     */
    PosOrderPromotionComponent.prototype.backDateOrderChange = function (event) {
        this.posOrderFormGroup.controls['backDateOrder'].setValue(event.target.checked);
    };
    PosOrderPromotionComponent.prototype.saveMemberActivityLog = function (memberId, key) {
        var activityLogKeys = [];
        if (key === MemberActivityLogType.Override_Minimum_Limit) {
            activityLogKeys.push({
                key: MemberActivityLogType.Override_Minimum_Limit,
                value: Constants.OVERRIDE_MINIMUM_LIMIT
            });
        }
        this._commonService.saveMemberActivity(memberId, activityLogKeys).subscribe();
    };
    PosOrderPromotionComponent.prototype.getMembergovernmentIdentificationsInfo = function (memberId) {
        var _this = this;
        if (memberId) {
            this._customerService.getMembergovernment_identifications(memberId).subscribe(function (response) {
                if (response) {
                    _this.memberInfo.memberGovernmentIdentifications = response.memberGovernmentIdentificationModel;
                    _this.memberInfo.vatDetailModel = response.vatDetailModel;
                }
            });
        }
    };
    PosOrderPromotionComponent.prototype.savedCardInfo = function (savedcardDetails) {
        this._cacheService.remove(CacheKey.IsRefreshed);
        sessionStorage.removeItem(CacheKey.OrderInfo);
        sessionStorage.removeItem(CacheKey.posOrderPaymentStatus);
        if (savedcardDetails) {
            this.paymentComponentSettings.savedCards.unshift(savedcardDetails);
            this.showNexioPopup.close();
            this.showNexioPayment = false;
            if (this.paymentComponentSettings.savedCards && this.paymentComponentSettings.savedCards.length) {
                var savedCard = this.paymentComponentSettings.savedCards[0];
                if (savedCard && savedCard.id === savedcardDetails.id) {
                    this.posOrderFormGroup.controls['paymentInstrumentId'].setValue(savedCard.id);
                }
                else {
                    this.posOrderFormGroup.controls['paymentInstrumentId'].setValue(this.paymentComponentSettings.savedCards[0].id);
                }
                this.selectedpayvisionCardInfo = savedcardDetails;
            }
        }
    };
    return PosOrderPromotionComponent;
}());
export { PosOrderPromotionComponent };



// WEBPACK FOOTER //
// ./src/app/customerservice/components/pos-orders/pos-order-promotion.component.ts.pre-build-optimizer.js